<template>
  <div style="height:100%">
    <!-- Home slide -->
    <div class="slide bg-home" v-if="this.current == 0 && this.language == 1">
      <div class="home-arrow">
        <a @click="slide(1)">
          <img src="../assets/zimes/2.png" class="animated animated pulse infinite slow" alt>
        </a>
      </div>
      <div class="box">
        <h1 style="text-decoration:none; font-size:35px;">LATVIEŠU NACIONĀLĀ ATMODA</h1>
        <p class="f20">
          Latviešu tautas garīgā atmoda sasaucas ar Eiropas pilsonisko revolūciju un nacionālās atbrīvošanās kustības
          idejām
          <br>19. gadsimta pirmajā pusē. To ietekmē veidojas latviešu tautas kopības apziņa, izglītības un kultūras
          pirmsākumi.
        </p>
      </div>
    </div>

    <!--main menu slide -->
    <div class="slide bg-menu" v-if="this.current == 1 && this.language == 1">
      <div class="layout-1">
        <div style="width:90%; height:90%; margin:auto !important;">
          <!-- menu image -->
          <img src="../assets/zimes/josla-lv.png" style="max-height:100%;float:right;" alt>
          <!-- menu arrows -->
          <!-- menu arrows -->
          <img
            @click="slide(3)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:160px;"
            alt
          >
          <img
            @click="slide(2)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:815px;"
            alt
          >
          <img
            @click="slide(4)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:882px;"
            alt
          >
          <img
            @click="slide(5)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:957px;"
            alt
          >
          <img
            @click="slide(6)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:1050px;"
            alt
          >
          <img
            @click="slide(7)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:1157px;"
            alt
          >
          <img
            @click="slide(8)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:1219px;"
            alt
          >
          <img
            @click="slide(9)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5-v.png"
            style="position:absolute; top:315px;left:1460px;"
            alt
          >

          <img
            @click="slide(10)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:840px;left:1212px;"
            alt
          >
          <img
            @click="slide(11)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:840px;left:1381px;"
            alt
          >
          <img
            @click="slide(12)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:840px;left:1552px;"
            alt
          >
          <img
            @click="slide(13)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:840px;left:1685px;"
            alt
          >
        </div>
      </div>
    </div>

    <!-- Dzimbūšanas atcelšana - Dome -->
    <div class="slide bg-1" v-if="this.current == 2 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>Atmodas ceļš
      </div>
      <div class="layout-1">
        <div class="side">
          <img class="float-right h-100" src="../assets/zimes/skala-1819.png" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            Dzimtbūšanas atcelšana Vidzemē
            <hr style="width:35%">
          </h1>

          <div class="pos-a slide-white" style=" width:400px; height:290px; left:333px; top:141px">
            <p class="text f20 justify p-20">
              1819. gadā Vidzemes guberņā notiek dzimtbūšanas atcelšana, tautā saukta brīvlaišana. Tā pamatojas uz
              Vidzemes landtāgā izstrādātajiem zemnieku likumiem. Ar dzimtbūšanas atcelšanu zemnieki juridiski kļūst par
              personiski brīviem cilvēkiem, taču bez savas zemes un saimniecības, kas paliek muižnieka īpašumā.
            </p>
          </div>
          <div class="pos-a slide-white p-10" style=" width:405px;  left:634px; top:441px;">
            <img src="../assets/bildes/14.png" alt>
          </div>
        </div>
      </div>
    </div>
    <!-- Brāļu draudzes Done / Skala-->
    <div class="slide bg-1" v-if="this.current == 3 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>Atmodas ceļš
      </div>
      <div class="layout-1">
        <div class="side">
          <img class="float-right h-100" src="../assets/zimes/skala-1729.png" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            Brāļu draudzes -
            <br>Latviešu garīgās atmodas pirmsākums
            <hr style="width:36.5%">
          </h1>

          <div class="pos-a slide-white" style=" width:395px; height:931px; left:131px; top:121px">
            <p class="text f20 justify p-20 pb0">
              <img src="../assets/bildes/15.jpg" alt>
            </p>
            <p class="annotation p-10">
              Hernhūtes brāļu simbols un devīze
              <br>“Vicit Agnus Noster, Eum sequamur”
              <br>vēsta par sekošanu dieva jēram,
              <br>kurš upurēts par visu cilvēku grēkiem
              <br>
            </p>
            <p class="text justify f20 p-15">
              Vidzemes brāļu draudzēm (hernhūtiešiem) 18.–19. gadsimtā Vidzemē ir spēcīga ietekme. Draudzes sanāksmes
              ar sarunām un kopīgu dziedāšanu stiprina tautas vienotības apziņu un iedibina pirmās kordziedāšanas
              tradīcijas. Savukārt grāmatu izdošana latviešu valodā, draudzes skolu un skolotāju semināra dibināšana
              veido latviešu inteliģences pamatus. Centīgākie un talantīgākie hernhūtieši kļūst par skolotājiem,
              mācītāju palīgiem, literātiem un mūziķiem. Ar brāļu draudzēm saistīts Vidzemes skolotāju semināra un
              nacionālās kormūzikas tradīciju dibinātājs Jānis Cimze, skolotājs, mācītājs, dziesmu svētku iniciators
              Juris Neikens, nacionālās reālistiskās literatūras pamatlicēji brāļi Kaudzītes un daudzi citi pirmās
              atmodas darbinieki
            </p>
          </div>

          <div class="pos-a slide-white" style=" width:394px; height:auto; left:545px; top:307px">
            <p class="text f20 justify p-20">
              Pēc brāļu draudžu kustības aizlieguma (1743–1817) tās darbība atkal aktivizējas 19. gadsimta pirmajā pusē.
              Veidojas jaunas draudzes, tiek atjaunoti saiešanas nami. Viens no 19. gadsimta pirmās puses Vidzemes
              hernhūtiešu centriem atrodas Trapenē, kur Mikužu saiešanas namā ap 1854. gadu pulcējas vairāk nekā 200
              draudzes locekļi. Brāļu draudžu vadošo lomu latviešu garīgajā izaugsmē 19. gadsimta vidū pārņem hernhūtiešu
              ideju ietekmē radusies jaunlatviešu kustība
            </p>
          </div>

          <div
            class="pos-a slide-white p-20"
            style=" width:394px; height:auto; left:959px; top:542px"
          >
            <img src="../assets/bildes/16L.jpg" alt>
            <p
              class="annotation justify p-10"
            >“Mikuži” – viens no Vidzemes Brāļu draudzes saiešanas (saieta) namiem tagadējā Trapenes pagastā 2017. gadā</p>
          </div>
          <div class="pos-a slide-white" style=" width:394px; height:auto; left:1379px; top:177px">
            <img src="../assets/bildes/17.jpg" class="p-20 pb0" alt>
            <p class="annotation justify p-10">Mikužu saieta nama un sētas plāns</p>
            <p class="text f20 justify p-20">
              Mikužu saieta nams celts Vidzemes lauku sētas stilā 1803. gadā, ēkas pašreizējais veidols saglabājies kopš
              1872. gada pārbūves. No 19. gadsimta otrās puses līdz mūsdienām to izmanto par evaņģēliski luteriskās
              draudzes lūgšanu namu.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Dzimtu veidošanās -->
    <div class="slide bg-dzimtas" v-if="this.current == 4 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>Atmodas ceļš
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1820.png" style="float:right;" class="h-100" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            Izglītoto zemnieku dzimtu veidošanās
            <br>Pēc dzimtbūšanas atcelšanas vidzemē
            <hr style="width:40%">
          </h1>
          <!-- Lesiņu dzimta -->
          <div class="slide-white p-20" style="height:415px;">
            <slick2 :options="slickOptions2">
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:25%">
                    <h1
                      class="m-auto"
                      style="text-decoration:none; text-align:center; font-size:28px; padding:0"
                    >Lesiņu dzimta</h1>
                    <p class="text f20 justify">
                      Viena no 19. gadsimta Siguldas izglītoto zemnieku dzimtām ir Lesiņi, Paltmales (Paltemal, tagad
                      Augšlīgatne) muižas “Lapsu” mājas saimnieki. Saimniecību vada Mārtiņš Lesiņš, viņa jaunākais brālis
                      Pēteris ap 1820. gadu uzsāk mācības pie Siguldas draudzes skolotāja Vordermaņa (Wordermann), lai ar
                      laiku stātos viņa vietā. Vēlāk papildinājis zināšanas Rīgā, Pēteris Lesiņš kļūst par pirmo latviešu
                      tautības skolotāju Siguldas draudzē. Viņa skolotāja un dzīves gaitas rit vācu kultūras iespaidā.
                      Nav ziņu, ka skolotājs Pēteris Lesiņš būtu iesaistījies latviešu tautas atmodas kustībā 19.
                      gadsimta pirmajā pusē.
                    </p>
                  </div>
                  <div style="width:15%;">
                    <img src="../assets/bildes/BILDE3.jpg" alt>
                    <p
                      class="annotation"
                    >Lesiņu dzimtas māju “Lapsas” atrašanās vietā kartē 2017. gadā</p>
                  </div>
                  <div style="width:25%">
                    <p class="text f20 justify">
                      Izšķirošs laiks Lesiņu dzimtai ir 1837. gads, kad “Lapsu” saimnieks Mārtiņš Lesiņš kopā ar dēla
                      Jāņa ģimeni pārceļas uz Nītauri, kur neilgi pēc tam miruši. Savukārt, Mārtiņa Lesiņa trešais dēls
                      Dāvis ar ģimeni dodas uz Sērmūkšiem un pēc gada – uz Viļķenes privātmuižu. “Lapsās” paliek tikai
                      skolotāja Pētera Lesiņa ģimene, taču par saimnieku ieceļ Mārtiņu Cīruli no “Kazkāju” mājām.
                      <br>
                      <br>Kāpēc notiek saimnieka maiņa, nav zināms. Pēc dēla Kārļa Reinholda traģiskās bojā ejas 1848. gadā,
                      Pētera Lesiņa skolotāja darbība Siguldas draudzē pārtrūkst. Viņa dēlu Magnusa Eduarda un Ernesta
                      Johana gaitas šobrīd nav zināmas.
                    </p>
                  </div>
                  <div style="width:25%">
                    <p class="text f20 justify">
                      Savukārt Dāvja Lesiņa dzimta sakuplojusi Vilķenes privātmuižas Strobu mājās, kur viņš 1839. gadā
                      minēts kā saimnieks. Starp viņa ģimenes atvasēm ir tādi pazīstami 20. gadsimta rakstnieki kā Valdis
                      (Voldemārs) Lesiņš (1881–1932) un viņa dēls Knuts Lesiņš (1909–2000), skolotājs Hugo Lesiņš,
                      bioloģe Dace Gertnere (dzimusi Lesiņa) un citi kultūras un sabiedriskie darbinieki.
                    </p>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png">
                    </div>
                  </div>
                </div>
              </a>
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:5%;">
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png">
                    </div>
                  </div>
                  <div style="width:30%">
                    <img src="../assets/bildes/20.jpg" style="width:90%" class="m-auto" alt>
                    <p class="annotation m-auto" style="width:80%">
                      Kopija no Siguldas draudzes Paltmales (Paltemal) privātmuižas 1826. gada revīziju saraksta par
                      Lapsu māju saimnieka Mārtiņa Lesiņa dēla Pētera Lesiņa atbrīvošanu no muižas nodevām sakarā ar
                      pārcelšanu par Siguldas draudzes skolotāju
                    </p>

                    <p class="text f20 justify">
                      Lapsu māju saimnieka dēls Pēteris Lesiņš (ap 1803.–?) ir pirmais latviešu tautības skolotājs
                      Siguldā. Strādājis par Siguldas draudzes (Kirspiel) skolas skolotāju (1824–1829) un Siguldas
                      draudzes skolas (Parochialschule) skolotāju un ērģelnieku (1829–1847)
                    </p>
                  </div>
                  <div style="width:30%;">
                    <div style="width:100%" class="m-auto">
                      <img src="../assets/bildes/21.jpg" style="width:90%" class="m-auto" alt>
                      <p
                        class="annotation"
                        style="padding:0"
                      >Siguldas pamatskolas ēka Līvkalna un Miera ielas stūrī 20. gadsimta 20. gadu beigās</p>
                    </div>
                    <p class="text f14 justify">
                      Ziņas par draudzes skolu Siguldā ir jau no 1685. gada. 19. gadsimtā tā atradusies vienstāva ēkā,
                      kuras vietā 1928. gadā tiek uzbūvēta jauna mūra celtne Siguldas sešklasīgās pamatskolas vajadzībām.
                    </p>
                  </div>
                  <div style="width:25%">
                    <div class="m-auto" style="width:90%">
                      <img src="../assets/bildes/22.jpg" alt>
                      <p class="annotation">
                        Dāvja Lesiņa dzīvesvietā Viļķenes “Strobos” tagad saimnieko viņa mazdēls Hugo Lesiņš, pensionēts
                        advokāts
                      </p>
                    </div>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png">
                    </div>
                  </div>
                </div>
              </a>
              <a>
                <div style="display:flex;justify-content:space-around;width:80%;">
                  <div style="width:5%;">
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png">
                    </div>
                  </div>
                  <div style="width:17%">
                    <div style="width:90%" class="m-auto">
                      <img src="../assets/bildes/26.jpg" alt>
                      <p class="annotation">
                        Rakstnieks Valdis (Voldemārs) Lesiņš (1881–1932). Portrets no izdevuma
                        <b></b>
                        ”Latviešu rakstniecība biogrāfijās”, Rīga, 1992
                      </p>
                    </div>
                  </div>
                  <div style="width:35%;">
                    <p class="text f18 justify">
                      Dzimis Viļķenē, izglītojies Limbažu pilsētas skolā (1897), Gori-Gorku mērnieku un taksatoru skolā
                      Smoļenskas guberņā (1900). Darba gaitās devies uz Volīniju, Pēterburgu, Harkovas apgabalu, Sibīriju
                      (1901–14) un citām Krievijas impērijas vietām. Pirmā Pasaules kara laikā (1914–17) Valdis Lesiņš ir
                      Krievijas armijas artilērijas virsnieks. Nākot pie varas boļševikiem 1917. gadā, demobilizējies un
                      vairākus gadus dzīvojis Ukrainā, Kaukāzā, Krimā, Sevastopolē, Konstantinopolē, Sofijā, Vīnē,
                      Berlīnē un Ščecinā. Ap 1921. gadu Valdis Lesiņš ar ģimeni atgriežas dzimtenē, kur jaundibinātajā
                      Latvijas valstī strādā Zemkopības ministrijā par sevišķu uzdevumu ierēdni (1921–22 un 1930–32), kā
                      arī Valmieras apriņķa valsts zemju inspektoru (1922–30). Pa vaļas brīžiem atrod laiku arī
                      rakstniecībai. Literāts Jānis Grīns atceras Valdi Lesiņu kā dēkainu dzīves baudītāju un lepnu
                      romantiķi, kura literāro darbu varoņi ir stipri līdzīgi autoram un sarunās “bārstās ar paradoksiem
                      un aforismiem”. Valda Lesiņa vienīgais dēls Knuts Lesiņš (1909–2000), kura dzīves pēdējais posms
                      paiet emigrācijā ASV, arī pazīstams kā publicists, rakstnieks un komponists.
                    </p>
                  </div>
                  <div style="width:30%">
                    <img src="../assets/bildes/27.jpg" alt>
                    <p class="annotation">
                      Skaņuplates vāka noformējums ierakstam ar Knuta Lesiņa dziesmām dzīvesbiedres Valdas Lesiņas
                      izpildījumā
                    </p>
                  </div>
                  <div style="width:1%;">
                    <div class="hor-prev"></div>
                  </div>
                </div>
              </a>
            </slick2>
          </div>
          <br>
          <!-- Krogzemju dzimta -->
          <div class="slide-white p-20" style="height:415px;">
            <slick2 :options="slickOptions2">
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:37%">
                    <h1
                      class="m-auto"
                      style="text-decoration:none; text-align:center; font-size:28px; padding:0"
                    >KROGZEMJU DZIMTA</h1>
                    <p class="text f19 justify">
                      Pēc Valmieras apriņķa Alojas draudzes Stakenbergu/Stābegu (Eichenangern) privātmuižas dvēseļu
                      revīzijas ziņām Krogzemju dzimtas senči ap 1795. gadu pieder pie muižas dzirnavnieka saimes. Drīz
                      pēc tam viņi pārcelti uz “Krogvietu” par saimniekiem, no kā arī cēlies uzvārds “Krogzemis”. Ap
                      1834. gadu Jēkabs un Anna Krogzemji jau saimnieko Stakenbergu muižas Slakteru mājās, bet 19.
                      gadsimtā vidū – vada Ungurpils (tagad Alojas) pagasta Sīpolu māju saimniecību. Laikabiedri viņus
                      raksturo kā čaklus un dievbijīgus zemniekus. “Svētdienās abi cēlās trijos četros no rīta, lai
                      paspētu uz brāļu draudzes saieta namu, pusdienās gāja baznīcā, bet pievakarē – mājās ar sajūsmu
                      dziedāja vienu dziesmu pēc otras, asaras slaucīdami”. Jēkabs pēc dabas bijis kluss un skarbs vīrs,
                      turpretī Anna, kaut arī domīga sapņotāja – runātīgāka un inteliģentāka par vīru. Viņa centusies
                      izskolot savus bērnus, iemācīt pirmās lasīšanas un rēķināšanas iemaņas. Pēc draudzes skolas
                      beigšanas Krogzemji vecāko dēlu Mārtiņu sūta uz Cimzes skolotāju semināru Valkā. Arī jaunākajam
                      dēlam Miķelim “prāts nenesas uz lauku darbiem”, tāpēc vecāki nolemj laist viņu mācīties par
                      “skolmeistaru”
                    </p>
                  </div>
                  <div style="width:30%;">
                    <img src="../assets/bildes/19.jpg" alt>
                    <p class="annotation p-10">
                      Krogzemju dzīvesvieta – Alojas Krogzemju (Krogzemnieku) ūdensdzirnavas 19./20. gadsimta mijā. Tās
                      vairākkārt degušas, līdz mūsdienām saglabājušies tikai akmens mūra sienu, aizsprosta un dzirnakmeņu
                      fragmenti
                    </p>
                  </div>
                  <div style="width:25%">
                    <p class="text f20 justify">
                      Pēc skolotāju semināra beigšanas abi brāļi strādā par skolotājiem, darbojas publicistikā un aktīvi
                      iesaistās Vidzemes, vēlāk – Krievijas latviešu sabiedriskajā dzīvē. Jaunākais brālis Miķelis, kurš
                      pazīstams kā dzejnieks Auseklis, kļūst par vienu no latviešu romantiskās dzejas pamatlicējiem un
                      atmodas ideju paudējiem. Vairākas viņa dzejas rindas, kas atspoguļo jaunlatviešu idejas, mūsdienās
                      ieguvušas simbolisku nozīmi un folklorizējušās
                      <br>
                      <br>Pēc vecāku nāves “Sīpolu” saimniecību vada Ausekļa trešais brālis Andrejs Krogzemis. Viņš, tāpat kā
                      visi Krogzemji, pēc izskata esot “lībisks, strādīgs un taupīgs, izpircis tēva mājas. Viņa dēls
                      Pēteris Krogzemis izmācījies par agronomu, saimniekojis “Sīpolos” līdz 1940. gadam
                    </p>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png">
                    </div>
                  </div>
                </div>
              </a>
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:5%;">
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png">
                    </div>
                  </div>
                  <div style="width:28.333%" class="p-10 pt0 pb0">
                    <img
                      src="../assets/bildes/23.jpg"
                      style="height:320px; width:auto"
                      class="m-auto"
                      alt
                    >
                    <p
                      class="annotation"
                    >Dzejnieka Ausekļa (Miķeļa Krogzemja) dzimtās mājas “Sīpoli” 1935. gadā</p>
                  </div>
                  <div style="width:28.333%" class="p-10 pt0 pb0">
                    <img
                      src="../assets/bildes/3.png"
                      class="m-auto"
                      style="height:320px; width:auto"
                      alt
                    >
                    <p class="annotation">
                      Jāņa Cimzes vadītā Valkas Skolotāju semināra audzēkņu 10. kurss. 1868.–1871. gads. 2. rindā 5. no
                      kreisās – Auseklis (Miķelis Krogzemis). Fotogrāfs nezināms. RMM
                    </p>
                  </div>
                  <div style="width:28.333%" class="p-10 pt0 pb0">
                    <img
                      src="../assets/bildes/25.jpg"
                      style="height:320px; width:auto"
                      class="m-auto"
                      alt
                    >
                    <p
                      class="annotation p-10"
                    >Dzejnieka Ausekļa portrets viņa Pēterburgā izdotajā darbu izlasē “Izlasīti raksti”</p>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png">
                    </div>
                  </div>
                </div>
              </a>
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:5%;">
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png">
                    </div>
                  </div>
                  <div style="width:12%">
                    <img
                      src="../assets/bildes/28.png"
                      class="m-auto"
                      style="height:320px; width:auto"
                      alt
                    >
                    <p class="annotation p-10 pt0">Ausekļa piemineklis Alojā</p>
                  </div>
                  <div style="width:25%">
                    <p class="text f18 justify">
                      Auseklis (Miķelis Krogzemis, 1850–1879) Ungurpils (tagad Alojas) pagasta Sīpolu māju saimnieka
                      dēls, mācījies Cimzes skolotāju seminārā (1868–1871). Pēc tā beigšanas, līdztekus skolotāja darbam,
                      darbojas publicistikā, ar pseidonīmu Auseklis raksta dzeju. Savos darbos kritizē vācu muižniecību
                      un mācītājus, ceļ godā latviešu valodu, folkloru un tradīcijas. Strādājot Lielvārdes draudzes
                      skolā, piedalās tautasdziesmu vākšanā, pirmajos Vispārīgajos latviešu dziesmu svētkos, iestudē
                      teātra izrādi. Par to mācītājs Krons Ausekli atlaiž no darba: “Miķeli Krogzemi es varbūt pieciestu,
                      bet rīmnieks Auseklis, kam tāda kāre tejāterus rīkot, man un manai Lielvārdei ir par negodu un
                      aplamu piedauzību.” Nevarēdams atrast darbu dzimtenē, 1874. gadā Auseklis pārceļas uz Pēterburgu,
                      kur 1879. gadā pāragri mirst 29 gadu vecumā. Viņa mirstīgo atlieku pārvešana uz dzimteni izvēršas
                      par grandiozu tautas manifestāciju, jo viņa darbi tautā ir zināmi un iemīļoti.
                    </p>
                  </div>
                  <div style="width:8%">
                    <img src="../assets/bildes/29.jpg" alt>
                    <img src="../assets/bildes/30.jpg" alt style="margin-top:3px !important">
                  </div>
                  <div style="width:40%">
                    <p class="text justify f18">
                      Ausekļa biogrāfs Jānis Lapiņš 20. gadsimta 20. gados raksta: „Viņa dzeja ir viena liela doma par
                      latviešu nacionālo atmodu.citādi bezbēdīgi jautrais Krogzems, par savas tautas likteni domājot, ir
                      drūms un svinīgs.“ Ausekļa darbos „Latvijā“,„Tālavas taurētājs“, „Beverīnas dziedātājs“ un citos
                      strāvo patriotisma un brīvības gars. Savukārt viņa sarakstītā „Gaismas pils“ kļuvusi parvienu no
                      latviešu tautas atmodas simboliem.
                    </p>
                    <p
                      class="annotation pt0 mt0 pb0 mb0"
                    >Ausekļa dzejolis „Latvijā“ Līgotņu Jēkaba grāmata „Auseklis“. Rīga, 1927</p>
                    <div class="dzejolis" style="line-height:1.2">
                      <h1>Latvijā</h1>

                      <div style="display:inline-block; width:50%;" class="f18">
                        Latvijas kalnājos, Latvijas lejās
                        <br>Krūtīs man atdzīvo brīvības gars;
                        <br>Raugu tur vīrus kā ozolus zeļam,
                        <br>Meitas kā liepas kuplojam.
                        <br>
                        <br>
                      </div>
                      <div style="display:inline-block; width:50%" class="f18">
                        Daugavas māmuļa, mīlīga jauka,
                        <br>Sirsnīgi glaužas pie Latvijas krūts;
                        <br>Dedzīgi viņa caur klintaini laužas,
                        <br>Tautiešu censībās modrina.
                        <br>
                        <br>
                      </div>
                      <div style="display:inline-block; width:50%" class="f18">
                        Dzirdu še burtnieku sirmajās dziesmas,
                        <br>Dievkoku paēnās audzētas.
                        <br>Krūtis tās pilda ar debesu jūsmām,
                        <br>Garu līdz dievībai pacilā
                        <br>
                        <br>
                      </div>
                      <div style="display:inline-block; width:50%" class="f18">
                        Līga man apveltī dziesmotiem pušķiem,
                        <br>Sēdina ozolu krēsliņā,
                        <br>Trimpus man mielo ar putošu alu,
                        <br>Ūziņš ar Dravdāvas dzērienu.
                        <br>
                        <br>
                      </div>
                    </div>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png">
                    </div>
                  </div>
                </div>
              </a>
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:5%;">
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png">
                    </div>
                  </div>
                  <div style="width:35%">
                    <div class="dzejolis">
                      <h1>JŪRA</h1>
                      <div style="margin-left:100px !important; position:relative">
                        <img
                          style="position:absolute;top:-5px;left:-30px;"
                          src="../assets/zimes/citats-before.png"
                        >
                        Darbs ir latvju krietnais tikums,
                        <br>Pamats katrai svētībai;
                      </div>

                      <div style="margin-left:300px !important; position:relative">
                        Darbs ir viņu lepnais likums,
                        <br>Pamats dārgai brīvībai.
                        <img
                          src="../assets/zimes/citats-after.png"
                          style="position:absolute;bottom:-10px;right:70px;"
                        >
                      </div>

                      <h1>DZIESMU MĀMUĻA</h1>

                      <div style="margin-left:100px !important; position:relative">
                        <img
                          style="position:absolute;top:-5px;left:-30px;"
                          src="../assets/zimes/citats-before.png"
                        >
                        Dar man, tēvis, pastaliņas,
                        <br>Pirc man staltu cepurīt
                      </div>

                      <div style="margin-left:300px !important; position:relative">
                        Šuv man svārkus māmuliņa
                        <br>Skolā ieti man gribas!
                        <img
                          src="../assets/zimes/citats-after.png"
                          style="position:absolute;bottom:-10px;right:70px;"
                        >
                      </div>
                    </div>
                    <div style="border-top:3px solid #000; width:40%; margin-top:30px !important">
                      <p class="annotation tal">Fragmenti no Ausekļa dzejas</p>
                    </div>
                  </div>
                  <div style="width:30%">
                    <img src="../assets/bildes/33.jpg" alt>
                    <p class="annotation p-10">
                      Alojas II pakāpes pamatskolas audzēkņi “Sīpolos” 20. gadsimta 20. gadu sākumā. Vidū Ausekļa brālis
                      skolotājs Mārtiņš Krogzemis. Otrajā rindā pirmais no kreisās puses viņa brāļa dēls Pēteris
                      Krogzemis
                    </p>
                  </div>
                  <div style="width:22%">
                    <p class="text f20 justify">
                      Mārtiņš Krogzemis (1841–1929) Ungurpils (Alojas) pagasta Sīpolu māju saimnieka dēls, dzejnieka
                      Ausekļa vecākais brālis. Cimzes seminārā izmācījies par skolotāju (1859–1862), Mārtiņš Krogzemis
                      strādāja par palīgskolotāju Zeltiņu draudzes skolā Valkas apriņķī, vēlāk par mājskolotāju Brentes
                      muižā un kopš 1868. gada darba gaitas turpināja Krievijā Voroņežā (1868–1877) un Sankt-Pēterburgā
                      (1880–?), kur iesaistījās latviešu inteliģences sabiedriskajā dzīvē un darbojās latviešu lasāmajā
                      biedrībā. Viņš rakstīja dzeju, bija korespondents vācu laikrakstā St. Petersburg Herold. Mārtiņa
                      Krogzemja publicistika vainagojās ar grāmatu
                      <i>“Zur Fragen zur Ethischen Erziehung in der Schule”</i>
                      (1914).
                    </p>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next"></div>
                  </div>
                </div>
              </a>
            </slick2>
          </div>
        </div>
      </div>
    </div>
    <!--Tautas tradīcijas -->
    <div class="slide bg-1" v-if="this.current == 5 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>Atmodas ceļš
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1863.png" style="float:right;" class="h-100" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            Tautai kopīgu tradīcīju veidošanās
            <hr style="width:38.5%">
          </h1>
          <div class="col-4">
            <div class="col-outer">
              <h2>Kora dziedāšana</h2>
              <div class="col-bg">
                <slick151 :options="slickOptions1" ref="slick">
                  <a>
                    <div class="slide">
                      <img src="../assets/bildes/34.jpg" style="width:90%" class="m-auto" alt>
                      <p class="annotation p-10">
                        Dikļu vīru koris, dibināts 1864. gadā, diriģents Heinrihs (Indriķis) Šmits. Attēls no pirmajiem
                        vispārējiem latviešu dziesmu svētkiem 1873. gadā Rīgā
                      </p>
                      <p class="text f18">
                        Kora dziedāšanu latviešu vidē, it īpaši Vidzemē, veicina Brāļu draudžu saieti ar kopīgu
                        dziedāšanu. Tur dzimst pirmās latviešu koru tradīcijas, kuras 19. gadsimtā iesakņojas un izplatās
                        visā Latvijas teritorijā. Vidzemes brāļu draudžu pētnieks vēsturnieks Gvido Straube raksta:
                      </p>
                      <p class="citats f18">
                        1742./1743.gada Vidzemes baznīcu vizitācija nonāca pie atzinuma, ka zemnieku dziedāt prasme
                        strauji uzlabojusies un viņi dievkalpojuma laikā nevis bļauj, kā to 17. gs. bija konstatējis savā
                        sprediķu grāmatā Georgs Mancelis, bet dzied meldiņā, turklāt spējot pat sagatavot daudzbalsīgus
                        dziedājumus. Arī viens no latviešu mūzikas pionieriem Jānis Cimze ir cieši saistīts ar šo
                        kustību, līdzīgi kā Georgs jeb Juris Neikens, kurš lika Dikļos pamatus latviešu kordziedāšanas
                        fenomenam, kuru šodien apbrīno visā pasaulē.
                      </p>
                      <div class="bottom-arrow">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>

                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <div style="display:block">
                        <img style="width:90%" class="m-auto" src="../assets/bildes/38-39.png" alt>
                      </div>

                      <div style="display:inline-block;width:50%; vertical-align:top">
                        <p
                          class="annotation p-10"
                        >Jānis Cimze (1814–1881) mūziķis, pedagogs, Vidzemes draudžu skolu skolotāju semināra vadītājs.</p>
                      </div>
                      <div style="display:inline-block;width:50%; vertical-align:top">
                        <p class="annotation p-10">
                          Pirmais 1872. gadā Leipcigā izdotais Jāņa Cimzes „Dziesmu rotas” sējums. Tajā iekļautas latviešu
                          tautas dziesmu apdares koriem
                        </p>
                      </div>

                      <p class="text f18">
                        Jānis Cimze māca audzēkņiem latviešu un vācu valodu, kora vadību, ērģeļu, klavieru un vijoles
                        spēli. Semināra otrā kursa audzēknis K. Rinkužs atmiņās raksta, ka 1843. gadā tiek nodibināts
                        koris un tā dalībnieki "… sava audzinātāja uzmundrināti, pa vasaras brīvlaiku apceļojuši Latviju.
                        Būdami mūzikā un dziedāšanā izglītoti, viņi savām četrbalsīgām garīgām un laicīgām dziesmām tai
                        laikā pārsteidza visus klausītājus, kur vien uzstājās. Šie audzēkņi bijuši kā pirmās bezdelīgas
                        Latvijā, kas vēstījušas, ka līdz ar semināru latviešu tautai atnācis dziesmots pavasaris“ Jānis
                        Cimze darbojies arī kā komponists, Viņa veikums ir ap 350 latviešu tautasdziesmu apdares, t.sk.
                        "Rīga dimd",
                      </p>
                      <div class="bottom-arrow" style="margin-top:7px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <div style="width:65%;" class="m-auto">
                        <img src="../assets/bildes/43.jpg" style="width:90%" class="m-auto" alt>
                        <p
                          class="annotation"
                        >Juris Neikens (1826–1868), Dikļu mācītājs, skolotājs un rakstnieks</p>
                      </div>
                      <p class="text f18">
                        Juris Neikens ir pirmās latviešu dziesmu dienas iniciators un organizētājs. 1864. gada trešajos
                        Vasarsvētkos viņš Dikļos (tagad Kocēnu novadā) sapulcina sešus vīru korus no Limbažiem, Rūjienas,
                        Mazsalacas, Lielsalacas, Straupes un Dikļiem uz kopīgu dziedāšanu. Vēlāk Juris Neikens atceras:
                      </p>
                      <p class="citats">
                        Svētku rīta saulīte mirdzēja caur plāniem, gaišiem padebešiem, un putnu balsis atskanēja siltā,
                        klusā gaisā. Ap pulksten astoņiem jau viesi sāka rasties, visvairāk tālnieki, kas nebija zinājuši
                        noteiktu stundu, kad dziesmas sāksies. Tie nāca arvien biezāki kājām un braukšus, līdz pēdīgi
                        bija lasījies tāds ļaužu pulks, kā reti te būs redzēts.
                      </p>
                      <p class="text">
                        Dziesmu diena Dikļos veicina pirmo vispārējo latviešu dziesmu svētku organizēšanu 1873. gadā
                        Rīgā.
                      </p>
                      <div class="bottom-arrow"></div>
                    </div>
                  </a>
                </slick151>
              </div>
            </div>
            <div class="col-outer">
              <h2>
                Pirmie kori
                <br>Turaidas apkārtnē
              </h2>
              <div class="col-bg">
                <slick152 :options="slickOptions1">
                  <a>
                    <div style="position:relative">
                      <img src="../assets/bildes/35.jpg" alt>
                      <p class="annotation p-10">
                        Lēdurgā pie Maiņkalna (bij. tirgus vieta) iepretī baznīckrogam, kurā 19. gadsimta otrajā pusē
                        notiek Merķeļa dziedāšanas biedrības sapulces un mēģinājumi
                      </p>
                      <p class="text f18 justify">
                        Senākie kori Turaidas apkārtnē dibināti Straupē 1864. gadā un Lēdurgā 1871. gadā. Straupes vīru
                        kora diriģents ir vietējās draudzes skolas skolotājs Dionīsijs Garklāvs. Lēdurgas jeb Merķeļa
                        dziedāšanas biedrības vīru kori vada diriģents Antons Baltgailis (1846-1887). Viņš ir Valkas
                        skolotāju semināra absolvents, no 1870. līdz 1882. gadam strādā par Lēdurgas draudzes skolotāju
                        un ērģelnieku. Lēdurgas Merķeļa biedrībā sākotnēji iesaistās 22 vīri, no tiem vairāki skolotāji.
                        Septiņi tā saucamie “klusie” biedri korī nedzied, bet ir biedrības un kora atbalstītāji. Straupes
                        un Lēdurgas vīru kori piedalās pirmajos vispārējos latviešu dziesmu svētkos 1873. gadā Rīgā. Abi
                        kori piesaka dalību arī skatē jeb tā sauktajos Dziesmu karos, turklāt Straupes koris izcīna
                        balvu.
                      </p>
                      <div class="bottom-arrow" style="margin-top:39px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <div>
                        <img
                          style="display:inline-block; width:50%"
                          src="../assets/bildes/40.jpg"
                          alt
                        >
                        <p
                          style="display:inline-block; width:45%; vertical-align:bottom;"
                          class="annotation pal"
                        >Pēteris Bērziņš (1848–1926), pirmais Siguldas pagasta kora diriģents</p>
                      </div>
                      <p class="text f18">
                        Siguldā pirmo kori nodibināja pie draudzes skolas 1872. gadā. Septiņus gadus vēlāk 1879. gadā
                        tika izveidots Siguldas pagasta jeb Līgates koris, kurā skolotāja Pētera Bērziņa vadībā dziedāja
                        vienpadsmit vīri.
                        <br>Pēteris Bērziņš mācījies Raunas un Smiltenes skolās, pašmācībā sagatavojies un 1869. gadā ieguvis
                        skolotāja tiesības, atbalstījis jaunlatviešu idejas un vēlāk iesaistījies jaunstrāvnieku kustībā.
                        No 1871. līdz 1875. gadam strādājis Trikātā Tiepeles skolā un Raunas draudzes skolā, tad līdz
                        1882. gadam – Līgatnes papīrfabrikas skolā (dibināta 1858). No tās ticis atlaists un apcietināts
                        par to, ka dziedājis dziesmu ar sagrozītiem vārdiem: ”…Kaut man būtu tā naudiņa, Kas guļ jūras
                        dibenā,— Es nopirktu Rīgas pili, Ar visiem tītariem…”. No Līgatnes Pēteris Bērziņš pārcēlās uz
                        Rīgu, kur strādāja Pavasara biedrībā par
                      </p>
                      <div class="bottom-arrow" style="margin-top:22px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <p class="text f18">
                        skolotāju un rakstvedi un īsu brīdi bija laikraksta „Dienas Lapa” līdzstrādnieks. No 1885. gada
                        viņš darbojās grāmatu tirdzniecības un izdošanas jomā. Viena no nozīmīgākajām Pētera Bērziņa
                        mācību grāmatām ir Līgatnē sagatavotā „Lasīšanas grāmatu skolas bērniem”, kas kopš 1881. gada
                        piedzīvoja 12 izdevumus. Rakstījis arī prozu un dzeju (“Dziesmu vīte jaunībai un jaunības
                        mīlestībai” (1876) u.c. darbi).
                      </p>
                      <img src="../assets/bildes/44.jpg" class="p-10" alt>
                      <p class="text f18">
                        Gatavojoties latviešu otrajiem vispārīgajiem dziedāšanas svētkiem Rīgā 1880. gadā, koris tika
                        nodibināts arī Turaidas pagastā. Tā diriģents bija Turaidas skolas skolotājs Tenis Nolle
                        (1832-1913). Viņš ienācis Turaidā no Rūjienas draudzes Ternejas pagasta, kur strādāja par
                        skolotāju kopā ar pazīstamo Rūjienas ērģelnieku, kordiriģentu un vienu no Dikļu Dziesmu svētku
                        (1864) organizatoriem Ernestu Aleksandru Švehu (Ernst Alexander Schwech, 1819–1898). Otrajos
                        vispārīgajos latviešu dziedāšanas svētkos Rīgā 1880. gadā E. A. Švehs vadīja godalgoto Rūjienas
                        kori, T. Nolle – Turaidas kori.
                      </p>
                      <div class="bottom-arrow" style="margin-top:18px !important"></div>
                    </div>
                  </a>
                </slick152>
              </div>
            </div>
            <div class="col-outer">
              <h2>Latviešu biedrības</h2>
              <div class="col-bg">
                <slick153 :options="slickOptions1">
                  <a>
                    <div>
                      <p class="citats pb0">
                        Pēc dzimtbūšanas atcelšanas un latviešu zemnieku brīvlaišanas 19. gadsimta pirmajā pusē
                        paplašinājās esošās un dibinājās jaunas skolas. Auga to audzēkņu skaits un latviešu izglītības
                        līmenis. Tam līdzi nāca augoša interese par latviešu vēsturi, kultūras un sabiedrisko darbību.
                        Lai apmierinātu cilvēku kāpjošās intereses un vajadzības, dibinājās un aktīvi strādāja dažādas
                        biedrības, it īpaši dziedāšanas, krājaizdevu, lauksaimniecības un uguns apdrošināšanas biedrības.
                        Tās organizēja bibliotēkas, izstādes, jautājumu un atbilžu vakarus, koncertus, priekšlasījumus un
                        citus pasākumus. Līdz ar biedrībām un skolām auga latviešu izglītības, kultūras un sabiedriskā
                        darba aktīvisti, no kuriem ievērojama daļa grupējās ap Rīgas Latviešu biedrību un tās atzariem
                        citās pilsētās.
                      </p>
                      <p class="annotation tar" style="width:70%;float:right">
                        No Saulveža Cimermaņa publikācijas “Rīgas Latviešu biedrība un latviešu etnogrāfija”.
                        <br>Latvijas Vēstnesis, 1999, Nr. 173
                      </p>
                      <div style="clear:both"></div>
                      <div style="margin-top:20px !important">
                        <img src="../assets/bildes/36.jpg" class="m-auto" style="width:65%" alt>
                        <p class="annotation">Rīgas Latviešu biedrības logo</p>
                      </div>
                      <div class="bottom-arrow" style="margin-top:12px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <p class="text f20 justify">
                        Pirmo Rīgas Latviešu biedrības namu uzcēla 1869. gadā pēc Jāņa Fridriha Baumaņa projekta. 1908.
                        gadā šī ēka pilnīgi nodega. Līdz mūsdienām saglabājies pēc Eižena Laubes un Ernesta Poles
                        projekta celtais biedrības nams, kuru iesvētīja 1909. gadā.
                      </p>
                      <img src="../assets/bildes/41.jpg" class="m-auto" alt>
                      <p
                        class="annotation"
                      >Pirmais Latviešu biedrības nams pēc 1885. gada litogrāfijas</p>
                      <p class="text f20 justify">
                        Vidzemē 19. gadsimta 60.-70. gados tiek dibinātas biedrības, pie kurām izglītotie latvieši
                        organizē kora dziedāšanu. Sākumā tiek dibināti vīru, vēlāk – arī jauktie kori. Viena no pirmajām
                        dziedāšanas (vēlāk: Labdarības) biedrībām 1869. gadā nodibināta Vecpiebalgā.
                      </p>
                      <div class="bottom-arrow" style="margin-top:10px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <img src="../assets/bildes/45.jpg" class="m-auto" alt>
                      <p class="annotation p-10">
                        Vecpiebalgas Labdarības (iepriekš: Dziedāšanas) biedrības koris pirmajos vispārējos latviešu
                        dziesmu svētkos 1873. gadā
                      </p>
                      <img src="../assets/bildes/46.jpg" class="m-auto" alt>
                      <p class="annotation p-10">
                        Siguldas labdarības biedrības sanākšanas vieta Jelgavkrogs jeb Baznīcas krogs 19./20. gadsimta
                        mijā
                      </p>
                      <div class="bottom-arrow" style="margin-top:18px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>

                      <p class="text f20">
                        Pirmās latviešu sabiedriskās biedrības Turaidas apkārtnē dibinātas 19. gadsimta beigās. Biedrības
                        organizē kora dziedāšanu, teātru iestudēšanu un dažādus kultūras pasākumus. Aktivitāšu norisēm
                        izbūvē jaunas vai pielāgo jau esošās ēkas. Siguldas labdarības biedrība dibināta 1880. gadā.
                        Laikrakstā “Siguldas Ziņas” 1930. gadā, atskatoties uz biedrības 50. gadu darbību, rakstīts:
                      </p>
                      <p class="citats f20">
                        No sākuma izrīkojumus sarīkojuši Siguldas ūdens dzirnavās un uz Jelgavas kroga stadulas augšas.
                        Rīkoti apm. 2 - 3 izrīkojumi gadā, tātad uz katriem augstiem svētkiem pa vienam. Ziemas svētkos
                        un Lieldienās rīkotas teātra izrādes ar saviesīgu dzīvi, bet vasarās - zaļumballes ar dziesmām.
                        Pie b-bas kopš pašas dibināšanas pastāvējis arī jauktais koris, kurš piedalījies jau II Dziesmu
                        svētkos. Par diriģentiem min skolotājus Cilinbergu, Zānu, Miesiņu, Lindi u.c.
                      </p>
                      <div class="bottom-arrow" style="margin-top:243px !important"></div>
                    </div>
                  </a>
                </slick153>
              </div>
            </div>
            <div class="col-outer">
              <h2>Teātra spēlēšana</h2>
              <div class="col-bg">
                <slick154 :options="slickOptions1">
                  <a>
                    <div>
                      <div style="width:85%" class="m-auto">
                        <img src="../assets/bildes/37.jpg" alt>
                        <p
                          class="annotation"
                        >Afiša pirmajai latviešu teātra izrādei “Žūpu Bērtulis” Rīgā. 1868. Eduarda Smiļģa Teātra muzejs</p>
                      </div>
                      <p class="text f18">
                        1790. gadā Aleksandrs Johans Stenders iztulko latviešu valodā Ludviga Holberga lugu “Kalnu Jepe”,
                        dodot dāņu rakstnieka darbam jaunu nosaukumu "Lustes spēle no zemnieka, kas par muižnieku tape
                        pārvērsts". Vēlāk šī joku luga iegūst nosaukumu “Žūpu Bērtulis” un 1868. gadā tās iestudējums
                        kļūst par pirmo latviešu teātra izrādi Rīgā.
                      </p>
                      <div class="bottom-arrow" style="margin-top:83px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <img src="../assets/bildes/42_.png" style="width:80%" class="m-auto" alt>
                      <p class="annotation">
                        Piemiņas zīme pirmās latviešu valodā iestudētās lugas “Žūpu Bērtulis” pirmizrādei 1868. gada 2.
                        jūnijā Rīgā vācu Strēlnieku biedrības vingrošanas zālē “Turnhalle” tagadējā Kronvalda bulvārī
                      </p>

                      <p class="text f18">
                        Izrādi organizē "Latviska palīdzības biedrība priekš trūkumu ciezdamiem igauņiem". Tā vāc ziedojumus bada piemeklētajiem Igaunijas guberņu iedzīvotājiem. Aptuveni pēc pusgada uz šīs biedrības pamata tiek izveidota Rīgas Latviešu
                        biedrība
                      </p>
                      <br>
                      <p class="text f18">
                        Teātra spēlēšana Turaidas apkārtnē sākusies ap 1879. gadu, kad Lēdurgas Baznīckroga otrajā stāvā
                        tiek izveidota teātra zāle. Arī Siguldā 1880. gadā nodibina labdarības biedrību, kas divas trīs
                        reizes gadā rīko teātra izrādes. Pirmās iestudētās lugas ir Ādolfa Alunāna „Lielpils pagasta
                        vecākie” un Kārļa Kalniņa „Mednieki”. Viens no Siguldas labdarības biedrības dibinātājiem un
                        teātra patroniem ir Mārtiņš Ertners, vēlākās Dailes teātra režisores un kustību konsultantes
                        Felicitas Ertneres tēvs.
                      </p>
                      <div class="bottom-arrow" style="margin-top:13px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <div>
                        <img src="../assets/bildes/47-48-49.png" alt>
                        <p class="annotation">
                          Siguldas labdarības biedrības teātrī iestudētās Ādolfa Alunāna lugas “Lielpils pagasta vecākie”
                          1888. gada izdevuma vāks un pirmā lapa
                        </p>
                      </div>
                      <p class="text f18">
                        Ādolfa Alunāna lugā “Lielpils pagasta vecākie” notiek priekšvēlēšanu cīņa par pagasta vecākā
                        amatu. Viens no kandidātiem ir bagātais saimnieks Lielozols. Viņa sāncensis ir ideālists dakteris
                        Briedis, kurš uzskata, ka pagasta vecākajam “…jāgādā par kārtību un labklāšanos pagastā, viņam
                        jābūt gādniekam un tēvam visiem apspiestiem un trūcīgiem. Pie katra krietna darba viņam jāķeras
                        kā pašam pirmam”. Vēlēšanās virsroku gūst dakteris Briedis.
                      </p>
                      <div class="bottom-arrow" style="margin-top:152px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <img
                        style="display:inline-block; width:45%"
                        src="../assets/bildes/50.jpg"
                        alt
                      >
                      <p
                        style="display:inline-block; width:45%; padding-left:5%;"
                        class="annotation tal"
                      >Dailes teātra aktrise un kustību konsultante Felicita Ertnere</p>

                      <img src="../assets/bildes/51.jpg" alt>
                      <p class="annotation">
                        Aktieris un Rīgas Latviešu biedrības teātra direktors Pēteris Ozoliņš, pseidonīms Vidridžu
                        Pēteris (1864–1938)
                      </p>

                      <p class="text f18">
                        Pētera Ozoliņa dzimtā vieta atrodas netālu no Turaidas – Vidrižu pagasta “Langžu” mājās. Ieguvis
                        Vācijā labu profesionālo izglītību aktiermākslā un režijā, viņš 19. gadsimta beigās un 20.
                        gadsimta sākumā nelielo Rīgas Latviešu biedrības amatierteātri izveido par plašu, profesionālu
                        visas tautas teātri. Līdz ar Jēkabu Duburu un Aleksi Mierlauku viņš ir arī viens no
                        populārākajiem latviešu aktieriem.
                      </p>
                      <div class="bottom-arrow" style="margin-top:16px !important"></div>
                    </div>
                  </a>
                </slick154>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Tartu universitāte -->
    <div class="slide bg-3" v-if="this.current == 6 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>Atmodas ceļš
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1853.png" class="h-100" style="float:right;" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            TARTU (TĒRBATAS) UNIVERSITĀTE – JAUNLATVIEŠU KUSTĪBAS DZIMŠANAS VIETA
            <hr style="width:70.5%">
          </h1>
          <h2 class="pos-a" style="left:135px; top:120px">
            TĒRBATAS LATVIEŠU
            <br>STUDENTU PULCIŅŠ
          </h2>

          <div class="pos-a slide-white" style=" width:470px; left:135px; top:176px">
            <p class="text justify f20 p-15">
              Jaunlatviešu kustības pirmsākumi ir nelieli izglītoto latviešu pulciņi. Vienu no pirmajiem 1853. gadā
              izveido skolotājs Juris Caunītis Rīgā tekstilrūpnieka Tilo fabrikā pie strādnieku svētdienas skolas. 1856.
              gadā nodibina latviešu studentu pulciņu Tērbatas universitātē – vienīgajā Baltijas guberņas augstskolā.
              Tolaik tur mācās deviņi latviešu studenti, starp kuriem arī Krišjānis Valdemārs, Krišjānis Barons un Juris
              Alunāns – Tērbatas latviešu studentu pulciņa organizētāji un vadītāji. Savas sanāksmes viņi iesauc par
              “Latviešu vakariem”. Tur pulcējas no 10 līdz 20 jaunieši, kuri diskutē par zinātnes, studiju un aktuāliem
              sabiedriski politiskiem jautājumiem. Viņi aicina modināt un izglītot savus tautiešus, kopt dzimto valodu,
              attīstīt nacionālo kultūru un atbrīvoties no vācu virskundzības. “Latviešu vakaru” organizētājs Krišjānis
              Barons raksta, ka sanāksmēs: ".. pārrunājām un pārspriedām sevišķi Baltijas un latviešu dzīvi, apstākļus,
              (..) apņēmāmies katrs pēc iespējas strādāt tautas druvā, tautas labā un rūpēties sevišķi par to, lai
              izglītība un pārticība tautā vairotos."
            </p>
          </div>
          <div class="pos-a slide-white p-10" style=" width:394px; left:622px; top:176px">
            <img src="../assets/bildes/52.jpg" alt>
            <p class="annotation p-10">Tartu (Tērbatas) universitāte 19. gadsimta 50. gados</p>
          </div>

          <div class="pos-a slide-white" style=" width:420px; left:708px; top:535px">
            <p class="text justify f20 p-15">
              Tērbatas studentu pulciņa idejas izplatās izglītoto latviešu vidū un pāraug tautas atmodas kustībā. Tās
              dalībniekus pēc Jaunčehu (Mladočeši), jaunvācu (Junges Deutschland) un citu Eiropas nacionālo kustību
              nosaukumu parauga sāk dēvēt par jaunlatviešiem. Viņu laikabiedrs, romāna "Mērnieku laiki" autors Matīss
              Kaudzīte raksta: "Kas, vāciski prazdams, citu tādu pratēju vidū gribēja runāt latviski, tas bija
              jaunlatvietis." Starp dedzīgākajiem jaunlatviešiem minams Krišjānis Valdemārs, Krišjānis Barons, Fricis
              Brīvzemnieks, Juris Alunāns, Atis Kronvalds, Miķelis Krogzemis (dzejnieks Auseklis), Kaspars Biezbārdis un
              citi izcili 19. gadsimta 50.–80. gadu tautas atmodas darbinieki.
            </p>
          </div>
          <div class="pos-a slide-white" style=" width:550px; left:1150px; top:339px">
            <img src="../assets/bildes/53.jpg" alt>
            <p
              class="annotation p-10"
            >Tartu panorāma. Vilhelma Zigfrīda Štāfenhāgena litogrāfija. 1866</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Jaunlatvieši -->
    <div class="slide bg-1" v-if="this.current == 7 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>Atmodas ceļš
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1856.png" class="h-100" style="float:right;" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            JAUNLATVIEŠI UN LATVIEŠU VALODA
            <hr style="width:36.5%">
          </h1>
          <div class="col-3">
            <div class="col-outer">
              <h2>JURIS ALUNĀNS</h2>
              <div class="col-bg">
                <slick171 :options="slickOptions1" ref="slick">
                  <a>
                    <div class="slide" style>
                      <div style="display:inline-block; width:40%;vertical-align:top;">
                        <img src="../assets/bildes/54.jpg" alt>
                        <p class="annotation p-10">
                          Jura Alunāna grāmatas "Dziesmiņas, latviešu valodai pārtulkotas" 1856. gada izdevuma vāks un
                          titullapa
                        </p>
                        <p class="text justify f18">
                          Ievadtekstā autors raksta: “Šīs dziesmiņas pārtulkojot man bij šādas domas: es gribēju rādīt,
                          cik latviešu valoda spēcīga un jauka, un tad es arī dzinos latviešu valodu cik spēdams no
                          svešiem grabažiem iztīrīt.”
                        </p>
                      </div>

                      <div style="display:inline-block; width:55%; vertical-align:top; float:right">
                        <p class="text justify f18">
                          Jaunlatvieši devuši nozīmīgu ieguldījumu latviešu literārās valodas izveidē. Sevišķi nopelni ir
                          Jurim Alunānam (1832–1864). Ar viņa grāmatas "Dziesmiņas, latviešu valodai pārtulkotas"
                          iznākšanu 1856. gadā aizsākas literārās valodas attīstība. Juris Alunāns pārvalda vairākas
                          svešvalodas, tāpēc spēj latviskot citu tautu leksikas vārdus. Tieši tulkojot no vācu valodas,
                          viņš izveido jaunus latviešu valodas vārdu: kokvilna (no Baumwolle), akmeņogles (no Steinkohle)
                          un citus. Vairāki Jura Alunāna veidoti vārdu atvasinājumi pirmoreiz minēti "Pēterburgas
                          Avīzēs". Tādi ir: virtuve, klausītava, zvērnīce, virsvaldnieks, rakstniecība, zemkopība,
                          skābeklis un citi. Mūsdienās latvieši joprojām izmanto viņa dotos gada mēnešu apzīmējumus, ar
                          kuriem ir aizstāti senākie nosaukumi: janvar, vevrar, merc, april, mei utt. Līdz mūsdienām
                          saglabājušies arī viņa ieviestie etnonīmi: angļi, armēnieši, austrieši, beļģieši, francūži,
                          grieķi, holandieši, spānieši, kas nomainīja iepriekš lietotos vārdus: eņlenderi, armenjeri,
                          eistreiķeri, belgeri, spranči, grieķeri, ollenderi un spānjeri. Kopumā Juris Alunāns ieviesis
                          ap 600 latviešu jaunvārdu.
                        </p>
                      </div>
                      <div class="bottom-arrow" style="margin-top:112px !important"></div>
                    </div>
                  </a>
                </slick171>
              </div>
            </div>
            <div class="col-outer">
              <h2>Atis Kronvalds</h2>
              <div class="col-bg">
                <slick172 :options="slickOptions1">
                  <a>
                    <div>
                      <div style="display:inline-block; width:55%; vertical-align:bottom;">
                        <img src="../assets/bildes/55.jpg" alt>
                      </div>
                      <div
                        style="display:inline-block; width:45%; vertical-align:bottom;"
                        class="p-10 pb0"
                      >
                        <p class="annotation tal">
                          Vairākus gadu desmitus pirms Latvijas dibināšanas jau 1869. gadā Atis Kronvalds ierosina valsts
                          galveno pamatlikumu – konstitūciju apzīmēt ar vārdu “satversme”. Latvijas Satversmes
                          pirmpublicējums “Valdības Vēstnesī” 1922. gada 30. jūnijā
                        </p>
                      </div>
                      <p class="text f20 justify">
                        <br>Latviešu literārās valodas tapšanā nozīmīgu pienesumu devis arī jaunlatviešu kustības
                        sabiedriskais darbinieks, skolotājs un publicists Atis Kronvalds (1837–1875). Gan vārdos, gan
                        darbos viņš pierāda latviešu valodas nozīmību: “Mums ir skaidra un svēta valoda, kuŗa vēl pēc
                        daudz gadu tūkstošiem savā jaunības vaigā, jaunības spēkā liecību dod par mūsu sentēvu pirmo
                        šūpuli, uzrāda seno latviešu jautru un spēcīgu gara darbošanos; viņai netrūkst ne smalkuma, nedz
                        dziļuma, ne bagātības, nedz veiklības.” Atis Kronvalds bagātinājis latviešu valodu ar vismaz
                        divsimt jaunvārdiem, no kuriem saglabājušies ap simt. Starp tiem minami - aizbildnis, apstāklis,
                        arhitektūra, atvasināt, audzēt, burtnīca, būtība, cēlonis, cēls, daile, dzeja, dzejolis,
                        dzenulis, episks, galotne, gleznot, horizonts, izglītība, izglītot, izloksne, jaunatne, kaislība,
                        kautrēties, līdzeklis, locījums, luga, māksla, mūzika, nākotne, pagātne, pilsonis, poēzija,
                        priekšmets, raksturs, skolēns, slimnīca, varonis, vēstule, vēsture, zinātne un citi. Nav
                        ieviesušies tādi vārdi, kā daileklis (glezna), dīvatrons (teātris), gailestība, aizkārtnība
                        (greizsirdība), gādeklis (uzdevums), spaidonis (nepieciešamība), klibzaķis (bezrakstura cilvēks).
                        Atis Kronvalds kuplinājis latviešu leksiku ar apvidvārdiem, tostarp arī ar dažiem lībiešu cilmes
                        vārdiem, piemēram: jauda, selga, apvārsnis, arods, kautrēties, josla, loma, luga, veids un citi.
                      </p>
                      <div class="bottom-arrow" style="margin-top:52px !important"></div>
                    </div>
                  </a>
                </slick172>
              </div>
            </div>
            <div class="col-outer">
              <h2>KRIŠJĀNIS BARONS</h2>
              <div class="col-bg">
                <slick173 :options="slickOptions1">
                  <a>
                    <p class="text f18 justify">
                      Folkorists, rakstnieks, publicists Krišjānis Barons (1835–1923) savu vārdu latviešu kultūrā
                      padarījis nemirstīgu ar latviešu tautasdziesmu krājumu “Latvju dainas” sešos sējumos (astoņās
                      grāmatās), kas iznāca no 1894. līdz 1915. gadam. Tā sastādīšanai viņš velta sava mūža lielāko daļu.
                      Valodnieks profesors Jānis Endzelīns uzskata šo izdevumu par pamatu, uz kura radusies latviešu
                      filoloģija. Savās zinātniskajās publikācijās Krišjānis Barons latviskojis un ieviesis tādus līdz
                      tam latviešu leksikā nebijušus svešvārdus kā admirālis, agronoms, astronoms, atestāts, biljons,
                      ekvators, elektrība, elipse, famīlija, fabrika, gāze, instrukcija, interese, kafeja, klavieres,
                      kapteinis, konfiscierēt, kristāls, mašīna, metāls, mode, muzikants, pols, procents, revīzers,
                      sekunde, šoseja, uniforma. Pateicoties Krišjānim Baronam, latviešu leksikā tiek lietoti arī
                      mūsdienās pierastie zinātņu nosaukumi – matemātika, ģeogrāfija, fizika, bioloģija un citi.
                    </p>
                    <div>
                      <div style="display:inline-block;width:50%; vertical-align:top;" class="p-10">
                        <img src="../assets/bildes/56.jpg" alt>
                      </div>
                      <div style="display:inline-block;width:50%;vertical-align:top" class="p-10">
                        <img src="../assets/bildes/57.jpg" alt>
                        <p class="annotation">
                          Titullapa un fragments no Krišjāņa Barona pirmās ģeogrāfijas mācību grāmatas “Mūsu tēvzemes
                          aprakstīšana”, izdota 1859. gadā Jelgavā.
                        </p>
                      </div>
                    </div>
                    <div class="bottom-arrow" style="margin-top: 20px !important">
                      <img src="../assets/zimes/bottom.png" class="m-auto">
                    </div>
                  </a>
                  <a>
                    <div class="top-arrow">
                      <img src="../assets/zimes/top.png" class="m-auto">
                    </div>
                    <p class="citats">
                      <span style="text-align:center;display:block">Vidzeme</span>
                      <br>Robežas. Ziemeļos Igauņu zem; rītos lielais Peipus ezers un Pleskavas gub.; dienvidos Vitebskas
                      gub. un Kurzeme, un vakaros jūra.
                      <br>Vidzeme ar savām salām (no kurām Sāmu sala tā prāvākā 47 jūdz) un ar saviem lieliem ezeriem kopā
                      880 jūdzes liela ar gandrīz 880 tūkst. iedzīvotājiem, no kuriem:
                      <br>
                      <br>
                      <span style="line-height:2">
                        Latvieši 365 tūkst.,
                        <br>Igauņi 410 tūkst.,
                        <br>Vācieši 65 tūkst.,
                        <br>Krievi, Rīgā vien jau 20 tūkst.,
                        <br>Zviedri 450 uz Roņu (Ruhnas) salas,
                        <br>Poļi 5 tūkst.,
                        <br>Reti Finni un 1000 žīdu, tik Rīgā un Slokā.
                        <br>Savādas tautas – savādas ticības. Lutera ticībai piekrīt 710 tūkst. (Še ir arī pieskaitīta Brāļu
                        draudze (Hernhūter) ar labu tiesu mācekļu.
                        <br>Krievu ticībai vairāk kā 148 tūkst. (Krievi, igauņi un latvieši);
                        <br>Katoļi ir kādi 4300;
                        <br>Reformāti ne visai daudz;
                        <br>Žīdiem ir viena sinagoge Rīgā.
                        <br>
                      </span>
                    </p>
                    <div class="bottom-arrow"></div>
                  </a>
                </slick173>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Jaunlatvieši krievijā -->
    <div class="slide bg-1" v-if="this.current == 8 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>Atmodas ceļš
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1862.png" class="h-100" style="float:right;" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            JAUNLATVIEŠI KRIEVIJĀ
            <hr style="width:36.5%">
          </h1>
          <div class="col-3">
            <div class="col-outer">
              <h2>
                PĒTERBURGA – JAUNLATVIEŠU IDEJISKAIS
                <br>CENTRS 19. GADSIMTA OTRAJĀ PUSĒ
              </h2>
              <div class="col-bg h-100">
                <div class="slide">
                  <p class="text f18 justify">
                    Latviešu tautas atmodas idejas 19. gadsimta otrajā pusē brīvāk var izpausties ārpus Baltijas vācu
                    ietekmes sfēras – Krievijā. Tur inteliģentajiem latviešiem ir lielākas iespējas atrast izglītībai
                    atbilstošu darbu. Pēterburgā strādā Krišjānis Valdemārs, Krišjānis Barons, Fricis Brīvzemnieks,
                    Miķelis Krogzemis (dzejnieks Auseklis), Andrejs Spāģis un vēl citi latvieši, kuri savu nacionālo
                    ideju dēļ spiesti pamest dzimteni. Tur studē arī daudzi latviešu jaunieši, tiek izdots jaunlatviešu
                    laikraksts “Pēterburgas Avīzes” (1862—1865), iespiests Krišjāņa Barona apkopotais krājums “Latvju
                    dainas” un citi latviešu izdevumi. Ar Pēterburgu saistīta arī Latvijas valsts himnas “Dievs, svētī
                    Latviju!” vēsture, kuru Pirmajiem vispārējiem latviešu dziesmu svētkiem 1873. gadā saraksta
                    Pēterburgas Smoļnija institūta pasniedzējs Kārlis Baumanis
                  </p>
                  <div>
                    <div style="display:inline-block;width:60%" class="p-10">
                      <img src="../assets/bildes/58.jpg" alt>
                    </div>
                    <div style="display:inline-block;width:40%; vertical-align:bottom" class="p-10">
                      <p class="annotation tal">
                        Pēterburga 19. gadsimtā.
                        <br>Skats uz skulptūru
                        “Vara jātnieks”,
                        Vasilija Surikova gleznas reprodukcija
                      </p>
                    </div>
                  </div>
                  <div>
                    <div style="display:inline-block;width:40%" class="p-10">
                      <p class="annotation tal">
                        Pēterburga, Vasilija sala, 4. līnija, nams Nr. 5, kurā atradies Krišjāņa Barona dzīvoklis un līdz
                        1875. gadam arī “Pēterburgas Avīžu” redakcija
                      </p>
                    </div>
                    <div style="display:inline-block;width:60%" class="p-10">
                      <img src="../assets/bildes/59.jpg" alt>
                    </div>
                  </div>

                  <div class="bottom-arrow"></div>
                </div>
              </div>
            </div>
            <div class="col-outer">
              <h2>
                PĒTERBURGAS AVĪZES –
                <br>JAUNLATVIEŠU LAIKRAKSTS
              </h2>
              <div class="col-bg">
                <slick182 :options="slickOptions1">
                  <a>
                    <div class="slide">
                      <img class="m-auto" src="../assets/bildes/112.png" alt>
                      <p
                        class="annotation p-10"
                      >Augusta Dauguļa (1830-1899) zīmētā “Pēterburgas Avīžu” titullapa (1862)</p>
                      <p class="text justify f18">
                        “Pēterburgas Avīzes” ir jaunlatviešu preses izdevums, kuru izdod Pēterburgā no 1862. līdz 1865.
                        gadam ar Jura Alunāna, Krišjāņa Barona un Krišjāņa Valdemāra atbalstu. Laikraksta publikācijās
                        atspoguļojas Eiropas nacionālās kustības idejas.
                      </p>
                      <p class="text justify f18">
                        Latviešu valodā 19. gadsimta vidū iznāk vairāki preses izdevumi, taču tie neapmierina augošās
                        latviešu inteliģences prasības. Aktīvākie jaunlatvieši pēc Krišjāņa Valdemāra iniciatīvas nolemj
                        dibināt jaunu laikrakstu. Par tā redakcijas atrāšanās vietu izvēlas Pēterburgu, jo tur ir lielāka
                        neatkarība no vācbaltu muižnieku cenzūras. “Pēterburgas Avīzes” iznāk tikai četrus gadus
                        (1862–1865), taču šajā laikā paspēj noformulēt latviešu pirmās atmodas idejas, veicināt to
                        ieviešanu dzīvē. Rakstu autori aicina zemniekus celt pašapziņu un apzināties savas kārtas nozīmi.
                        “Pēterburgas Avīzēs” daudz raksta arī par latviešu nacionālo jautājumu un neatkarību. Vienā no
                        Krišjāņa Valdemāra izglītojošajiem rakstiem pirmoreiz vēsturē bija pieminēts vārds “Latvija”:
                        “Latvija atrodas vidū starp lielo Krieviju un arī pēc ļaužu skaita ņemot lielo Vāciju…” Šādi
                        jaunlatviešu raksti pēc Krišjāņa Barona domām bija dūriens “vācu lapseņu pudurā”. Tie
                        neapmierināja arī Krievijas varas iestādes, tāpēc 1865. gada 17. jūnijā avīze tika slēgta.
                      </p>
                      <div class="bottom-arrow" style="margin-top:30px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div class="slide">
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <img class="m-auto" style="width:65%" src="../assets/bildes/114.png" alt>
                      <p
                        class="annotation p-10"
                      >Augusta Dauguļa zīmētā “Pēterburgas Avīžu” pielikuma “Zobugals” titullapa (1852)</p>
                      <p class="text f18">Par krogiem. Fragments no “Pēterburgas Avīzēm”:</p>
                      <p class="citats justify f16">
                        Sādžas mācītājs un skolmeisteris neliedzas ar daļu ņemt pie alus un vīna glāzes. Ja gaiss
                        lietains jeb auksts, tad iet visi gastuzī iekšā. Un tā tur visi cits caur citu biedrojas, pār
                        visiem valda viens gars. Zināms, nevajaga domāt, ka tur mācītājs un skolmeisters klāt ir, ka tur
                        jau tūlīt ar visiem priekiem pagalam, ka tur tūlīt sāk no Dieva vārdiem runāt. Mācītājs tur ar
                        visiem apietas kā viens cilvēks ar otru, viena pati mīlestības saite sien visus par vienas
                        biedrības locekļiem, kuŗā katrs tīrus, skaidrus cilvēcības priekus bauda.
                        <br>
                        <br>Tā tad, pirmā kārtā redzējām, ka krogi jeb gastūži (tas vienalga) īsti no dabas nevis vien nakts
                        mājas un apmešanās, bet it īpaši biedrošanās vietas ir; un otrā kārtā, ka no krogu un gastūžu
                        būšanas uz visa tā apriņķa miesīgu un garīgu būšanu spriest var. Krogs ir visa pagasta ģīmis. Kas
                        ar šām lietām labi iepazinies, var droši un riktīgi no krogā būšanas uz pagasta mājas būšanu
                        spriest bez kā tam misētos. Bet, saprotams, ka tas jāzina, kā vaļā kroga ieriktēšana stāv, cik
                        brīvības ļaudīm dotas uz viņa pārgrozīšanu uzspiesties…
                      </p>
                      <div class="bottom-arrow">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div class="top-arrow">
                      <img src="../assets/zimes/top.png" class="m-auto">
                    </div>

                    <p class="citats justify f16 p-10">
                      Lai tikai apskatāmies mūsu mazā zemītē. Kur atrod vairāk nešķīstību, dzeršanu un visvisādu negausību?
                      Arvien tur, kur vislielākā nabadzība, kur saimnieks un saimniece ar bēdām apgulstas un uzceļas, kur
                      sāpes, iekšķīgas un ārīgas tā prātu un sirdi sagrauž, ka viņš kā apdullis vairs nesajūt, ka cilvēks
                      esot, tur, kur nekādi prieki, nekādas lustes tam prātu necilā, kur nopūtas un bēdas uz katra soļa
                      gala, kā smags svaru akmins sirdi spiež. Ticīgā prātā gan viņš sauc uz Dievu; gan viņš zina, ka aiz
                      kapa visām bēdām gals būs, bet viņš ar sajūt, ka viņam še virs zemes vajadzētu labi klāties. Tāpēc
                      tas nāk, ka pamācīšanas tikai gluži, gluži reti vien un daudzreiz it neko nepalīdz. Laimība cilvēkam
                      šai pasaulē ir vajadzīga kā ēšana un dzeršana. Tā kā pret ēšanu un dzeršanu nekāds sprediķis
                      nepalīdz, tāpat ar pret laimību. Un ja cilvēks to nevar uz pienākamu vīzi iedabūties, tad viņš to sev
                      ņemas uz nepienākamu vīzi.
                      <br>
                      <br>Ticu, ka šo lasot nevienam prātā nenāks, ka es dzērājus aizbildināt gribējis. Dieva pēc nē! Tikai uz
                      to cītos, lasītājiem dzeršanas sakni rādīt, lai tie uz aplamiem ceļiem nenopūlētos, viņu gribēdami
                      izravēt. Vēl vienreiz jāsaka: darāt cilvēku īsti par cilvēku, tad viņš par lopu nepaliks. Ļaužu
                      vadītāji, dodat saviem audzēkņiem, bez ko tie nevar iztikt, tad tie pie tā neķersies, kas tiem
                      skādīgs. Dodat viņiem citus augstākus priekus, tad viņi paši no sevis, bez visas uzspiešanas šos
                      skādīgos atstās. Darāt viņus par cilvēku biedrības dzīviem locekļiem, tā kā viena asiņu straume caur
                      visām dzīslām iet tā kā tas viena cīnīšanās, viens gala mērķis, viena dzīšanās savieno, - tad vien
                      var ir šie cilvēku biedrības vāji locekļi atkal par veseliem locekļiem un visa miesa vesela palikt.
                    </p>
                    <div class="bottom-arrow" style="margin-top:52px !important">
                      <img src="../assets/zimes/bottom.png" class="m-auto">
                    </div>
                  </a>
                  <a>
                    <div class="top-arrow">
                      <img src="../assets/zimes/top.png" class="m-auto">
                    </div>
                    <div style="width:70%" class="m-auto">
                      <img class="m-auto" src="../assets/bildes/60.jpg" alt>
                      <p class="annotation p-10">
                        Pēterburgas latviešu 1875. gada izdevuma ”Jauni Dunduri” vāks, veidots pēc Augusta Dauguļa
                        kokgrebuma
                      </p>
                    </div>
                    <div class="bottom-arrow" style="margin-top:55px !important"></div>
                  </a>
                </slick182>
              </div>
            </div>
            <div class="col-outer">
              <h2>
                LATVIEŠU INTELIĢENCES DARBĪBA
                <br>MASKAVĀ 19. GADSIMTA OTRAJĀ PUSĒ
              </h2>
              <div class="col-bg">
                <slick183 :options="slickOptions1">
                  <a>
                    <div class="slide">
                      <p class="text justify f18">
                        Kopš 1870. gada arī Maskavā veidojas tur dzīvojošo latviešu inteliģences un studentu pulciņi.
                        Maskavas pulciņa sākums cieši saistīts ar jaunlatviešu ideologa Krišjāņa Valdemāra un Krišjāņa
                        Barona vārdu. Darba meklējumos viņi 1867. gadā ierodas Maskavā, kur pulcina ap sevi latviešu
                        inteliģenci. Krišjāņa Barona dzīvoklī notiek sapulces un kora mēģinājumi. Populāri ir t.s.
                        “Maskavas latviešu lasāmie vakari”, kuri izpaužas kā sanāksmes un diskusijas par latviešu
                        valodas, literatūras, vēstures un citiem jautājumiem. Maskavas latvieši uztur sakarus ar
                        Tērbatas, Jelgavas un Rīgas jaunlatviešiem, īpaši ar Rīgas latviešu biedrību. Maskavas latviešu
                        pulciņā 1878. gadā Krišjānis Valdemārs ar 60 rubļu ziedojumu aizsāk līdzekļu vākšanu latviešu
                        tautasdziesmu publicēšanai. Lai iesūtīto folkloras materiālu apkopotu, sistematizētu un
                        uzglabātu, Krišjānis Barons pasūta īpašu skapi ar 70 atvilktnēm. Katrā no tām ir 20 nodalījumi,
                        kas paredzēti uz nelielām lapiņām rakstīto tautasdziesmu ievietošanai. Skapis izgatavots 1880.
                        gadā Maskavā.
                      </p>
                      <div style="width:90%" class="m-auto">
                        <img class="m-auto" src="../assets/bildes/113.png" alt>
                        <p
                          class="annotation p-10"
                        >Maskava 19. gadsimtā. Skats uz Akmens tiltu un Kremli. Fjodora Aleksejeva gleznas reprodukcija</p>
                      </div>
                      <div class="bottom-arrow" style="margin-top:61px !important;">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div class="slide">
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <img
                        class="m-auto"
                        style="width:70%; height:auto"
                        src="../assets/bildes/61.jpg"
                        alt
                      >
                      <p class="annotation p-10">Krišjānis Barons Maskavā. 1852. RMM</p>
                      <div class="bottom-arrow" style="margin-top:73px !important"></div>
                    </div>
                  </a>
                </slick183>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Jaunlatvieši un atmoda-->
    <div class="slide bg-3" v-if="this.current == 9 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>Atmodas ceļš
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1855.png" class="h-100" style="float:right;" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            Jaunlatvieši un atmoda
            <hr style="width:27.5%">
          </h1>
          <slick19 :options="slickOptions2">
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-white" style=" width:320px; top:3px;  left:194px;">
                  <img src="../assets/bildes/62.png" alt>
                  <p class="annotation">
                    Viens no jaunlatviešiem, dzejnieks, publicists un valodnieks Juris Alunāns (1832–1864) starp Tērbatas
                    studentu korporocijas “Fraternitas Academica Dorpatensis” biedriem (otrajā rindā otrais no labās)
                  </p>
                </div>
                <div class="pos-a slide-white" style=" width:362px;top:394px;  left:381px;">
                  <p class="text justify f18 p-10">
                    Juris Alunāns prot krievu, vācu, grieķu, latīņu, franču, senebreju un lietuviešu valodu. Viņš tulko
                    latviski Eiropas nacionālās atdzimšanas kustības darbinieku un klasisko dzeju, kā arī ir daudzu
                    latviešu jaunvārdu radītājs. Viņa latviskotais čehu dzejnieka Františeka Čelakovska (F. L.
                    Čelakovský, 1799–1852) dzejolis “Nevis slinkojot un pūstot” kļūst par vienu no latviešu garīgās
                    atmodas ideju simboliem. Latviski tas pirmoreiz publicēts Tērbatā 1860. gadā Jura Alunāna sastādītajā
                    krājumā “Sēta, Daba, Pasaule”. Sākotnēji dzejolim ir 3 panti, vēlāk pievieno Jura Alunāna sacerēto
                    ceturto pantu.
                  </p>

                  <div style="width:80%;border-top:3px solid #000;float:right">
                    <p class="annotation tar">
                      No Pāvela Štolla publikācijas “
                      <br>No “Rozes simtlapainās”,
                      <br>(Latvijas Vēstnesis,
                      <br>05.05.2005., Nr. 70)
                    </p>
                  </div>
                </div>
                <div class="pos-a slide-white" style=" width:320px; top:160px;  left:770px;">
                  <img src="../assets/bildes/63.jpg" alt>

                  <p
                    class="annotation p-10"
                  >Jura Alunāna rakstītais dzejoļa “Jāņu vakars” manuskripts</p>
                </div>
                <div class="pos-a slide-white" style=" width:580px; top:47px;  left:1116px;">
                  <div>
                    <div style="width:90%; display:inline-block">
                      <img
                        src="../assets/bildes/64.jpg"
                        class="m-auto"
                        style="width:560px; height:auto"
                        alt
                      >

                      <p class="annotation p-10">
                        Alegoriska ilustrācija dzejolim “Nevis slinkojot un pūstot”
                        <br>(H. Šics, Jelgava, 1873)
                      </p>
                    </div>
                    <div
                      style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:50px !important"
                    >
                      <div class="hor-next">
                        <img src="../assets/zimes/right.png" alt>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-white p-20" style=" width:812px; top:0px;  left:0px;">
                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:135px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>
                  <div style="width:45%; display:inline-block;" class="p-20">
                    <img src="../assets/bildes/65.jpg" alt>
                    <p class="annotation">
                      Dzejolis “Nevis slinkojot un pūstot” oriģinālvalodā Františeka Ladislava Čelakovska krājumā “Růže
                      stolist?” (Roze simtlapainā, izdevniecība: Bohumil Haas synové Praha, 1840)
                    </p>
                  </div>
                  <div style="width:45%; display:inline-block;" class="p-20">
                    <p class="citats">
                      Nevis slinkojot un pūstot
                      <br>Tautu labā godā ceļ,
                      <br>Bet pie prāta gaismas kļūstot
                      <br>Tauta zied un tauta zeļ.
                      <br>
                      <br>Ja ikviens tik zemē sētu,
                      <br>Vienu graudu veselu.
                      <br>Kas gan izskaitīt tad spētu
                      <br>Zelta kviešu krājumu?
                      <br>
                      <br>Bet kas lielīdamies pārdod,
                      <br>Ved uz tirgu pelavas,
                      <br>Tas kā pelus vējam ārdot
                      <br>Zūd no ļaužu piemiņas.
                      <br>
                      <br>Augsim lieli, augsim stipri,
                      <br>Būsim sveiki, veseli,
                      <br>Uzdziedāsim, uzdziedāsim
                      <br>Augstu laimi Latvijai!
                      <br>
                    </p>
                    <p
                      class="annotation"
                    >Dzejolis “Nevis slinkojot un pūstot” Jura Alunāna atdzejojumā</p>
                  </div>
                </div>
                <div class="pos-a slide-white" style=" width:850px;top:133px;  left:830px;">
                  <div style="width:50%; display:inline-block; vertical-align:top" class="p-10">
                    <img src="../assets/bildes/66.jpg" alt>
                    <p
                      class="annotation p-10"
                    >Jura Alunāna tulkotā Heinriha Heines dzejoļa “Loreleja” teksts</p>
                    <p class="text f20 justify">
                      Mācītājs Braše par Jura Alunāna atdzejojumu ironiski teicis, ka Loreleja būšot kā jaunā Latvija uz
                      klints. Tā ieviešas jēdziens “jaunlatvieši”.
                    </p>
                  </div>
                  <div style="width:40%; display:inline-block;" class="p-10">
                    <p class="citats">
                      Es nezinu tiešām kā labad
                      <br>Tik skumīgs esmu tāds!
                      <br>Sev pasaku vecu glabāt,
                      <br>Uz to vien nesas man prāts.
                      <br>Vēss vakars krēslībā sedzies,
                      <br>Un klus` tek Daugava;
                      <br>Tas kalna gals liesmās dedzies,
                      <br>Mirdz saules spožumā.
                      <br>
                      <br>Tur jaunava jo skaista
                      <br>Sēd augšā brīnišķi:
                      <br>Tur zibošā zeltā saista
                      <br>Sev matus zeltainus šī,
                      <br>Tos sukā ar zeltainu ķemmi,
                      <br>Un uzdzied dziesmiņu,
                      <br>Kas brīnišķi skan uz zemi
                      <br>Ar varenu melodiju.
                      <br>
                      <br>Tas laiviniekam laivā iekšā
                      <br>Ar žēlabām sirdi spiež;
                      <br>Viņš neredz, kur klintis priekšā,
                      <br>Viņš acis uz augšu vien griež.
                      <br>Man šķiet, ka tur laiviņā, lejā
                      <br>Nu laivinieks postā vēl ies,
                      <br>Un dziedot Loreleja
                      <br>To darījusi paties`.
                      <br>
                    </p>
                  </div>
                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:50px !important"
                  >
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-white" style=" width:380px; top:0px;  left:0px;">
                  <div>
                    <div
                      style="width:20%; display:inline-block; height:350px; vertical-align:top;margin-top:160px !important"
                    >
                      <div class="hor-prev">
                        <img src="../assets/zimes/left.png" alt>
                      </div>
                    </div>

                    <div style="width:80%;display:inline-block">
                      <img src="../assets/bildes/67.png" style="width:80%" class="m-auto" alt>
                      <p class="annotation p-10">
                        Krišjānis Valdemārs (1825–1891). Viens no latviešu nacionālās literatūras un publicistikas
                        pamatlicējiem, tautasdziesmu vācējs. Dibinājis pirmo latviešu jūrskolu, finansējis jaunlatviešu
                        laikraksta “Pēterburgas Avīzes” izdošanu
                      </p>
                      <img src="../assets/bildes/68.jpg" style="width:80%" class="m-auto" alt>
                      <p class="annotation p-10">Krišjānis Barons (1835–1923) pie Dainu skapja</p>
                    </div>
                  </div>
                </div>
                <div class="pos-a slide-white p-20" style=" width:470px; top:70px;  left:400px;">
                  <img src="../assets/bildes/69.jpg" class="m-auto" alt>
                  <p class="annotation p-10">
                    Latviešu tautasdziesmu krājuma “Latvju dainas” sastādītāji un izdevēji. No kreisās: Henrijs
                    Visendorfs, Krišjānis Barons un Fricis Brīvzemnieks. 1901. LNB
                  </p>
                  <p class="text f18 justify">
                    Atmodas laika ideju ietekmē tiek vākts, uzkrāts un publicēts latviešu mutvārdu folkloras mantojums.
                    Pateicoties jaunlatvieša Krišjāņa Valdemāra, Friča Brīvzemnieka, Āronu Matīsa un Krišjāņa Barona
                    entuziasmam, tiek savākti un publicēti pirmie 1707 latviešu sakāmvārdi, 1682 mīklas, ap 700
                    burāmvārdu un 1888. gadā krājums “Mūsu Tautas dziesmas”.
                    <br>
                    <br>Krišjānis Barons no visiem novadiem iesūtītos oriģinālos tautasdziesmu tekstus uzkrāj un sistematizē
                    īpašā Dainu skapī, kurā 1893. gadā jau glabājas ap 150 000 manuskriptu. Ar latviešu tirgotāja Henrija
                    Visendorfa finansiālu atbalstu no 1894. līdz 1898. gadam Jelgavā Jēkaba Darvnieka izdevniecībā tiek
                    izdotas pirmās “Latvju Dainu” burtnīcas. Pārējās izdošanai paredzētās tautasdziesmas iznāk ar
                    Krievijas Ķeizariskās Zinātņu akadēmijas atbalstu un no 1903. līdz 1915. gadam tiek iespiestas
                    Pēterburgā.
                  </p>
                </div>
                <div class="pos-a slide-white p-20" style=" width:280px; top:167px;  left:888px;">
                  <img src="../assets/bildes/70.png" style="width:100%" class="m-auto" alt>
                  <p class="annotation p-20">
                    Atis Kronvalds (1837–1875) ir pedagogs, valodnieks, jaunvārdu darinātājs un izcils orators, kurš ar
                    savām runām iedvesmo klausītājus skolotāju konferencēs un pirmajos vispārējos latviešu dziesmu
                    svētkos
                  </p>
                </div>
                <div class="pos-a slide-white p-10" style=" width:350px; top:253px;  left:1252px;">
                  <div>
                    <img src="../assets/bildes/71.jpg" style="width:95%" class="m-auto" alt>
                    <p
                      class="annotation p-20"
                    >Ex-libris veltīts Atim Kronvaldam. Autors Zigurds Zuze</p>
                  </div>
                </div>
                <div
                  style="position:absolute;width:10px;height:350px; vertical-align:top;top:165px; left:1650px"
                >
                  <div class="hor-prev">
                    <img src="../assets/zimes/left.png" alt>
                  </div>
                </div>
              </div>
            </a>
          </slick19>
        </div>
      </div>
    </div>

    <!--Symbols slides -->

    <!-- Dziesmu svētki -->
    <div class="slide bg-4" v-if="this.current == 10 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:284px;right:106px;"
        >
        <br>Atmodas simboli
      </div>
      <div class="layout-2">
        <div class="content">
          <h1 class="slide-heading">
            Dziesmu svētki
            <hr style="width:18.5%">
          </h1>
          <slick22 :options="slickOptions2">
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-green" style="top:37px;left:0px;width:389px">
                  <img src="../assets/bildes/85.jpg" alt>
                  <p
                    class="annotation p-10"
                  >XXV Vispārējie latviešu Dziesmu un XV Deju svētki 2013. gadā Mežaparka estrādē Rīgā</p>
                  <p class="text f20 p-20 justify">
                    Latviešu pirmās nacionālās atmodas laikā radītā Dziesmu svētku tradīcija Latvijā pastāv jau gandrīz
                    150 gadus, joprojām apliecinot tautas radošo spēku, identitāti un kultūras savdabību. XXV Vispārējie
                    latviešu Dziesmu un XV Deju svētki 2013. gadā Mežaparka estrādē Rīgā pulcē gandrīz 40 000 dalībnieku,
                    kuri pārstāv vairāk nekā 1500 kolektīvus. Latvijas valsts simtgades jubilejai veltītajos XXVI Dziesmu
                    svētkos 2018. gadā piedalās ap 43 000 dalībnieku no 118 Latvijas pašvaldībām, kā arī no ārvalstīm.
                    Deviņas dienas no 30. jūnija līdz 8. jūlijam notiek vairāk nekā 65 pasākumi – koru, deju, pūtēju
                    orķestru, kokļu, tautas mūzikas, vokālo ansambļu, folkloras kopu un citu kolektīvu koncertprogrammas.
                    Svētkus apmeklē ap 500 000 skatītāju
                  </p>
                </div>
                <div class="slide-outer pos-a" style="top:64px;left:432px;width:781px">
                  <h2>PRIEKŠVĒSTURE</h2>
                  <div class="slide-green">
                    <div style="display:inline-block;width:60%">
                      <p class="text justify f18">
                        Raksturīga 19. gadsimta Eiropas nacionāli patriotiskās kustības izpausme ir koru dziedāšanas
                        biedrības, kuru pasākumi nereti vainagojas ar kopdziedāšanas svētkiem. Tie ir centieni izmantot
                        dziesmas iedvesmojošo spēku, lai saliedētu tautu vienotā valstī. Vieni no senākajiem koru dziesmu
                        svētkiem notiek 1838. gadā Vācijā Frankfurtē (Alt-Frankfurt) pie Mainas, kur piedalās vīru kori no
                        dažādiem Vācijas reģioniem. Dziesmām pievienojas arī politiskās prasības par nacionālo vienotību,
                        pilsoņu tiesībām un brīvību. Pirmie vispārīgie vācu dziedāšanas svētki 1845. gadā Vircburgā
                        (Würzburg) pulcē 1 626 kora dziedātāju.
                      </p>
                      <img src="../assets/bildes/86.jpg" style="width:80%" class="m-auto" alt>
                      <p class="annotation p-10">
                        Pastkarte “Dziedātāju ierašanās uz pirmajiem vācu dziesmu svētkiem Frankfurtē 1838. gada 28.
                        jūlijā“
                      </p>
                      <p class="text justify f18">
                        Dziedāšanas svētki Vācijā iedvesmo vācu minoritāti Baltijā un 1857. gadā Tallinā (tolaik: Rēvelē)
                        notiek Baltijas pirmie dziesmu svētki “Erste Sängerfest in Reval, 1857”. Tajos piedalās vācu kori
                        no visas Baltijas. Nākamie Baltijas vācu dziesmu svētki (Das Baltische Sängerfest in Riga) notiek
                        1861. gadā Rīgā un tur piedalās arī daži latviešu kolektīvi. Vislielākā dalībnieku aktivitāte ir
                        ceturtajos Baltijas dziesmu svētkos 1880. gadā Rīgā, kur pulcējas 34 vīru koru biedrības ar vairāk
                        nekā tūkstoš dziedātājiem
                      </p>
                    </div>
                    <div style="display:inline-block;width:40%; vertical-align:top">
                      <img src="../assets/bildes/87.jpg" class="m-auto" style="width:80%" alt>
                      <p
                        class="annotation p-10"
                      >Pirmo vispārīgo vācu dziedāšanas svētku karodziņš. Vircburga (Würzburg). 1845</p>

                      <img src="../assets/bildes/88.jpg" style="width:90%" class="m-auto" alt>
                      <p class="annotation p-10">
                        Pirmie Baltijas dziesmu svētki: dziedātāju brauciens pa Piritas upi Rēvelē (Tallinā) , 1857 (Das erste
                        baltische Liederfest zu Reval). Kokgriezums
                      </p>
                    </div>
                  </div>
                </div>

                <div class="pos-a slide-green" style="top:191px;left:1227px;width:477px">
                  <div style="display:inline-block;width:80%">
                    <img src="../assets/bildes/89.jpg" class="m-auto" alt>
                    <p class="annotation p-10">
                      Pirmo igauņu dziesmu svētku norise 1869. gadā Tartu (Tērbatā). Dziesmu svētki veltīti dzimtbūšanas
                      atcelšanas 50 gadu atcerei
                    </p>

                    <p class="text justify p-10">
                      Dziesmu svētki, kas radušies Rietumeiropas vāciski runājošajās zemēs, tur neiegūst tādu atsaucību kā
                      Latvijā, Lietuvā un Igaunijā, kur tie saglabājušies līdz mūsdienām. Pirmie vietējo iedzīvotāju
                      dziesmu svētki Baltijā notiek 1869. gadā mūsdienu Igaunijas pilsētā Tartu
                    </p>
                  </div>
                  <div
                    style="width:15%; display:inline-block; height:350px; vertical-align:top; margin-left:10px !important;margin-top:50px !important"
                  >
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <br>
                <br>
                <h2>
                  PIRMIE VISPĀRĪGIE LATVIEŠU
                  <br>DZIEDĀŠANAS (DZIESMU) SVĒTKI
                </h2>
                <div class="pos-a slide-green" style="top:195px;left:17px;width:479px">
                  <div
                    style="width:12%; display:inline-block; height:350px; margin-right:10px !important;vertical-align:top;margin-top:40px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>
                  <div style="display:inline-block;width:85%">
                    <img src="../assets/bildes/90.jpg" class="m-auto" alt>
                    <p class="annotation p-10">
                      Rīga, pils laukums 19. gadsimta vidū.
                      Johana Ludviga fon Radecka akvarelis. LNVM
                    </p>

                    <p class="text justify p-10">
                      Pirmie vispārīgie latviešu dziedāšanas svētki notika 1873. gada jūnijā Rīgā. Šeit 26. jūnijā ierodas
                      27 kori no Vidzemes, 12 kori Kurzemes un Zemgales, kā arī 5 Rīgas kori. Kopumā ierodas 1003
                      dziedātāji gan zirgu pajūgos, gan izpušķotās laivās pa Aivieksti un Daugavu.
                    </p>
                  </div>
                </div>
                <div class="pos-a slide-green" style="top:96px;left:510px;width:560px">
                  <p class="citats justify">
                    Tai 26.jūnijā saulīte uzlēca jo koši, un debesis bija skaidras, tā kā varēja uz jauku laiku cerēt.
                    Pulksten 8 no rīta svētku komiteja bija biedrības namā uz viesu saņemšanu sapulcējušies. Latviešu
                    augstas skolas mācekļi no Tērpatas, Pēterburgas, Maskavas un Berlīnes universitātēm, kas svētku -
                    komitejai savu piepalīdzību bija piesolījuši līdzi ar tiem no svētku komitejas ieceltiem korteļa un
                    kārtības uzraugiem arī jo agri biedrības namā sapulcējās. Šie savienoti kārtības uzraugi dabūja
                    sarkan-baltas bantes ap plecu, par viņu darīšanu zīmi svētku dienās.
                    <br>
                    <br>Kārtības vīru pirmais darbs nu bija dziedātajus pie dzelzceļiem saņemt un tos uz biedrības namu
                    pavadīt, un tad no biedrības nama tos korteļos aizvest. Pulkstens vēl nebija 9, kad jau no visām
                    pusēm dziedātāju bari uz biedrības namu devās, kur tie savus karogus nolika; tad no komitejas svētku
                    programu un dziedātāju zīmi dabūjuši tika korteļos pavadīti.
                  </p>
                  <p class="annotation tar">
                    Fragments no Dziesmu svētku Rīcības komitejas
                    <br>priekšnieka Riharda Tomsona atmiņām
                  </p>
                </div>
                <div class="slide-outer pos-a" style="top:40px;left:1103px;width:602px">
                  <h2>
                    PIRMO VISPĀRĪGO LATVIEŠU
                    <br>DZIEDĀŠANAS SVĒTKU ATKLĀŠANA
                  </h2>
                  <div class="slide-green">
                    <div style="display:inline-block;width:88%">
                      <p class="citats justify">
                        <u>Ceturtdiena, 1873. gada 26. jūnijs</u>
                        <br>Pirmos vispārīgos latviešu dziedāšanas svētkus atklāja 26. jūnijā Rīgas Latviešu biedrības namā.
                        Svētku uzrunas teica Rīcības komitejas vadītājs Rihards Tomsons un arhitekts Jānis Baumanis. Baltijas
                        skolotāju semināra kora izpildījumā pirmo reizi izskanēja Kārļa Baumaņa dziesma “Dievs, svētī
                        Latviju!”. Rihards Tomsons svētku pārskatā apraksta speciāli svētkiem šūtā “Līgo” karoga ienešanu:”
                        Papriekšu ienācā zālē seši jaunekļi, goda sargi, ar sarkan-baltām krūts lentēm pušķoti. Tad nāca
                        deviņas kundzes. Pēc tam jaunais svētku karogs, ko Latviešu biedrības priekšnieks un divi runas vīri
                        nesa. Karogam no pakaļas nāca tie trīs iecelti karoga nesēji, kuriem bija apkārt baltas zīda krūts
                        lentes ar zelta pušķiem galā. Tiem no pakaļas nāca karoga apgādātājas, deviņas jaunkundzes, un visu
                        pēdīgi atkal seši goda sargi.
                      </p>
                      <div style="display:inline-block;width:50%;vertical-align:top;">
                        <img src="../assets/bildes/91_.png" style="width:80%" class="m-auto" alt>
                        <p
                          class="annotation m-auto"
                          style="width:90%"
                        >Uzņēmējs, žurnālists, viens no Rīgas Latviešu biedrības dibinātājiem Rihards Tomsons (1834–1893)</p>
                      </div>
                      <div style="display:inline-block;width:50%;vertical-align:top;">
                        <img src="../assets/bildes/92_.png" style="width:80%" class="m-auto" alt>
                        <p class="annotation m-auto" style="width:90%">
                          Arhitekts, viens no Rīgas Latviešu biedrības dibinātājiem un vadītājiem Jānis Frīdrihs Baumanis
                          (1834–1891). Jāņa Rozes gleznotā portreta reprodukcija. Oriģināls glabājas Rīgas Vēstures un
                          kuģniecības muzejā
                        </p>
                      </div>
                    </div>

                    <div
                      style="width:12%; display:inline-block; height:350px; vertical-align:top;margin-top:188px !important"
                    >
                      <div class="hor-next" style="margin-left:10px !important;">
                        <img src="../assets/zimes/right.png" alt>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <div class="slide-outer pos-a" style="top:40px;left:17px;width:1062px">
                  <h2>
                    Pirmo vispārīgo latviešu
                    <hr>dziedāšanas svētku koru gājiens un kopkoncerts
                  </h2>

                  <div class="slide-green">
                    <div
                      style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:203px !important"
                    >
                      <div class="hor-prev" style="margin-right:10px !important;">
                        <img src="../assets/zimes/left.png" alt>
                      </div>
                    </div>

                    <div style="display:inline-block;width:90%">
                      <div style="display:inline-block; width:60%">
                        <p class="text justify f20 p-10">
                          <u>Piektdiena, 1873. gada 27. jūnijs</u>
                          <br>Koru gājiens no Rīgas latviešu biedrības nama uz dziesmu svētku norises vietu Ķeizardārzā (tagad:
                          Viesturdārzs) pēc pirmo vispārējo latviešu dziesmu svētku Rīcības komitejas priekšnieka Riharda
                          Tomsona apraksta:
                        </p>
                        <p class="citats p-10 justify">
                          Katra kora priekšgalā nostājās vadonis un karoga nesējs, aiz tiem dziedātāji pa četri rindā. Pašā
                          priekšgalā jāja žandarmi; tad gāja kara mūziķis, tad nesa Latviešu biedrības karogu, kam b-bas
                          priekšnieks, runasvīri un goda viesi līdzi gāja. Tad gāja seši kārtībnieki un tiem pakaļ nesa
                          svētku karogu. Nu nāca svētku komiteja, tad abi svētku diriģenti (Bētiņš un Zīle) un tiem pakaļ
                          viss dziedātāju pulks ar Skujenes dziedātāju biedrības kori priekšgalā. Pašā pēdējā galā gāja atkal
                          kārtībnieki. Pašā vidū šai virknē bij otris kara mūziķis. – Kad svētku karogu iz biedrības nama
                          iznesa, tad sāka mūziķis spēlēt un visi citi karogi vicināti. Tūkstošiem stāvēja ļaudis gar abām
                          ielas pusēm. Tāpat pie Ķeizara dārza tūkstošiem klausītāji dziedātājus jau gaidīja. Dziedātāji,
                          Ķeizara dārzā nonākuši, gāja uz tribīni un nolika savus karogus tai gar katru pusi. Pēc maza
                          atpūšanās laika iesākās koncerte, tā kā pēc programma bija nolikts, pulksten 7 vakarā.
                        </p>
                        <p class="text justify f20 p-10">
                          Koncertā kopkora priekšnesumā izskanēja Jāņa Cimzes, Kārļa Baumaņa, Jāņa Bētiņa un citu komponistu
                          dziesmas. Ar īpašu sajūsmu 1873. gada saulgriežu laikā tika uzņemtas “Jāņu dziesmas” ar skanīgi
                          piedziedāto “līgo”. Koncerts turpinājās līdz pat tumsai, kad Ķeizardārzs tika skaisti izgaismots ar
                          laternām un lukturiem.
                        </p>
                      </div>
                      <div style="display:inline-block; width:40%; vertical-align:bottom">
                        <img src="../assets/bildes/93.jpg" alt>
                        <p class="annotation">
                          Koru gājiens no Rīgas latviešu biedrības nama uz dziesmu svētku norises vietu Ķeizardārzā (tagad:
                          Viesturdārzs)
                        </p>

                        <img src="../assets/bildes/94.jpg" style="width:57%" class="m-auto" alt>
                        <p
                          class="annotation"
                        >Pirmo vispārīgo latviešu dziedāšanas svētku izdevums, Rīga, 1873</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pos-a slide-outer" style="top:182px;left:1103px;width:612px">
                  <h2>
                    PIRMO VISPĀRĪGO LATVIEŠU
                    <br>DZIEDĀŠANAS SVĒTKU KORU KARI
                  </h2>
                  <div class="slide-green">
                    <div style="display:inline-block; width:66%">
                      <p class="citats justify p-20">
                        <u>Sestdiena, 1873. gada 28. jūnijs</u>
                        <br>Dziesmu svētku trešā diena bija veltīta koru kariem, kuros piedalījās 5 jauktie un 10 vīru kori.
                        Vērtēšanas komisijā no Rīcības komitejas bija Kārlis Baumanis, no Kurzemes koriem – diriģenti Jānis
                        Bētiņš un Teodors Veidemanis, no Vidzemes koriem – Jānis Cimze un Indriķis Zīle. Katram korim bija
                        jādzied divas dziesmas. Ap 11 – iem vakarā Rīgas Latviešu biedrības namā atvadu vakariņu laikā tika
                        paziņoti uzvarētāji:
                        <br>
                        <br>“Vienu lielāku karoga kāta virsuni (sudraba liru) dabūja Mazsalaces vīru koris.
                        Vienu mazāku karoga kāta virsuni (sudraba liru) dabūja Cēsu jaukts koris.
                        Sudraba biķeri, svētku komitejai dāvātu no kāda latviešu pulciņa Rīgā, dabūja Trikates vīru koris.
                        Zīda banti ar sudraba sprādzi dabūja Straupes vīru koris.
                        Sudraba karoga zīmi dabūja Kokneses jaukts koris un Zīda banti ar sudraba sprādzi dabūja Beverina
                        jaukts koris”.
                      </p>
                    </div>

                    <div style="display:inline-block; width:22%; vertical-align:top">
                      <img src="../assets/bildes/95_.png" alt>
                      <p
                        class="annotation"
                      >Latviešu 1 vispārējo dziedāšanas svētku viena no balvām – sudraba lira</p>
                    </div>
                    <div
                      style="width:12%; display:inline-block; height:350px; vertical-align:top;margin-top:45px !important"
                    >
                      <div class="hor-next" style="margin-left:10px !important;">
                        <img src="../assets/zimes/right.png" alt>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <br>
                <br>
                <h2>
                  PIRMO VISPĀRĪGO
                  <br>LATVIEŠU DZIEDĀŠANAS
                  <br>SVĒTKU VIRSDIRIĢENTI
                  <br>
                </h2>
                <div class="pos-a slide-green" style="top:287px;left:17px;width:468px">
                  <div
                    style="width:15%; display:inline-block; height:300px; vertical-align:top;margin-top:0px !important"
                  >
                    <div class="hor-prev" style="height:300px; margin-right:10px !important">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>

                  <div style="display:inline-block;width:85%">
                    <img src="../assets/bildes/96.jpg" alt>
                    <p
                      class="annotation"
                    >Pirmo vispārīgo latviešu dziedāšanas svētku estrāde Ķeizardārzā (tagad: Viesturdārzs)</p>
                    <p class="text justify f18">
                      Pirmo vispārīgo latviešu dziedāšanas svētku laicīgās mūzikas koncerti un dziesmu kari notiek
                      Ķeizardārzā speciāli izveidotā estrādē. Kopkori veido 1003 dziedātāji un tajā dominē vīru balsis.
                      Virsdiriģenti ir Jānis Bētiņš no Kurzemes un Indriķis Zīle no Vidzemes
                    </p>
                  </div>
                </div>
                <div class="pos-a slide-green" style="top:15px;left:507px;width:588px">
                  <div class style="display:inline-block; width:45%">
                    <img src="../assets/bildes/97_png.png" style="width:80%" class="m-auto" alt>
                    <p class="annotation">
                      Jānis Bētiņš (1830–1912), skolotājs, diriģents, ērģelnieks, ērģeļu konstruktors un Kurzemes
                      latviešu mūzikas dzīves organizators 19. gadsimta otrajā pusē. Viņa devums Kurzemes mūzikas
                      attīstības jomā tiek vērtēts tāpat kā Jāņa Cimzes darbība latviešu pirmās atmodas laikā Vidzemē
                    </p>
                    <img src="../assets/bildes/98_.png" style="width:70%" class="m-auto" alt>
                    <p class="annotation">
                      1978. gadā pie bijušā skolotāju semināra ēkas atklāts piemiņas akmens, bet
                      1986. gada 8. jūnijā – skulptores Olitas Nigules un arhitekta Teodora Niguļa veidots piemineklis
                    </p>
                  </div>
                  <div class="p-10" style="display:inline-block; width:55%; vertical-align:top">
                    <p class="text justify f18">
                      Jānis Bētiņš mācījies mūziku Irlavas skolotāju seminārā, kur viņa pedagogs ir pats semināra
                      direktors un ērģelnieks Kārlis Sadovskis, kā arī vijoļspēles pasniedzējs V. Denkevics. 1848. gadā
                      Jānis Bētiņš no Irlavas skolotāju semināra izstājas un dodas papildināt savas muzikālās zināšanas
                      uz Jelgavu pie tolaik slavena ērģelnieka un mūzikas teorētiķa Rūdolfa Posteļa. 1849. gadā viņš
                      atgriežas seminārā jau kā mūzikas pedagogs un nostrādā Irlavā līdz pat 1883. gadam. Šajā laikā
                      izveidojis un vadījis jaukto kori, ar kuru piedalījies paša organizētajos pirmajos Kurzemes dziesmu
                      svētkos 1870. gadā Dobelē. Irlavas koris diriģenta Jāņa Bētiņa vadībā 1873. gadā uzstājas arī
                      pirmajos vispārējos latviešu dziesmu svētkos Rīgā, kur ar 101 dziedātāju ir viens no lielākajiem
                      kolektīviem. Jānis Bētiņš ir arī Irlavas pagasta Sātu draudzes ērģelnieks (1860-1905), kā arī
                      piedalās ērģeļu būvē Tukuma apkaimē.
                    </p>
                    <br>
                    <br>
                    <img src="../assets/bildes/99.jpg" style="width:70%" class="m-auto" alt>
                    <p class="annotation">
                      Sātu baznīca un ērģeles, uz kurām gandrīz piecdesmit gadus spēlējis Kurzemes latviešu mūzikas
                      tradīciju pamatlicējs Jānis Bētiņš
                    </p>
                  </div>
                </div>
                <div class="pos-a slide-green" style="top:15px;left:1116px;width:588px">
                  <div style="display:inline-block;width:80%">
                    <div style="display:inline-block;width:50%; vertical-align:top">
                      <img src="../assets/bildes/100_.png" style="width:100%" class="m-auto" alt>
                      <p class="annotation">
                        Indriķis Zīle (1841–1919), skolotājs, diriģents, ērģelnieks, komponists,
                        Jāņa Cimzes skolnieks un viņa darba turpinātājs. Viņš ir viens no latviešu dziesmu svētku
                        tradīcijas aizsācējiem, pirmo trīs latviešu vispārīgo dziesmu svētku virsdiriģents
                      </p>
                    </div>
                    <div style="display:inline-block;width:50%">
                      <img
                        src="../assets/bildes/101_.png"
                        class="m-auto"
                        style="width:100%;padding-top:250px;"
                        alt
                      >
                      <p class="annotation">
                        Pirmo vispārīgo latviešu dziesmu svētku virsdiriģentam Indriķim Zīlem veltīts cilnis, atrodas
                        mūziķa dzimtenē Alojas muzejā. Tēlnieks Kārlis Baumanis
                      </p>
                    </div>
                    <img src="../assets/bildes/102_.png" style="width:90%" class="m-auto" alt>
                    <p class="annotation">
                      Pirmo vispārējo latviešu dziesmu svētku virsdiriģenta zizlis,
                      <br>dāvināts Indriķim Zīlem
                    </p>
                  </div>
                  <div
                    style="width:15%; display:inline-block; height:350px; vertical-align:top;margin-top:259px !important"
                  >
                    <div class="hor-next" style="margin-left:10px !important">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <br>
                <br>
                <h2>
                  PIRMO VISPĀRĪGO
                  <br>LATVIEŠU DZIEDĀŠANAS
                  <br>SVĒTKU DALĪBNIEKI
                  <br>
                </h2>
                <div class="pos-a slide-green" style="top:287px;left:17px;width:409px">
                  <div
                    style="width:20%; display:inline-block; height:350px; vertical-align:top;margin-top:0px !important"
                  >
                    <div class="hor-prev" style="height:343px">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>

                  <div style="display:inline-block;width:80%">
                    <hr>
                    <hr>
                    <p class="text f18 p-10 justify">
                      Pirmajos vispārīgajos latviešu dziesmu svētkos piedalās kori no Vidzemes, Kurzemes un Rīgas.
                      <br>
                      <br>Tiek dziedātas pirmās latviešu kora oriģināldziesmas un tautas melodiju
                      apdares. Atklāšanas aktā Latviešu biedrības namā pirmo reizi atskaņo Baumaņu Kārļa dziesmu
                      "Dievs, svētī Latviju!", kas 1920. gadā kļūst par Latvijas valsts himnu.
                    </p>
                  </div>
                </div>
                <div class="pos-a slide-green" style="top:0px;left:443px;width:1262px">
                  <div style="display:inline-block;width:90%">
                    <img src="../assets/bildes/karte.png" style="width:100%" class="m-auto" alt>
                  </div>

                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:300px !important"
                  >
                    <div class="hor-next" style="margin-left:10px !important">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-green" style="top:51px;left:17px;width:532px">
                  <div
                    style="width:15%; display:inline-block; height:350px; vertical-align:top;margin-top:241px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>

                  <div style="display:inline-block;width:80%">
                    <img src="../assets/bildes/110.jpg" style="width:70%" class="m-auto" alt>
                    <p class="annotation">Unesco logo</p>
                    <p class="text justify f18 p-20">
                      Pirmie vispārējie latviešu dziedāšanas svētki 1873. gadā ir pirmās nacionālās atmodas kulminācijas
                      punkts. Gatavošanās dziesmu svētkiem mudina muzikāli izglītotos latviešu sacerēt tautasdziesmu
                      apdares un oriģināldziesmas. Visos Vidzemes un Kurzemes novados aktivizējas koru darbība svētku
                      repertuāra apgūšanai. Pirmie dziedāšanas svētki kļūst par visas tautas svētkiem, rada milzīgu
                      emocionālu un garīgu pacēlumu latviešu vidū un parāda citām nācijām tautasdziesmas skaistumu un
                      spēku. Tie iedibina latviešu dziesmu svētku tradīciju ar nemainīgu norises kārtību, kuras galvenās
                      sastāvdaļas ir dziesmu svētku gājiens, kopkora koncerts un koru kari. Vispārīgie dziesmu svētki, kas
                      aizsākas un plaši izplatās 19. gadsimtā Rietumeiropā, mūsdienās saglabājušies tikai Latvijā, Igaunijā
                      un Lietuvā, kur ieguvuši dziesmotas tautas manifestācijas raksturu. Latvijā Dziesmu svētki notiek
                      regulāri ik pēc pieciem gadiem. Novērtējot šīs tradīcijas noturību, Dziesmu svētki 2003. gadā
                      iekļauti UNESCO Reprezentatīvajā cilvēces nemateriālās kultūras mantojumā sarakstā kā mutvārdu un
                      nemateriālās kultūras meistardarbs (Masterpiece of the Oral and Intangible Heritage of Humanity)
                    </p>
                  </div>
                  <div
                    style="width:5%; display:inline-block; height:350px; vertical-align:top;margin-top:241px !important"
                  >
                    <div class="hor-next"></div>
                  </div>
                </div>
              </div>
            </a>
          </slick22>
        </div>
      </div>
    </div>
    <!-- Himmna -->
    <div class="slide bg-4" v-if="this.current == 11 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:284px;right:106px;"
        >
        <br>Atmodas simboli
      </div>
      <div class="layout-2">
        <div class="content">
          <h1 class="slide-heading">
            Himmna
            <hr style="width:14.5%">
          </h1>
          <div class="col-3 h-100">
            <div class="col-outer">
              <h2>Vēsture</h2>
              <div class="slide-green h-100 p-20">
                <p class="text f18 justify p-20">
                  Mūsdienu Latvijas valsts himnas rašanās saistīta ar pirmās nacionālās atmodas laika kordziedāšanas
                  tradīcijām 19. gadsimta vidū. Sākotnēji tā sarakstīta kā vīru kora dziesma. Tolaik tāda valsts vai
                  administratīva teritorija kā “Latvija” vēl nepastāv, tāpēc dziesmas oriģinālo tekstu, kas sākās ar
                  vārdiem “Dievs, svētī Latviju!” cenzūra aizliedz. To vietā tiek lietotas rindas “Dievs, svētī Baltiju!”
                  Pirmo reizi dziesmas tekstu un notis iespiež divos izdevumos 1874. gadā Pēterburgā. Pirmais no tiem ir krājums
                  "Līgo", kuru Baltijas guberņu valdība konfiscē un liek Rīgā Daugavmalā publiski sadedzināt.
                  Saglabājušies tikai trīs krājuma eksemplāri, kas tagad ir bibliogrāfisks retums. Otrs ir krājums
                  "Austra". Neskatoties uz cenzūras aizliegumu, dziesma “Dievs, svētī Latviju!” sajūsmina latviešus un
                  tiek dziedāta visos novados. To iedēvē par latviešu tautas lūgšanu, bet dramaturgs un režisors Ādolfs
                  Alunāns ir pirmais, kurš to nosauc par latviešu tautas himnu
                </p>
                <div style="text-align:center">
                  <img style="width:90%" class="m-auto" src="../assets/bildes/82.jpg" alt>
                  <p class="annotation p-20">
                    Ieskats 1874. gadā Pēterburgā izdotajā dziesmu krājumā "Līgo", kurā iespiesta
                    Baumaņu Kārļa dziesma “Dievs, svētī Baltiju!”
                  </p>
                </div>
                <div class="bottom-arrow" style="margin-top:10px !important"></div>
              </div>
            </div>
            <div class="col-outer">
              <h2>Autors</h2>
              <div class="slide-green h-100 p-20">
                <div style="text-align:center">
                  <img style="width:45%" class="m-auto" src="../assets/bildes/83.jpg" alt>
                  <p
                    class="annotation p-10"
                  >Latvijas himnas autoram Kārlim Baumanim (1835–1905) veltītā pastmarka, izdota 2005. gada 21. maijā</p>
                  <p class="text f18 p-20 justify">
                    Latviešu tautas lūgšanas “Dievs, svētī Latviju!” vārdu un teksta autors ir skolotājs, dzejnieks un
                    komponists Kārlis Baumanis. Pēc Cimzes skolotāju semināra beigšanas 1856. gadā viņš dažus
                    gadus strādā savā dzimtajā Viļķenes pagastā par mājskolotāju Ķirbižu muižas īpašnieka grāfa Aderkasa
                    (von Aderkas) ģimenē. 1858. gadā Kārlis Baumanis pārceļas uz Pēterburgu, kur dažu mēnešu laikā
                    nokārto eksāmenus un iegūst mājskolotāja diplomu. Sākumā viņš strādā par audzinātāju un kaligrāfijas
                    skolotāju Annas baznīcas skolā, vēlāk – par vācu valodas skolotāju Reformātu skolā un no 1870. gada –
                    Smoļnija Dižciltīgo jaunavu institūtā. Uzturoties Pēterburgā, Baumaņu Kārlis, kā viņu tolaik dēvē,
                    1862. gadā iestājas Latviešu lasāmajā biedrībā un darbojas “Pēterburgas Avīžu” redakcijā.
                    Papildinājis zināšanas kompozīcijā un iemaņas klavierspēlē, viņš 1860. gadu beigās saraksta 36
                    latviešu tautasdziesmu apdares un kora dziesmas, kas 1874. gadā publicētas Pēterburgā izdotajā
                    dziesmu krājumā “Austra” un “Līgo”. 1881. gadā atgriežas dzimtenē, kur iesaistās kultūras un
                    sabiedriskajā dzīvē.
                  </p>
                </div>
                <div class="bottom-arrow" style="margin-top:10px !important"></div>
              </div>
            </div>
            <div class="col-outer">
              <h2>Himna un dziesmu svētki</h2>
              <div class="slide-green h-100 p-20">
                <div style="text-align:center">
                  <img class="m-auto" src="../assets/bildes/84.jpg" alt>
                  <p class="annotation p-20">
                    Latvijas himnas teksts un notis uz Kārļa Baumaņa
                    piemiņas zīmes Pirmo vispārīgo latviešu dziesmu svētku vietā
                    Rīgā Viesturdārzā. Piemiņas zīmes autors tēlnieks Bruno Strautiņš
                  </p>
                  <p class="text f18 p-20 justify">
                    Trīs no Pēterburgā sakomponētājām kora dziesmām Kārlis Baumanis aizsūta Pirmo vispārējo latviešu
                    dziesmu svētku organizācijas komitejai. "Tēvijas dziesmu" un "Daugavas zvejnieku dziesmu" iekļauj kopkora
                    repertuārā, bet dziesmu "Dievs, svētī Latviju!" cenzūra aizliedz. Taču tā tomēr izskan dziesmu svētku
                    atklāšanas pasākumā Rīgas Latviešu biedrības nama zālē 1873. gada 23. jūnijā. Dziesmu izpilda
                    Baltijas skolotāju semināra vīru koris diriģenta Jāņa Dreiberģa vadībā. Trešajos dziesmu svētkos
                    1888. gadā to atskaņo simfoniskais orķestris, un 1895. gadā dziesma jau iegūst neoficiālas latviešu
                    nacionālās himnas statusu. Ar 1920. gada 4. jūnija Latvijas Satversmes lēmumu Kārļa Baumaņa dziesma
                    „Dievs, svētī Latviju!” kļūst par Latvijas valsts himnu.
                  </p>
                </div>
                <div class="bottom-arrow" style="margin-top:39px !important"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tautas dziemas -->
    <div class="slide bg-4" v-if="this.current == 12 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:284px;right:106px;"
        >
        <br>Atmodas simboli
      </div>
      <div class="layout-2">
        <div class="content">
          <h1 class="slide-heading">
            LATVIEŠU TAUTAS DZIESMAS UN DAINU SKAPIS
            <hr style="width:40.5%">
          </h1>
          <slick23 :options="slickOptions2">
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-green" style=" width:846px; top:0px; left:0px;">
                  <div>
                    <div
                      style="display:inline-block;  width:55%; vertical-align:bottom"
                      class="p-10"
                    >
                      <img src="../assets/bildes/105.jpg" alt>
                    </div>
                    <div
                      style="display:inline-block;  width:35%; vertical-align:baseline; border-left:5px solid #333"
                      class="p-10 dzejolis"
                    >
                      Divi vien, divi vien,
                      <br>Kas miedziņa negulēja:
                      <br>Ūdens miega negulēja,
                      <br>Saule gaisu tecēdama.
                      <br>
                    </div>
                  </div>
                  <div>
                    <div style="display:inline-block; width:10%"></div>
                    <div
                      style="display:inline-block;  width:55%; vertical-align:bottom"
                      class="p-10"
                    >
                      <img src="../assets/bildes/106.jpg" alt>
                    </div>
                    <div
                      style="display:inline-block;  width:35%; vertical-align:baseline; border-left:5px solid #333"
                      class="p-10 dzejolis"
                    >
                      Sudradots gailis dzied
                      <br>Zeltupītes maliņā,
                      <br>Lai cēlās tās meitiņas,
                      <br>Sudraba vērpējiņas
                      <br>
                    </div>
                  </div>
                  <p class="annotation">
                    Tautas dziesmu vārdi rokrakstā un to transkripcija drukā.
                    <br>Pierakstītas Cēsu apriņķa Kalsnavas pagastā (iesūtījis K. Mieriņš) un Dūrē Vārmes pagastā (iesūtījis
                    F. Simanovičs).
                    <br>Rokraksts glabājas Dainu skapī Latvijas Nacionālajā bibliotēkā
                    <br>
                  </p>
                </div>

                <div class="pos-a slide-green p-20" style="width:340px; left:264px; top:384px;">
                  <p class="text justify f20">
                    Latviešu tautasdziesmas – arhaiska mutvārdu poēzija, kas atspoguļo tautas raksturu, tradīcijas,
                    rituālus, paradumus, vēstures notikumus. Par tekstu senumu liecina gan to saturs, gan forma, gan
                    izteiksmes līdzekļi. Sastopamas arī pēc Eiropā pazīstamo lirisko dziesmu vai liroepisko balāžu
                    parauga darinātas latviešu tautas dziesmas, taču par senākajām uzskata bezsižeta četrrindes.
                  </p>
                </div>
                <div class="pos-a slide-green p-20" style="width:484px; left:624px; top:415px;">
                  <img src="../assets/bildes/107.jpg" style="width:90%" class="m-auto" alt>
                  <p class="annotation">
                    Jēkaba Bīnes glezna "Dievs, Laima, Māra" (1931), kurā simboliski attēlotas latviešu tautasdziesmās
                    minētās dievības.
                  </p>
                </div>
                <div class="pos-a slide-green p-20" style="width:297px; left:1127px; top:707px;">
                  <p class="dzejolis" style="text-align:left;">
                    Dieviņš kannu sadauzīja
                    <br>Pa vienam gabalam,
                    <br>Mīļā Māra sastīpoja
                    <br>Ar sudraba stīpiņām.
                    <br>
                  </p>
                </div>
                <div class="pos-a slide-green p-20" style="width:500px; left:1127px; top:150px;">
                  <div style="display:inline-block;width:87%">
                    <p class="dzejolis m-auto" style="padding:20px;text-align:center">
                      Kas varēja to darīt
                      <br>Vidū jūras kaudzi mest?
                      <br>To darīja Dieva dēls,
                      <br>Saules meitu precēdams
                      <br>
                    </p>
                    <div
                      style="border-bottom:4px solid #333; width:30%;margin-bottom:5px"
                      class="m-auto"
                    ></div>
                    <br>
                    <p class="text justify f20">
                      Vissenākajās latviešu tautasdziesmās atklājas baltu senču izpratne par pasaules radīšanu, visuma
                      uzbūvi un debesu spīdekļiem. Pasaulē tās izmanto kā nozīmīgu indoeiropiešu arhaisko mītisko un
                      kosmogonisko priekšstatu pētniecības avotu. Visums latviešu skatījumā ir zelta kanna – trauks jeb
                      telpa. Ar trauka lauskām jeb vizuļiem domāta zvaigžņotā debess. Savukārt, pasaules radīšana, tāpat kā
                      daudzu citu tautu mītos, saistīta ar ūdeni, jūru jeb pirmatnējo okeānu, kura vidū atrodas zeme
                      (kaudze vidū jūras). Lai pasauli radītu un tā varētu pastāvēt nepieciešama vīrišķās (Dieviņš, Dieva
                      dēls) un sievišķās (Māra, Saules meita) enerģijas saplūšana.
                    </p>
                  </div>
                  <div
                    style="width:13%; display:inline-block; height:350px; vertical-align:top;margin-top:50px !important"
                  >
                    <div class="hor-next" style="margin-left:5px !important">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-green p-20" style="width:615px; left:0px; top:166px;">
                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:50px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>

                  <div style="display:inline-block;width:90%">
                    <img src="../assets/bildes/108.jpg" style="width:90%" class="m-auto p-10" alt>
                    <img src="../assets/bildes/109.jpg" style="width:90%" class="m-auto p-10" alt>
                    <p class="annotation">Dainu skapis</p>
                  </div>
                </div>
                <div class="pos-a slide-green p-20" style="width:449px; left:626px; top:97px;">
                  <p class="text justify f20">
                    Dainu skapis top pēc latviešu tautasdziesmu krājuma „Latvju Dainas” sastādītāja un redaktora Krišjāņa
                    Barona (1835–1923) ieceres 1880. gadā Maskavā. Tajā izveidotas 70 atvilktnes ar 20 sadaļām, kurās
                    Krišjānis Barons sistematizē un ievieto no visas Latvijas teritorijas iesūtītos tautas dziesmu
                    manuskriptus. Atvilktnes apzīmētas ar „Latvju Dainu” dziesmu tipu un izdevuma sējumu numuriem. Bez
                    tām ir arī trīs lielākas atvilktnes, kurās glabājas citi vērtīgi un nozīmīgi dokumenti – K. Baronam
                    rakstītās vēstules, viņa iesāktais tautas dziesmu vārdu rādītājs un daži nelieli priekšmeti.
                  </p>
                </div>
                <div class="pos-a slide-green p-20" style="width:449px; left:626px; top:450px;">
                  <img src="../assets/bildes/110.jpg" style="width:70%" class="m-auto" alt>
                  <p class="annotation">Unesco logo</p>
                  <p class="text justify f20">
                    Novērtējot šo folkloras tekstu unikalitāti un saikni ar joprojām dzīvajām latviešu nemateriālās
                    kultūras tradīcijām mūsdienās, Dainu skapis 2001. gadā iekļauts UNESCO programmas “Pasaules atmiņa”
                    (Memory of the World) starptautiskajā reģistrā. Lai padarītu tā saturu pieejamu sabiedrībai visā
                    pasaulē, 2006. gadā izveidota Dainu skapja virtuāla versija: www.dainuskapis.lv
                  </p>
                </div>
                <div
                  class="pos-a slide-green"
                  style="padding:40px !important;width:579px; left:1128px; top:208px;"
                >
                  <div style="display:inline-block;width:90%">
                    <img src="../assets/bildes/111.jpg" style="width:100%" class="m-auto" alt>
                    <p class="dzejolis p-20" style="text-align:center;">
                      Sukā, māte, man galviņu,
                      <br>Pin līdzenus man matiņus,
                      <br>Lai mūžiņš līdzināts
                      <br>Pie tautieša tēva dēla.
                      <br>
                    </p>
                    <div
                      style="border-bottom:4px solid #333; width:30%; margin-bottom:5px"
                      class="m-auto"
                    ></div>
                    <br>
                    <p class="annotation">
                      Viena no piecpadsmit Turaidā pierakstītajām tautasdziesmām, kas glabājas Dainu skapī. Manuskripts un
                      tā transkripcija. Pierakstījis un iesūtījis Alaunu Reinis
                    </p>
                  </div>
                  <div style="width:10%; display:inline-block; height:350px; vertical-align:top;">
                    <div class="hor-prev" style="height:100%"></div>
                  </div>
                </div>
              </div>
            </a>
          </slick23>
        </div>
      </div>
    </div>
    <!-- Karogs -->
    <div class="slide bg-4" v-if="this.current == 13 && this.language == 1">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:284px;right:106px;"
        >
        <br>Atmodas simboli
      </div>
      <div class="layout-2">
        <div class="content">
          <h1 class="slide-heading">
            Karogs
            <hr style="width:14.5%">
          </h1>
          <slick21 :options="slickOptions2">
            <a>
              <div class="absolute-hor-slide">
                <h2>Vēsture</h2>
                <div class="pos-a slide-green p-20" style=" width:542px; top:60px; left:0px;">
                  <p class="text f18 justify">
                    Pirmās ziņas par mūsdienu Latvijas karoga izcelsmi lasāmas
                    <br>13. gadsimta beigās sarakstītajā “Atskaņu
                    hronikā”. Tās fragmentā pieminētais ordeņa brālis ir Livonijas ordeņa landmaršals Gerhards no
                    Kacenelnbogenes, kurš 1279. gadā cīņā pret zemgaļiem vadījis krustnešu un Autīnes letu (latgaļu)
                    apvienoto karaspēku. Latgaļu karotāji kā atšķirības zīmi nesuši sarkanbaltsarkanu karogu.
                  </p>
                  <br>
                  <div>
                    <div style="display:inline-block; width:40%; vertical-align:top" class="p-10">
                      <img src="../assets/bildes/72.jpg" alt>
                    </div>
                    <div style="display:inline-block; width:60%; vertical-align:top" class="p-10">
                      <p class="citats">
                        No Cēsīm Rīgā atnācis
                        <br>bij brālis kāds un atvedis
                        <br>simts zemessargu sevim līdz,
                        <br>lai zemgaļus tie sakaut līdz.
                        <br>To dzirdējuši nāca nu
                        <br>
                        <span class="red">
                          ar karogu tie sarkanu,
                          <br>kam vidū balta josla bija.
                        </span>
                        <br>To pirmo reizi ieraudzīja
                        <br>pie Cēsīm, tur tas zināms nācis
                        <br>un letu zemē plīvot sācis...
                        <br>
                      </p>
                    </div>
                    <p
                      class="annotation"
                    >“Atskaņu hronikas” rokraksta fragments ar vēstījumu par sarkanbaltsarkano karogu. 1290–1296</p>
                  </div>
                </div>
                <div class="pos-a slide-green" style=" width:542px; top:633px; left:0px;">
                  <p class="text justify f18 p-10">
                    Tērbatas universitātes pasniedzējs Jēkabs Lautenbahs-Jūsmiņš
                    <br>19. gadsimta vidū vērš studentu uzmanību
                    uz “Atskaņu hronikā” aprakstīto letu (latgaļu) karogu. Tā sarkanbaltsarkanās krāsas kā latviešiem
                    raksturīgu simboliku pirmoreiz izmanto Tērbatas universitātes studentu korporācija “Lettonia”.
                    Nedaudz vēlāk dzejnieks Auseklis savā
                    <br>1879. gadā sarakstītajā dzejolī “Gaismas pils” rakstiski
                    apliecina leģendāro latgaļu karogu kā latviešu pirmās atmodas simbolu.
                  </p>
                </div>
                <div class="pos-a slide-green" style=" width:235px; top:0px; left:570px;">
                  <img src="../assets/bildes/73_.png" class="m-auto" style="width:90%" alt>
                  <p class="annotation p-10">
                    Auseklis (Miķelis Krogzemis)
                    <br>(1850–1879)
                  </p>
                </div>
                <div class="pos-a slide-green" style=" width:235px; top:400px; left:570px;">
                  <img src="../assets/bildes/74_png.png" class="m-auto" style="width:90%" alt>
                  <p class="annotation p-10">
                    Jēkabs Lautenbahs-Jūsmiņš (1847–1928), Tartu (Tērbatas) universitātes teoloģijas fakultātes students
                    <br>(1875–1878), vēlāk – latviešu valodas lektora vietas izpildītājs Tartu (Tērbatas) universitātes
                    Vēstures un filozofijas fakultātē. 1890. RMM
                  </p>
                </div>
                <div class="pos-a slide-green" style=" width:312px; top:0px; left:830px;">
                  <p class="dzejolis p-20 f14" style="line-height:1.2">
                    <span style="font-weight:bold">GAISMAS PILS</span>
                    <br>
                    <br>Kurzemīte, Dievzemīte,
                    <br>Brīvas tautas auklētāj.
                    <br>Kur palika sirmie dievi?
                    <br>Brīvie tautas dēliņi?
                    <br>
                    <br>Tie līgoja vecos laikos
                    <br>Gaismas kalna galotnē.
                    <br>Visapkārt egļu meži,
                    <br>Vidū gaiša tautas pils.
                    <br>
                    <br>Zelta stabiem, zītar - jumtu,
                    <br>Sidrabotiem pamatiem.
                    <br>To negāza gaisa vētras,
                    <br>Kara viļņu bangojums.
                    <br>
                    <br>Asiņainas dienas ausa
                    <br>Tēvu zemes ielejā;
                    <br>Vergu valgā tauta nāca,
                    <br>Nāvē krita varoņi.
                    <br>
                    <br>Ātri grima, ātri zuda
                    <br>Gaismas kalna staltā pils.
                    <br>Tur guļ mūsu tēvu dievi!
                    <br>Tautas gara greznumi.
                    <br>
                    <br>Sirmajami ozolami
                    <br>Pēdīgajo ziedu dod:
                    <br>Tas slēpj svētu piles vārdu
                    <br>Dziļās siržu rētiņās.
                    <br>
                    <br>Ja kas vārdu uzminētu,
                    <br>Augšām celtos vecā pils!
                    <br>Tālu laistu tautas slavu,
                    <br>Gaismas starus margodam.
                    <br>
                    <br>

                    <span class="red">
                      Zilā gaisā plivinātos
                      <br>Sarkanbalti karogi,
                    </span>
                    <br>Dobji, dobji atskanētu
                    <br>Sirmo garu daiņojums.
                    <br>
                    <br>Tautas dēli uzminēja
                    <br>Sen aizmirstu svētumu:
                    <br>Gaismu sauca, gaisma ausa,
                    <br>Augšām cēlās Gaismas pils!
                    <br>
                    <br>
                  </p>
                </div>
                <div class="pos-a slide-green" style=" width:538px; top:0px; left:1160px;">
                  <div style="display:inline-block;width:85%">
                    <img src="../assets/bildes/75.jpg" alt>
                    <p class="annotation p-20">
                      Voldemāra Vimbas alegoriskā glezna “Saules kauja”. 1930. Kaujā pie Saules (1236) attēloti karotāji ar
                      leģendā un “Atskaņu hronikā” minēto sarkanbaltsarkano karogu
                    </p>
                    <p class="text justify f18 p-10">
                      „Atskaņu hronikā“ minētie fakti pārtapuši vairākos nostāstos un teikās, kas skaidro Latvijas karoga
                      rašanos. Viena no tām vēsta: “Sensenos laikos latvieši cīnījās ar iebrucējiem – bruņiniekiem par savu
                      brīvību. Kādā kaujā latvieši ieguva ienaidnieka balto karogu, bet tanī pašā kaujā ievainoja arī
                      latvju virsaiti. Latvieši iegūto balto karogu noklājuši zemē un uz tā noguldījuši ievainoto vadoni.
                      Tas sasaucis ap sevi visus karotājus un teicis, lai karotāji apsolās cīnīties, līdz ienaidnieks būs
                      padzīts un dzimtā zeme brīva. Visi to arī apsolījuši. Kad virsaitis nomiris, cīņas biedri viņu
                      nocēluši no karoga, kas bijis gluži sarkans no asinīm, palikusi tikai balta vieta, kur atradies
                      ievainotā ķermenis. Par vadoņa nāvi noskumušie un sadusmotie latvieši piestiprinājuši asinīm
                      notraipīto karogu pie šķēpa, gājuši cīņā un padzinuši ienaidnieku. Tas arī esot bijis latviešu
                      karogs”
                    </p>
                  </div>
                  <div
                    style="width:15%; display:inline-block; height:350px; vertical-align:top;margin-top:225px !important"
                  >
                    <div class="hor-next" style="margin-left:10px !important">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <h2>
                  SARKANBALTSARKANAIS KAROGS
                  <br>UN DZIESMU SVĒTKI
                </h2>
                <div class="pos-a slide-green p-20" style=" width:561px; top:60px; left:0px;">
                  <div
                    style="width:15%; display:inline-block; height:350px; vertical-align:top;margin-top:114px !important; margin-right:15px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>
                  <div style="display:inline-block;width:80%">
                    <div>
                      <img src="../assets/bildes/76.jpg" alt>

                      <p class="annotation p-20">
                        Pirmo vispārējo latviešu dziesmu svētku karogs XXV latviešu dziesmu svētku dalībnieku gājienā 2013.
                        gada 7. jūlijā Rīgā
                      </p>
                    </div>
                    <p
                      class="text f18 justify"
                    >Pirmo vispārējo latviešu dziedāšanas svētku simbolikā dominē Latvijas karogam raksturīgie sarkanbalto krāsu toņi. Tie ir dziesmu svētkiem speciāli šūdinātā karoga pamatā. Arī Tērbatas universitātes stundenti, kuriem uzticēta kārtības nodrošināšana svētku laikā, kā atšķirības zīmi nēsā savai korporācijai tradicionālās sarkanbaltās lentas.</p>
                  </div>
                </div>
                <div class="pos-a slide-green p-20" style=" width:355px; top:0px; left:673px;">
                  <img src="../assets/bildes/77_.png" alt>
                  <p class="annotation p-20">
                    Pirmo vispārējo latviešu dziedāšanas svētku karogs “Līgo”, šūts karalisko galma karogu darbnīcā
                    Leipcigā. RVKM
                  </p>
                </div>
                <div class="pos-a slide-green p-20" style=" width:680px; top:222px; left:1065px;">
                  <div style="width:80%; display:inline-block;">
                    <p class="citats p-10">
                      Karogs ir priekšpusē no balta zīda, ar platu sarkan-zīda samtu iekantēts. Uz samta ir zelta
                      izrotājumi, un apakšpusē zelta pušķi. Karoga vidus-laukā ir ar zīda pavedieniem izšūta bilde, kas
                      rāda svētu birzi un zem liela un veca ozola apsūnojušu un ar kuplu lapu vītni pušķotu altari. Uz
                      altara deg upuru liesmiņa un dūmi viļņo uz augšu. Pie altara uz kreisās rokas atspiedies stāv vecs
                      vaidelotis, kas savā paceltā labā rokā tura kuplu ozola zaru. Virs karoga uz sarkana samta ir ar
                      zelta burtiem uzšūts "Līgo", un apakšā uz balta zīda ar zelta burtiem ir lasāms: 26. jūnijā 1873.
                      Karoga otra puse ir no sarkana zīda.
                    </p>
                    <div style="float:right;width:50%; border-top:3px solid #000">
                      <p
                        class="annotation p-10 tar"
                      >No pirmo vispārējo latviešu dziesmu svētku Rīcības komitejas priekšnieka Riharda Tomsona apraksta</p>
                    </div>
                  </div>
                  <div
                    style="width:10%; display:inline-block; height:150px; vertical-align:top;margin-top:0px !important; margin-left:10px !important"
                  >
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <h2>
                  SARKANBALTSARKANAIS KAROGS –
                  <br>LATVIJAS VALSTS SIMBOLS
                </h2>
                <div class="pos-a slide-green p-20" style=" width:565px; top:70px; left:0px;">
                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:133px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>
                  <div style="display:inline-block; width:90%">
                    <img src="../assets/bildes/78_.png" style="width:90%" class="m-auto" alt>
                    <p class="annotation p-10 pt0">
                      Līdz mūsdienām saglabājies pirmais sarkanbaltsarkanais karogs, ko pēc pedagoga un žurnālista Jāņa
                      Lapiņa meta 1916. gada otrajā pusē izgatavo viņa skolniece, Valmieras bēgļu patversmes skolotāja
                      Marianna Straumane
                    </p>
                    <p class="text f18 justify p-10">
                      Latviešu pirmās atmodas laikā lietotā sarkanbaltsarkanā krāsu simbolika plaši tiek izmantota vēlāk
                      1917. gadā latviešu strēlnieku bataljonu karogiem. Pirmais zināmais sarkanbaltsarkanais
                      karogs, kas šūts 1916. gadā, šobrīd glabājas Cēsu vēstures un mākslas muzejā. Tā stūri rotā saule,
                      kas ir latviešu strēlnieku nozīmītes pamatā, tāpēc tā arī izšūta uz karoga.
                    </p>

                    <img style="width:70%;" class="m-auto" src="../assets/bildes/79.jpg" alt>

                    <p class="annotation pt0">
                      Latviešu strēlnieku sarkanbaltsarkanais karogs ar krāsu attiecību 2:1:2 un patriotisku uzrakstu
                      “Mēs
                      ejam atriebt senču vaidus un nepabeigtās cīņas veikt!”. Rezerves latviešu strēlnieku pulka karavīri
                      1917. gada 1. maijā Strenčos. LKM
                    </p>
                  </div>
                </div>

                <div class="pos-a slide-green p-20" style=" width:382px; top:80px; left:680px;">
                  <p class="text f20 justify">
                    Dibinoties valstij, latviešu politiskās aktivitātes saistītas ar sarkanbaltsarkano krāsu kā nacionālo
                    simboliku. To izmanto 1917.gadā, iztrādājot karoga standarta priekšlikumus. No diviem iesūtītajiem
                    karoga metiem tiek izvēlēts mākslinieka Anša Cīruļa un Voldemāra Tones piedāvājums. Tam bija mūsdienu
                    karogam atbilstošas sarkanbaltsarkanās krāsas proporcijas (2:1:2), taču vēl nav noteikts
                    karmīnsarkanais tonis. Ar tādu karogu ir dekorēta tagadējā Nacionālā teātra zāle Latvijas valsts
                    proklomēšanas pasākumā 1918. gada 18. novembrī Rīgā. Oficiāli Latvijas Republikas karogs tiek atzīts
                    ar 1921. gada 15. jūnija Satversmes sapulcē pieņemto likumu
                  </p>
                </div>
                <div class="pos-a slide-green p-20" style=" width:465px; top:540px; left:587px;">
                  <img src="../assets/bildes/80.jpg" style="width:95%" class="m-auto" alt>
                  <p class="annotation p-18">
                    Ar sarkanbaltsarkano karogu dekorētā zāle Latvijas Republikas proklamēšanas akta laikā 1918. gada 18.
                    novembrī. Viļa Rīdzenieka foto, LNVM
                  </p>
                </div>
                <div class="pos-a slide-green p-20" style=" width:572px; top:0px; left:1123px;">
                  <div style="display:inline-block; width:90%">
                    <div>
                      <div style="display:inline-block;width:38%">
                        <img src="../assets/bildes/81.jpg" class="m-auto" alt>
                      </div>
                      <div style="display:inline-block;width:60%">
                        <p class="annotation p-10 tal">
                          Satversmes izstrādāšanas komisijas priekšsēdētājs
                          <br>Marģers Skujenieks (1886–1941)
                        </p>
                      </div>
                    </div>
                    <p class="text f20 justify">
                      Marģera Skujenieka runas fragments no Latvijas Satversmes 1921. gada 15. jūnija sapulces
                      stenogrammas:
                    </p>
                    <p class="citats justify">
                      Valsts karogs ir noteikts sarkans ar baltu svītru, tādos apmēros, ka katra sarkanā strīpa ir divreiz
                      platāka par vidējo balto. Šis karogs mums jau ir nodibinājies, viņš atrodas lietošanā un tādā kārtā
                      šis likums attiecībā uz karogu tikai likuma kārtā noteic to, kas jau patiesi ieviests. Šis karogs ir
                      diezgan laimīgi izvests, jo tam jau vēsturiskas tiesības, jo kāds kroniķis ir atstāstījis gadījumu no
                      13.gadusimteņa, kur latviešu kara pulki gājuši uz Rīgas pusi un nesuši līdzi karogu, kas bijis
                      sarkans ar baltu švītru, un kroniķis saka, ka patiesi es varu apgalvot, ka šis karogs ir latviešu
                      karogs. Tā kā attiecībā uz karogu mums ir noteikts klasisks liecinieks, kas nosaka, kādam jābūt mūsu
                      karogam. Bez tam atsvabināšanas cīņas un kari izcīnīti zem šī sarkan—balti—sarkanā karoga un tamdēļ
                      domāju, ka vispieņemamākais būtu še likumā fiksēt jau pastāvošo karogu.
                    </p>
                  </div>
                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:239px !important"
                  >
                    <div class="hor-prev"></div>
                  </div>
                </div>
              </div>
            </a>
          </slick21>
        </div>
      </div>
    </div>

    <!-- ENGLISH -->
    <!-- Home slide  DONE-->
    <div class="slide bg-home" v-if="this.current == 0  && this.language == 2">
      <div class="home-arrow">
        <a @click="slide(1)">
          <img src="../assets/zimes/2.png" class="animated animated pulse infinite slow" alt>
        </a>
      </div>
      <div class="box">
        <h1 style="text-decoration:none; font-size:32px;">THE LATVIAN NATIONAL AWAKENING</h1>
        <p
          class="f20"
        >The spiritual awakening of the Latvian people is in line with the European civil revolution and the ideas of the national liberation movement in the first half of the 19th century. Under these influences forms the awareness of a community of the Latvian people's and the beginnings of education and culture.</p>
      </div>
    </div>

    <!--main menu slide | Samainīt bildi -->
    <div class="slide bg-menu" v-if="this.current == 1  && this.language == 2">
      <div class="layout-1">
        <div style="width:90%; height:90%; margin:auto !important;">
          <!-- menu image -->
          <img src="../assets/zimes/josla-en.png" style="max-height:100%;float:right;" alt>
          <!-- menu arrows -->
          <img
            @click="slide(3)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:160px;"
            alt
          >
          <img
            @click="slide(2)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:815px;"
            alt
          >
          <img
            @click="slide(4)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:882px;"
            alt
          >
          <img
            @click="slide(5)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:957px;"
            alt
          >
          <img
            @click="slide(6)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:1050px;"
            alt
          >
          <img
            @click="slide(7)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:1157px;"
            alt
          >
          <img
            @click="slide(8)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:535px;left:1219px;"
            alt
          >
          <img
            @click="slide(9)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5-v.png"
            style="position:absolute; top:315px;left:1460px;"
            alt
          >

          <img
            @click="slide(10)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:840px;left:1212px;"
            alt
          >
          <img
            @click="slide(11)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:840px;left:1381px;"
            alt
          >
          <img
            @click="slide(12)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:840px;left:1552px;"
            alt
          >
          <img
            @click="slide(13)"
            class="animated animated pulse infinite fast"
            src="../assets/zimes/5.png"
            style="position:absolute; top:840px;left:1685px;"
            alt
          >
        </div>
      </div>
    </div>

    <!-- Dzimbūšanas atcelšana - Dome -->
    <div class="slide bg-1" v-if="this.current == 2  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>THE ROAD OF THE AWAKENING
      </div>
      <div class="layout-1">
        <div class="side">
          <img class="float-right h-100" src="../assets/zimes/skala-1819.png" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            Abolition of Serfdom in Vidzeme
            <hr style="width:35%">
          </h1>

          <div class="pos-a slide-white" style=" width:400px; height:290px; left:333px; top:141px">
            <p class="text f20 justify p-20">
              Vidzeme in 19th century is part of the Russian Governorate of Livonia. The governorate is not ruled by Russian laws, but is administreted autonomously by the local German Baltic nobiliy throught their power and political institution Landtag (Liefländischer Landtag).
              It is one of the factors leading to the abolition of serfdom in the Governorate of Livonia in 1819 - earlier than in the Russian Empire.
            </p>
          </div>
          <div class="pos-a slide-white p-10" style=" width:405px;  left:634px; top:441px;">
            <img src="../assets/bildes/14.png" alt>
          </div>
        </div>
      </div>
    </div>
    <!-- Brāļu draudzes Done / Skala-->
    <div class="slide bg-1" v-if="this.current == 3  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>THE ROAD OF THE AWAKENING
      </div>
      <div class="layout-1">
        <div class="side">
          <img class="float-right h-100" src="../assets/zimes/skala-1729.png" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            UNITY OF THE BRETHREN –
            <br>BEGINNING OF THE LATVIAN NATIONAL AWAKENING
            <hr style="width:50.5%">
          </h1>

          <div class="pos-a slide-white" style=" width:395px; height:931px; left:131px; top:121px">
            <p class="text f20 justify p-20 pb0">
              <img src="../assets/bildes/15.jpg" alt>
            </p>
            <p
              class="annotation p-10"
            >Symbol and motto of the Herrnhuter is “Vicit Agnus Noster, Eum sequamur” announces of following the God’s lamb sacrificed for the sins of all people</p>
            <p class="text justify f20 p-15">
              Vidzeme Unity of the Brethren (Herrnhuter) have a strong influence in Vidzeme in the 18th-19th century. Congregational meetings with talks and joint singing strengthen the consciousness of the people's unity and establish the first tradition of choir singing. In turn, the publishing of books in Latvian, the setting up of a parish school and founding the teacher seminar, forms the basis for Latvian intelligence. The most studious and talented Herrnhuter become teachers, teacher assistants, literates and musicians. With the Unity of the
              <br>Brethren were connected the founder of the Vidzeme Teacher Seminar and the National tradition of choir singing, Jānis Cimze, teacher, pastor, the initiator of the Song Celebration Juris Neikens, the founders of the national realist literature brothers Kaudzītes, and many other workers of the First Awakening.
            </p>
          </div>

          <div class="pos-a slide-white" style=" width:394px; height:auto; left:545px; top:307px">
            <p
              class="text f20 justify p-20"
            >Following a ban on the Unity of the Brethren (1743-1817), it again activates in the first half of the 19th century. New congregations are being formed, the gathering houses are being restored. One of the Vidzeme Herrnhuter centres of the first half of the 19th century is located in Trapen, where in the Mikuži gathering house around 1854 assembled more than 200 parishioners. In the mid-19th century, the new movement of New Latvian’s takes over the leadership role of the Unity of the Brethren in the spiritual development of Latvians.</p>
          </div>

          <div
            class="pos-a slide-white p-20"
            style=" width:394px; height:auto; left:959px; top:542px"
          >
            <img src="../assets/bildes/16L.jpg" alt>
            <p
              class="annotation justify p-10"
            >Mikuži – one of the gathering houses of Vidzeme Unity of the Brethren in the Trapene parish in 2017</p>
          </div>
          <div class="pos-a slide-white" style=" width:394px; height:auto; left:1379px; top:177px">
            <img src="../assets/bildes/17.jpg" class="p-20 pb0" alt>
            <p
              class="annotation justify p-10"
            >The Mikuži gathering house and the plan of the farmstead</p>
            <p
              class="text f20 justify p-20"
            >The Mikuži gathering house was built in Vidzeme countryside style in 1803, and the building's current form has preserved since the reconstruction of 1872. From the second half of the 19th century to the present, it is used as a prayer house for the evangelical Lutheran congregation.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Dzimtu veidošanās -->
    <div class="slide bg-dzimtas" v-if="this.current == 4  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>THE ROAD OF THE AWAKENING
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1820.png" style="float:right;" class="h-100" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            FORMATION OF EDUCATED FARMERS FAMILIES
            <br>AFTER ABOLITION OF SERFDOM IN VIDZEME
            <hr style="width:40%">
          </h1>
          <!-- Lesiņu dzimta -->
          <div class="slide-white p-20" style="height:415px;">
            <slick2 :options="slickOptions2">
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:25%">
                    <h1
                      class="m-auto"
                      style="text-decoration:none; text-align:center; font-size:28px; padding:0"
                    >The story of Lesiņi family</h1>
                    <p
                      class="text f20 justify"
                    >One of the educated peasant families of the 19th-century Sigulda are Lesiņi, the farmer of Lapsu home in the Paltmale (Paltemal, presently Augšlīgatne) manor. Mārtiņš Lesiņš leads the homemstead, his youngest brother, Pēteris, around 1820, begins lessons at the Sigulda parish teacher Wordermann, in order to take his place in time. After adding to his knowledge in Riga, Pēteris Lesiņš becomes the first Latvian teacher in the Sigulda congregation. His teaching and life are running under the influence of German culture. There is no news that the teacher, Pēteris Lesiņš would have been involved in the Latvian national awakening movement in the first half of the 19th century.</p>
                  </div>
                  <div style="width:15%;">
                    <img src="../assets/bildes/BILDE3.jpg" alt>
                    <p
                      class="annotation"
                    >Location of the Lesiņi family Lapsu home in map and nature in 2017</p>
                  </div>
                  <div style="width:25%">
                    <p class="text f20 justify">
                      A crucial time for the Lesiņi family is 1837, when the farmer of Lapsu home Mārtiņš Lesiņš together with his son’s Jānis family moves to Nītaure, where they died shortly afterwards. On the other hand, Mārtiņš Lesiņš’s third son, Dāvis, goes with his family to the Sērmūkši and, after a year - to the Viļķne private manor. Only the family of the teacher Pēters Lesiņš remains in the Lapsu home, but as farmer of the homestead they appoint Mārtiņš Cīruls from the Kazkāju home.
                      <br>
                      <br>Why the farmer is changed is not known. After the tragic death of his son Kārlis Reinholds in 1848, the teacher's activities of Pēteris Lesiņš in Sigulda congregation are disrupted. The path of his sons Magnus Eduards and Ernests Johans are not known at the moment.
                    </p>
                  </div>
                  <div style="width:25%">
                    <p
                      class="text f20 justify"
                    >The family of Dāvisi Lesiņš, on the other hand, has expanded in the Strobu home of Vilķene private manor, where he was mentioned as a farmer in 1839. Among the offspring of his family are known writers of the 20th century, such as Valdis (Voldemārs) Lesiņš (1881-1932) and his son, Knuts Lesiņš (1909-2000), teacher Hugo Lesiņš, biologist Dace Gertnere (born Lesiņa) and other cultural and social workers.</p>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png">
                    </div>
                  </div>
                </div>
              </a>
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:5%;">
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png">
                    </div>
                  </div>
                  <div style="width:30%">
                    <img src="../assets/bildes/20.jpg" style="width:90%" class="m-auto" alt>
                    <p
                      class="annotation m-auto"
                      style="width:80%"
                    >Sigulda elementary school building at the corner of Līvkalna and Miera street in the late 20th century.</p>

                    <p
                      class="text f20 justify"
                    >Pēteris Lesiņš (ca. 1803–?) a son of the farmer from farmstead “Lapsas” was the first Latvian origin teacher at Sigulda. He worked as a teacher and organist at Sigulda Parish School (1824-1847)</p>
                  </div>
                  <div style="width:30%;">
                    <div style="width:100%" class="m-auto">
                      <img src="../assets/bildes/21.jpg" style="width:80%" class="m-auto" alt>
                      <p
                        class="annotation"
                        style="padding:0"
                      >Sigulda elementary school building at the corner of Līvkalna and Miera street in the late 20th century.</p>
                    </div>
                    <p
                      class="text f16 justify"
                    >Sigulda Parish School has already been mentioned in the documents since 1685. It is known that in the 19th century the school was housed in a single-storey building in place of which, in 1928, a stone building of Sigulda Elementary School was built as shown in the figure above</p>
                  </div>
                  <div style="width:25%">
                    <div class="m-auto" style="width:90%">
                      <img src="../assets/bildes/22.jpg" alt>
                      <p
                        class="annotation"
                      >In the residence of Dāvis Lesiņš in Viļķenes Strobos, now managed by his grandson Hugo Lesiņš, a retired lawyer</p>
                    </div>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png">
                    </div>
                  </div>
                </div>
              </a>
              <a>
                <div style="display:flex;justify-content:space-around;width:80%;">
                  <div style="width:5%;">
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png">
                    </div>
                  </div>
                  <div style="width:17%">
                    <div style="width:90%" class="m-auto">
                      <img src="../assets/bildes/26.jpg" alt>
                      <p
                        class="annotation"
                      >Writer Valdis (Voldemārs) Lesiņš (1881-1932). Portrait from the publication Biographies of Latvian literates (Latviešu rakstniecība biogrāfijās), Riga, 1992, p. 201.</p>
                    </div>
                  </div>
                  <div style="width:35%;">
                    <p
                      class="text f18 justify"
                    >Born in Viļķene, educated at the school of city Limbaži (1897), the Gori-Gork school of surveyors and cruisers in Smolensk Governorate (1900). He travelled to Russia during the course of his work and served in the Russian army's artillery regiment during the First World War (1914-1917). With the coming to power Bolsheviks in 1917 he demobilized and returned around 1921 to the homeland, where in the newly established state of Latvia he works in the Ministry of Agriculture as a special task official (1921-22 and 1930-32), as well as the state land surveyor (1922-30) in Valmiera district. In free moments also finds time for writing. The litterateur Jānis Grīns recalls Valdis Lesiņš as an adventurous reveller of life and a proud romantic whose literary characters are much like the author and talk about “dropping paradoxes and authorisms.” Knuts Lesiņš (1909-2000), the only son Valdis Lesiņš, whose final phase of life passes in emigration in the US, is also known as a publicist, writer and composer.</p>
                  </div>
                  <div style="width:30%">
                    <img src="../assets/bildes/27.jpg" alt>
                    <p
                      class="annotation"
                    >Recording cover design: Knuts Lesiņš songs, performed by his spouse, Valda Lesiņa.</p>
                  </div>
                  <div style="width:1%;">
                    <div class="hor-prev"></div>
                  </div>
                </div>
              </a>
            </slick2>
          </div>
          <br>
          <!-- Krogzemju dzimta -->
          <div class="slide-white p-20" style="height:415px;">
            <slick2 :options="slickOptions2">
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:37%">
                    <h1
                      class="m-auto"
                      style="text-decoration:none; text-align:center; font-size:28px; padding:0"
                    >The story of the Krogzemji family</h1>
                    <p
                      class="text f19 justify"
                    >Around 1795 the forefathers of the Krogzemji family belong to the miller’s kin of the manor. Soon afterwards, they were transferred as the farmers to Krogvieta (tavern-place), and from this came the name Krogzemji. Around 1834, Jēkabs and Anna Krogzemji already manage the Slakteru home of the Stakenberg manor, and in the mid-19th century, manage the Sīpoli homestead of Ungurpils (now Aloja) parish. The contemporaries describe them as hardworking and pious peasants. “On Sundays they rose at three or four in the morning to manage to get to the community centre of the Unity of the Brethren, high noon went to church, and in the evening with delight, wiping tears were singing one song after another.” Jēkabs was a quiet and harsh man, while Anne, though a thoughtful dreamer, was more talkative and intelligent than her husband. She tried to educate her children, to teach the first reading and counting skills. After finishing the parish school, Krogzemji oldest son, Martin, is sent to the Cimzes teachers' seminar in Valka. In addition, the younger son’s Miķelis “mind isn’t interested in the works of the countryside”, so the parents decide to send him to study to be a “schoolmaster”.</p>
                  </div>
                  <div style="width:30%;">
                    <img src="../assets/bildes/19.jpg" alt>
                    <p
                      class="annotation p-10"
                    >Krogzemji residence – Alojas Krogzemju (Krogzemnieku) water mill at the turn of 19th/20th century. It has burned down several times, nowadays only fragments of stone walls, barrage and millstones have remained</p>
                  </div>
                  <div style="width:25%">
                    <p class="text f20 justify">
                      After finishing the teachers' seminar, the two brothers work as teachers, work in journalism and actively engage in Latvian social life of Vidzeme, later of Russia. The younger brother Miķelis, known as the poet Auseklis, becomes one of the fundamentals of Latvian romantic poetry and the voices of the ideas of the awakening. Several of his poetry rows, reflecting the ideas of Young Latvians, have today gained symbolic meaning and folklorized.
                      <br>
                      <br>After the deaths of his parents, Andrejs Krogzemis, the third brother of Auseklis, led the Sīpoli homestead. He, like all the Krogzemji, looked as a Liv, hard-working and frugal, bought out his father's home. His son, Pēteris Krogzemis, had studied agronomy, farmed in Sīpoli until the 1940s.
                    </p>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png">
                    </div>
                  </div>
                </div>
              </a>
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:5%;">
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png">
                    </div>
                  </div>
                  <div style="width:28.333%" class="p-10 pt0 pb0">
                    <img
                      src="../assets/bildes/23.jpg"
                      style="height:320px; width:auto"
                      class="m-auto"
                      alt
                    >
                    <p
                      class="annotation"
                    >The mother of the poet Auseklis (Miķelis Krogzemis) in 1935, in the Sīpoli family home</p>
                  </div>
                  <div style="width:28.333%" class="p-10 pt0 pb0">
                    <img
                      src="../assets/bildes/3.png"
                      class="m-auto"
                      style="height:320px; width:auto"
                      alt
                    >
                    <p
                      class="annotation"
                    >The course 10 of the students at the Valka Teacher Seminar, chaired by Jāņa Cimzes. 1868-1871. In the 2nd row, 5th from left - Auseklis (Miķelis Krogzemis). Photographer unknown. RMM</p>
                  </div>
                  <div style="width:28.333%" class="p-10 pt0 pb0">
                    <img
                      src="../assets/bildes/25.jpg"
                      style="height:320px; width:auto"
                      class="m-auto"
                      alt
                    >
                    <p
                      class="annotation p-10"
                    >A portrait of the poet Auseklis in his St. Petersburg-issued Selected works (Izlasīti raksti)</p>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png">
                    </div>
                  </div>
                </div>
              </a>
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:5%;">
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png">
                    </div>
                  </div>
                  <div style="width:11%">
                    <img
                      src="../assets/bildes/28.png"
                      class="m-auto"
                      style="height:320px; width:auto"
                      alt
                    >
                    <p class="annotation p-10 pt0">Monument to Auseklis in Aloja</p>
                  </div>
                  <div style="width:26%">
                    <p
                      class="text f18 justify"
                    >Auseklis (Miķelis Krogzemis, 1850–1879) the son of the farmer of the Sīpoli home of the Ungurpils parish, studied at the Cimze teachers' seminar (1868-1871). After finishing, along with the teacher's work, he works in journalism, he writes poetry under the pseudonym Auseklis. In his publications he criticises German nobility and the pastors, emphasises the Latvian language, folklore and traditions. While working in the Lielvārde parish school, participates in the gathering of folk songs, the first General Latvian Song Celebration, stages a theatrical performance. For that, Pastor Krons dismissed Auseklis from his work: “I might have tolerated Miķelis Krogzemis, but the poet Auseklis, who desires to stage theatres, is a disgrace and an unwanted indecency for me and my parish.” Unable to find a job in his home country, in 1874 Auseklis moves to St. Petersburg, where in 1879 the 29-year-old dies prematurely. The transfer of his remains to the homeland is a grand national manifestation, as his works are known and beloved by the people.</p>
                  </div>
                  <div style="width:8%">
                    <img src="../assets/bildes/29.jpg" alt>
                    <img src="../assets/bildes/30.jpg" alt style="margin-top:3px !important">
                  </div>
                  <div style="width:40%">
                    <p
                      class="text justify f18"
                    >In the 1920s Ausekli's biographer, Jānis Lapiņš writes: “His poetry is one great idea of the Latvian national awakening. When thinking of the fate of his own nation, the otherwise cheerful Krogzemis, is grim and solemn. A spirit of patriotism and freedom flows into Ausekli's publications: Latvia (Latvijā), Tālava trumpeter (Tālavas taurētājs), The singer of Bevarīna (Beverīnas Dziedātājs) and others. Whereas his Palace of Light (Gaismas pils) has become one of the symbols of the awakening of the Latvian people.</p>
                    <p
                      class="annotation pt0 mt0 pb0 mb0"
                    >Ausekils poem In Latvia (Latvijā) in the book Auseklis by Līgotņu Jēkabs. Riga, 1927</p>
                    <div class="dzejolis" style="line-height:1.2">
                      <h1>Latvijā</h1>

                      <div style="display:inline-block; width:50%;" class="f18">
                        Latvijas kalnājos, Latvijas lejās
                        <br>Krūtīs man atdzīvo brīvības gars;
                        <br>Raugu tur vīrus kā ozolus zeļam,
                        <br>Meitas kā liepas kuplojam.
                        <br>
                        <br>
                      </div>
                      <div style="display:inline-block; width:50%" class="f18">
                        Daugavas māmuļa, mīlīga jauka,
                        <br>Sirsnīgi glaužas pie Latvijas krūts;
                        <br>Dedzīgi viņa caur klintaini laužas,
                        <br>Tautiešu censībās modrina.
                        <br>
                        <br>
                      </div>
                      <div style="display:inline-block; width:50%" class="f18">
                        Dzirdu še burtnieku sirmajās dziesmas,
                        <br>Dievkoku paēnās audzētas.
                        <br>Krūtis tās pilda ar debesu jūsmām,
                        <br>Garu līdz dievībai pacilā
                        <br>
                        <br>
                      </div>
                      <div style="display:inline-block; width:50%" class="f18">
                        Līga man apveltī dziesmotiem pušķiem,
                        <br>Sēdina ozolu krēsliņā,
                        <br>Trimpus man mielo ar putošu alu,
                        <br>Ūziņš ar Dravdāvas dzērienu.
                        <br>
                        <br>
                      </div>
                    </div>
                  </div>
                  <div style="width:5%;">
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png">
                    </div>
                  </div>
                </div>
              </a>
              <a>
                <div style="display:flex;justify-content:space-around;width:100%;">
                  <div style="width:5%;">
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png">
                    </div>
                  </div>
                  <div style="width:35%">
                    <div class="dzejolis">
                      <h1>JŪRA</h1>
                      <div style="margin-left:100px !important; position:relative">
                        <img
                          style="position:absolute;top:-5px;left:-30px;"
                          src="../assets/zimes/citats-before.png"
                        >
                        Darbs ir latvju krietnais tikums,
                        <br>Pamats katrai svētībai;
                      </div>

                      <div style="margin-left:300px !important; position:relative">
                        Darbs ir viņu lepnais likums,
                        <br>Pamats dārgai brīvībai.
                        <img
                          src="../assets/zimes/citats-after.png"
                          style="position:absolute;bottom:-10px;right:70px;"
                        >
                      </div>

                      <h1>DZIESMU MĀMUĻA</h1>

                      <div style="margin-left:100px !important; position:relative">
                        <img
                          style="position:absolute;top:-5px;left:-30px;"
                          src="../assets/zimes/citats-before.png"
                        >
                        Dar man, tēvis, pastaliņas,
                        <br>Pirc man staltu cepurīt
                      </div>

                      <div style="margin-left:300px !important; position:relative">
                        Šuv man svārkus māmuliņa
                        <br>Skolā ieti man gribas!
                        <img
                          src="../assets/zimes/citats-after.png"
                          style="position:absolute;bottom:-10px;right:70px;"
                        >
                      </div>
                    </div>
                    <div style="border-top:3px solid #000; width:40%; margin-top:30px !important">
                      <p class="annotation tal">Fragmenti no Ausekļa dzejas</p>
                    </div>
                  </div>
                  <div style="width:30%">
                    <img src="../assets/bildes/33.jpg" alt>
                    <p
                      class="annotation p-10"
                    >The pupils of the primary school in Sīpoli in the early 20th century. In the middle, Auseklis brother and the teacher, Mārtiņš Krogzemis. In the second row, first from left, his brother's son, Pēteris Krogzemis</p>
                  </div>
                  <div style="width:25%">
                    <p
                      class="text f20 justify"
                    >Mārtiņš Krogzemis (1841-1929) son of the farmer of the Sīpoli home of the Ungurpils (Alojas) parish, the elder brother of the poet Auseklis. Trained as a teacher at the Chimze teacher’s seminar (1859-1862), Mārtiņš Krogzemis works as an adjunct teacher at the Zeltiņi parish school in Valka district and later as a home teacher at the Brente manor. From 1868 he continued working in Russia in Voronezh (1868-1877) and St. Petersburg (1880-?), where he engages in the public life of Latvian intelligence and participates in the Latvian reading society. He writes poetry and is a correspondent of the German newspaper St. Petersburg Herold. The literary work of teacher Mārtiņš Krogzemis results in the book Zur Fragen zur Ethischen Erziehung in der Schule (1914).</p>
                  </div>
                  <div style="width:3%;">
                    <div class="hor-next"></div>
                  </div>
                </div>
              </a>
            </slick2>
          </div>
        </div>
      </div>
    </div>
    <!--Tautas tradīcijas -->
    <div class="slide bg-1" v-if="this.current == 5  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>THE ROAD OF THE AWAKENING
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1863.png" style="float:right;" class="h-100" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            FORMATION OF SHARED TRADITIONS
            <hr style="width:38.5%">
          </h1>
          <div class="col-4">
            <div class="col-outer">
              <h2>Choir singing</h2>
              <div class="col-bg">
                <slick151 :options="slickOptions1" ref="slick">
                  <a>
                    <div class="slide">
                      <img src="../assets/bildes/34.jpg" style="width:90%" class="m-auto" alt>
                      <p
                        class="annotation p-10"
                      >The chorus of Dikļi men, founded in 1864, conductor Heinrich (Indriķis) Schmidt. One of the first General Latvian Song Celebrations in 1873. Riga</p>
                      <p
                        class="text f18"
                      >Meetings of the Unity of the Brethren congregations with shared singing promotes choir singing in Latvian society, especially in Vidzeme. The first traditions of Latvian choirs are born there, which take root and spread throughout the territory of Latvia in the 19th century. The researcher of Vidzeme Unity of the Brethren, historian Gvido Straube writes:</p>
                      <p
                        class="citats f18"
                      >In 1742/1743 the Vidzeme visitation came to the opinion that the peasants' singing skills had improved rapidly and that they were not shouting, as in the 17th century in his sermon book noted Georgs Manceliss, but were singing in tune, and could even prepare multi-voiced chants. Also one of Latvian music pioneers, Jānis Cimze, is closely associated with this movement, as well as Georg or otherwise Juris Neikens who laid the foundations for the Latvian joint singing phenomenon, which today is admired around the world.</p>
                      <div class="bottom-arrow" style="margin-top: -20px !important;">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>

                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <div style="display:block">
                        <img style="width:90%" class="m-auto" src="../assets/bildes/38-39.png" alt>
                      </div>

                      <div style="display:inline-block;width:50%; vertical-align:top">
                        <p
                          class="annotation p-10"
                        >Jānis Cimze (1814-1881) musician, teacher, head of Vidzeme Congregational School Teacher Seminar.</p>
                      </div>
                      <div style="display:inline-block;width:50%; vertical-align:top">
                        <p
                          class="annotation p-10"
                        >The first volume of Song Adornment (Dziesmu rota) issued in Leipzig in 1872. It includes arrangements of Latvian folk lyrics for choirs and 19th century German composer and folk songs.</p>
                      </div>

                      <p
                        class="text f18"
                      >Jānis Cimze teaches students Latvian, German, choir management, organ, piano and violin. The second-course student of the seminar, K. Rinkužs, recalls that in 1843 a chorus and its members are established “… encouraged by their mentor during the summer holiday they travel Latvia. As they were educated in music and singing, at the time wherever they were singing they surprised all listeners by their four-part spiritual and secular songs. These students had been as the first swallows in Latvia, which heralded that together with the seminar a singing spring has come to Latvian people. ”</p>
                      <div class="bottom-arrow" style="margin-top:13px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <div style="width:65%;" class="m-auto">
                        <img src="../assets/bildes/43.jpg" style="width:90%" class="m-auto" alt>
                        <p
                          class="annotation"
                        >Juris Neikens (1826-1868), Dikļi Pastor, teacher and writer</p>
                      </div>
                      <p
                        class="text f16"
                      >Juris Neikens is the initiator and organiser of the first Latvian Song Celebration. In the third Pentecost of 1864, in Dikļi (nov Kocēni district) he brings together six choirs of men from Limbaži, Rūjiena, Mazsalaca, Lielsalaca, Straupe and Dikļi to a joint singing. Later, Juris Neikens remembers:</p>
                      <p
                        class="citats"
                      >On the festival the sun was shining through thin, bright clouds, and the birds' voices were heard in a warm, quiet air. By about eight o'clock, guests already began to arrive, mainly the most remote ones, who had not known for a certain the hour when the songs would begin. The crowd was getting thicker, travelling by foot of riding, until finally a crowd of people had gathered as rarely would have been seen here.</p>
                      <p
                        class="text"
                      >The Day of Song in Dikļi promotes the organisation of the first General Latvian Song Celebration in 1873, Riga.</p>
                      <div class="bottom-arrow"></div>
                    </div>
                  </a>
                </slick151>
              </div>
            </div>
            <div class="col-outer">
              <h2>
                First choirs
                <br>around Turaida
              </h2>
              <div class="col-bg">
                <slick152 :options="slickOptions1">
                  <a>
                    <div style="position:relative">
                      <img src="../assets/bildes/35.jpg" alt>
                      <p
                        class="annotation p-10"
                      >In the evening in Lēdurga at the Maiņkalns (former market place) opposite the church pub, where meetings and rehearsals of the Merķeļa Singing Society take place in the second half of the 19th century</p>
                      <p
                        class="text f18 justify"
                      >The oldest choirs around Turaida were founded in Straupe in 1864 and in Lēdurga in 1871. The Lēdurgas Merķeļa Society consists initially of 22 men, several of them teachers. Seven the so-called “quiet” comrades do not sing in the chorus, but are supporters of the society and the choir. The men's choirs of Straupe and Lēdurga participate in the first General Latvian Song Celebration in Riga in 1873. The two choirs also sign up to participate in the competition, the so-called Choir Wars, and Straupe choir wins the award.</p>
                      <div class="bottom-arrow" style="margin-top:127px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <div>
                        <img
                          style="display:inline-block; width:50%"
                          src="../assets/bildes/40.jpg"
                          alt
                        >
                        <p
                          style="display:inline-block; width:47%; vertical-align:bottom;"
                          class="annotation pal"
                        >Pēteris Bērziņš (1848-1926), first conductor of Sigulda parish choir</p>
                      </div>
                      <p
                        class="text f18"
                      >Pēteris Bērziņš starts working as teacher in 1869. He has worked in several schools of the Vidzeme. At the same time, he also wrote reading textbooks, as well as some works of prose and poetry.</p>
                      <div class="bottom-arrow" style="margin-top:296px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>

                      <img src="../assets/bildes/44.jpg" class="p-10" alt>
                      <p
                        class="annotation"
                      >List of choirs from the second General Latvian Song Celebration, including the name of Sigulda (Ligate) parish choir</p>
                      <p class="text f18">
                        In preparation for the second General Latvian Song Celebration in Riga in 1880, a choir was also established in Turaida parish. Its conductor was Turaida school teacher Tenis Nolle (1832-1913).
                        Tennis Nolle with Turaida choir also participates in the second Latvian Song Celebration in Riga in 1880.
                      </p>
                      <div class="bottom-arrow" style="margin-top:241px !important"></div>
                    </div>
                  </a>
                </slick152>
              </div>
            </div>
            <div class="col-outer">
              <h2>Latvian associations</h2>
              <div class="col-bg">
                <slick153 :options="slickOptions1">
                  <a>
                    <div>
                      <p
                        class="citats pb0"
                      >In the first half of the 19th century, existing schools were expanded and new schools were founded. The number of students and the level of Latvian education grew. It was accompanied by a growing interest in Latvian history, cultural and public activities. In order to meet people's rising interests and needs, various associations, in particular singing, savings, agriculture and fire insurance associations, were founded and became active. They organised libraries, exhibitions, question and answer evenings, concerts, lectures and other events. Latvian education, culture and public works activists grew with associations and schools, a significant part of which was grouped around the Riga Latvian Society and its branches in other cities.”</p>
                      <p class="annotation tar" style="width:70%;float:right">
                        From the publication by Saulvedis Cimermanis the Riga Latvian Society and Latvian ethnography
                        <br>(Riga Latvian Society and Latvian ethnography).
                        <br>Latvijas Vēstnesis, 1999, Nr. 173
                      </p>
                      <div style="clear:both"></div>
                      <div style="margin-top:20px !important">
                        <img src="../assets/bildes/36.jpg" class="m-auto" style="width:60%" alt>
                        <p class="annotation">Logo of the Riga Latvian Society</p>
                      </div>
                      <div class="bottom-arrow" style="margin-top:13px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <p
                        class="text f18 justify"
                      >The first house of the Riga Latvian Society is constructed in 1869, following the project by Jānis Fridrihs Baumanis. In 1908, this building completely burns down. The present house of the society was built based on the project of Eižens Laube and Ernests Pole, consecrated in 1909.</p>
                      <img src="../assets/bildes/41.jpg" class="m-auto" alt>
                      <p
                        class="annotation"
                      >First house of the Latvian Society after 1885 lithography</p>
                      <p
                        class="text f18 justify"
                      >In Vidzeme, in the 1960s till 1970s, associations are founded, in which the educated Latvians organised choir singing. In the beginning, men choirs are founded, later also mixed choirs. One of the first song (later: charity) societies was established in Vecpiebalga in 1869.</p>
                      <div class="bottom-arrow" style="margin-top:37px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <img src="../assets/bildes/45.jpg" class="m-auto" alt>
                      <p
                        class="annotation p-10"
                      >The chorus of the Vecpiebalga Charitable (formerly: Song) Association at the first General Latvian Song celebration in 1873</p>
                      <img src="../assets/bildes/46.jpg" class="m-auto" alt>
                      <p
                        class="annotation p-10"
                      >Jelgavkrogs or the Church tavern - the meeting site of the Sigulda Charitable Association at the turn of the 19th/20th century</p>
                      <div class="bottom-arrow" style="margin-top:-6px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>

                      <p
                        class="text f20"
                      >The first Latvian public associations around Turaida were founded at the end of the 19th century. They organise choir singing, theatre and cultural events. Building new or adapting existing buildings to these activities.</p>

                      <div class="bottom-arrow" style="margin-top:598px !important"></div>
                    </div>
                  </a>
                </slick153>
              </div>
            </div>
            <div class="col-outer">
              <h2>Theatre</h2>
              <div class="col-bg">
                <slick154 :options="slickOptions1">
                  <a>
                    <div>
                      <div style="width:85%" class="m-auto">
                        <img src="../assets/bildes/37.jpg" alt>
                        <p
                          class="annotation"
                        >Poster for the first Latvian theatrical show Bērtulis the Drunk (Žūpu Bērtulis) in Riga. 1868. Theatre Museum of Eduards Smiļģis</p>
                      </div>
                      <p
                        class="text f18"
                      >In 1790, Alexander Johann Stender translates in Latvian play by Ludvig Holberg Jeppe on the Hill (Jeppe på bjerget) by giving the Danish writers work a new title Merriment game from a peasant which looks to turn into a nobleman. Later, this joke play takes the name Bērtulis the drunk and in 1868 becomes the first Latvian theatrical show in Riga.</p>
                      <div class="bottom-arrow" style="margin-top:66px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <img src="../assets/bildes/42_.png" style="width:75%" class="m-auto" alt>
                      <p
                        class="annotation"
                      >Memorial mark for the premiere of the first Latvian-language play Bērtulis the drunk on 2 June 1868 in Riga at the German rifleman society’s gymnasium Turnhalle on the current Kronvalda Boulevard</p>

                      <p
                        class="text f18"
                      >The show is organised by the Latvian Aid Society for the Estonians Suffering from Poverty. It is looking for funds. About half a year later, the Riga Latvian Society was created on the basis of this association.</p>
                      <br>
                      <p
                        class="text f18"
                      >Theatre performances round Turaida started around 1879, when a theatre hall is created on the second floor of Lēdurga Baznīckrogs. Also, a charity association is founded in Sigulda in 1880, hosting theatrical shows twice or three times a year. The first performed plays are Ādolf Alunāns The Elders of Lielpils Parish (Lielpils pagasta vecākie) and Kārlis Kalniņš Hunters (Mednieki). One of the founders and theatre patrons of the Sigulda Charitable Society is Mārtiņš Ertners, the father of Felicita Ertnere the later director of the Daile theatre and movement consultant.</p>
                      <div class="bottom-arrow" style="margin-top:7px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <div>
                        <img src="../assets/bildes/47-48-49.png" alt>
                        <p
                          class="annotation"
                        >Cover and title-page of the 1888 edition of Ādolf Alunān's play at the Sigulda Charitable Society Theatre</p>
                      </div>
                      <p
                        class="text f18"
                      >In Ādolf Alunān's play The Elders of the Lielpils Parish (Lielpils pagasta vecākie) a pre-election battle for the senior post of the parish takes place. One of the candidates is the rich farmer Lielozols. His rival is the idealistic Dr. Briedis, who believes that the parish's elder “… must take care of order and well-being in the parish, he must be a provider and father to all the oppressed and needy. He himself needs be the first to do every good job”. Doctor Briedis wins the election.</p>
                      <div class="bottom-arrow" style="margin-top:152px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div>
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <img
                        style="display:inline-block; width:45%"
                        src="../assets/bildes/50.jpg"
                        alt
                      >
                      <p
                        style="display:inline-block; width:45%; padding-left:5%;"
                        class="annotation tal"
                      >Actress of the Daile theatre and movement consultant Felicita Ertnere and her family home Spriguļi in Sigulda</p>

                      <img src="../assets/bildes/51.jpg" alt>
                      <p
                        class="annotation"
                      >Pēteris Ozoliņš (1864-1938) actor and director of the Riga Latvian Society Theatre, pseudonym Vidridžu Pēteris</p>

                      <p
                        class="text f16"
                      >The place of birth of Pēteris Ozoliņš is located near Turaida in Vidrižu parish. Having acquired a good professional education in Germany in acting and stage direction, at the end of the 19th century and the beginning of the 20th century, he converts the small amateur theatre of the Riga Latvian Society as an extensive, professional theatre of the whole nation. Along with Jēkabs Duburs and Aleksis Mierlauks, he is also one of the most popular Latvian actors.</p>
                      <div class="bottom-arrow" style="margin-top:21px !important"></div>
                    </div>
                  </a>
                </slick154>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Tartu universitāte -->
    <div class="slide bg-3" v-if="this.current == 6  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>THE ROAD OF THE AWAKENING
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1853.png" class="h-100" style="float:right;" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            TARTU (TĒRBATA) UNIVERSITY – PLACE OF BIRTH OF THE YOUNG LATVIAN MOVEMENT
            <hr style="width:75.5%">
          </h1>
          <h2 class="pos-a" style="left:135px; top:120px">
            Latvian student group
            <br>of Tartu
          </h2>

          <div class="pos-a slide-white" style=" width:470px; left:135px; top:176px">
            <p
              class="text justify f20 p-15"
            >The beginnings of the Young Latvian movement are small groups of educated Latvians. One of the first is created in 1853 by the teacher Juris Caunītis in Riga at the textile industry's Tilo factory, at the workers' Sunday school. In 1856, a Latvian student group is be established at University of Tartu - the only university in the Baltic province. At the time there are nine Latvian students at the university, including Krišjānis Valdemārs, Krišjānis Barons and Juris Alunāns – the organisers and managers of the Latvian student group of Tartu. They call their meetings The Latvian evenings. From 10 to 20 young people gather to discuss science, study and topical public-political issues. They call for the waking and educating of their countrymen, tend to their mother tongue, the development of national culture and the freedom from German supremacy. The organizer of The Latvian evenings Krišjānis Barons writes that in the meetings: ".. we discussed and debated the conditions of the Baltic and the lives and conditions of Latvians in particular (..) and we committed ourselves to working as hard as possible for the people, for the benefit of the people, and especially for education and prosperity in the people to multiply."</p>
          </div>
          <div class="pos-a slide-white p-10" style=" width:394px; left:622px; top:176px">
            <img src="../assets/bildes/52.jpg" alt>
            <p class="annotation p-10">University of Tartu (Tērbata) in the 1850s</p>
          </div>

          <div class="pos-a slide-white" style=" width:420px; left:708px; top:535px">
            <p
              class="text justify f18 p-15"
            >The ideas of the student group of Tartu are spread among educated Latvians and are transformed into a popular awakening movement. According to the model of the names of the other European national movements Young Czechs (Mladočeši), Young Germans (Junges Deutschland) and others the members are called Young Latvians. Their contemporary, the author of the novel Times of the Land-Surveyors (Mērnieku laiki) Matīss Kaudzīte, writes: “Who wanted to speak Latvian, among people who knew German, although he himself knew German, he was a Young Latvian.” Among the most eager Young Latvians were Krišjānis Valdemārs, Krišjānis Barons, Fricis Brīvzemnieks, Juris Alunāns, Atis Kronvalds, Miķelis Krogzemis (poet Auseklis), Kaspars Biezbārdis and other prominent people of the National Awakening of the 1850s-1880s.</p>
          </div>
          <div class="pos-a slide-white" style=" width:550px; left:1150px; top:339px">
            <img src="../assets/bildes/53.jpg" alt>
            <p
              class="annotation p-10"
            >Tartu panorama. Lithography of Wilhelm Siegfried Stavenhagen. 1866</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Jaunlatvieši -->
    <div class="slide bg-1" v-if="this.current == 7  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>THE ROAD OF THE AWAKENING
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1856.png" class="h-100" style="float:right;" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            YOUNG LATVIANS AND LATVIAN LANGUAGE
            <hr style="width:36.5%">
          </h1>
          <div class="col-3">
            <div class="col-outer">
              <h2>JURIS ALUNĀNS</h2>
              <div class="col-bg">
                <slick171 :options="slickOptions1" ref="slick">
                  <a>
                    <div class="slide" style>
                      <div style="display:inline-block; width:40%;vertical-align:top;">
                        <img src="../assets/bildes/54.jpg" alt>
                        <p
                          class="annotation p-10"
                        >The cover and title-page of Juris Alunāns 1856 book Songs Translated to Latvian (Dziesmiņas, latviešu valodai pārtulkotas)</p>
                        <p
                          class="text justify f18"
                        >The author Juris Alunāns of the introductory part of the book says: "With this work I wanted to show how nice and strong the Latvian language is."</p>
                      </div>

                      <div style="display:inline-block; width:55%; vertical-align:top; float:right">
                        <p
                          class="text justify f16"
                        >Young Latvians have contributed significantly to the development of Latvian literary language. In particular, Juris Alunāns (1832-1864), who is considered to be the founder of Latvian linguistics. In 1856, the publication of his book Sons Translated to Latvian begins the development of a literary language. Juris Alunāns knows a number of foreign languages, so he can convert the words of other languages. Directly translated from German, he creates a new Latvian word for cotton “kokvilna” (from Baumwolle), for coal “akmeņogles” (from Steinkohle) and others. Several word derivatives formed by Juris Alunāns are first mentioned in The Newspapers of St. Petersburg. Those are: virtuve (kitchen), klausītava (auditorium), zvērnīce (zoo), virsvaldnieks (general governor), rakstniecība (writing skis), zemkopība (agriculture), skābeklis (oxygen) and others. Nowadays, Latvians still use the names of the months of the year that have replaced the oldest names: janvar to janvāris, vevrar to febrāris, merc to marts, apri to aprīlisl, mei to maijs, etc. The ethnonyms he introduced have also remained in place: angļi (English), armēnieši (Armenians) , austrieši (Australians), beļģieši (Belgians), francūži (French), grieķi (Greeks), holandieši (Hollanders), spānieši (Spanish), which changed the previously used words: eņlenderi, armenjeri, eistreiķeri, belgeri, spranči, grieķeri, ollenderi and spānjeri. In total, Juris Alunāns has introduced around 600 new words in the Latvian language</p>
                      </div>
                      <div class="bottom-arrow" style="margin-top:112px !important"></div>
                    </div>
                  </a>
                </slick171>
              </div>
            </div>
            <div class="col-outer">
              <h2>Atis Kronvalds</h2>
              <div class="col-bg">
                <slick172 :options="slickOptions1">
                  <a>
                    <div>
                      <div style="display:inline-block; width:55%; vertical-align:bottom;">
                        <img src="../assets/bildes/55.jpg" alt>
                      </div>
                      <div
                        style="display:inline-block; width:45%; vertical-align:bottom;"
                        class="p-10 pb0"
                      >
                        <p
                          class="annotation tal"
                        >Several decades before the foundation of Latvia in 1869, Atis Kronvalds proposes to put down the country's main basic law – the constitution with the word “satversme”. Pre-publication of the Latvian Constitution in the Governmental Journal (Valdības Vēstnesis) on 1922 June 30</p>
                      </div>
                      <p class="text f16 justify">
                        <br>A public worker, teacher and publicist Atis Kronvalds (1837-1875) also contributed significantly to the development of Latvian literary language. In words and works he shows the importance of the Latvian language: “We have a clear and sacred language, and a thousand years later it is still youthful. It gives a statement about the first cradle of our grandfathers, shows the fun and powerful spirit of the ancient Latvians; it lacks no subtlety, no depth, no wealth, no agility." Atis Kronvalds enriched the Latvian language with at least two hundred new names, of which remains around a hundred. Among them are: aizbildnis (guardian), apstāklis (circumstance), arhitektūra (architecture), atvasināt (derivation), audzēt (cultivate), burtnīca (note book), būtība (essence), cēlonis (cause), cēls (noble), daile (beauty), dzeja (poetry), dzejolis (poem), dzenulis (drive), episks (epic), galotne (apex), gleznot (painting), horizonts (horizon), izglītība (education), izglītot (to educate), izloksne (dialect), jaunatne (youth), kaislība (passion), kautrēties (to feel shy), līdzeklis (means), locījums (fold), luga (play), māksla (art), mūzika (music), nākotne (future), pagātne (past), pilsonis (a citizen), poēzija (poetry), priekšmets (object), raksturs (writer), skolēns (pupil), slimnīca (hospital), varonis (hero), vēstule (letter), vēsture (history), zinātne (science) and others. Words such as daileklis - glezna (painting), dīvatrons - (theatre), gailestība, aizkārtnība - (jealousy), gādeklis - (task), spaidonis - (necessity), klibzaķis - bezrakstura cilvēks (person without a character) have not spread. Atis Kronvalds has cultured the Latvian vocabulary with locale words, including with a few Liv origence words, such as: jauda (power), selga (blanket), apvārsnis (horizon), arods (trade), kautrēties (shyness), josla (band), loma (role), luga (play), veids (type) and others.
                      </p>
                      <div class="bottom-arrow" style="margin-top:122px !important"></div>
                    </div>
                  </a>
                </slick172>
              </div>
            </div>
            <div class="col-outer">
              <h2>KRIŠJĀNIS BARONS</h2>
              <div class="col-bg">
                <slick173 :options="slickOptions1">
                  <a>
                    <p
                      class="text f16 justify"
                    >Folklorist, writer and publicist Krišjānis Barons (1835-1923) made his name immortal in Latvian culture with the Latvian national song collection Latvian Folk Songs (Latvju Dainas) in six volumes (eight books), which came out between 1894 and 1915. He devotes most of his life to make it. Linguist Professor Jānis Endzelīns considers this edition to be the basis on which Latvian filology has been constructed. In his scientific publications Krišjānis Barons has written and introduced foreign words such as: admirālis (admiral), agronoms (agronomist), astronoms (astronomer), atestāts (attestation), biljons (billion), ekvators (equator), elektrība (electricity), elipse (ellipse), famīlija (family), fabrika (factory), gāze (gas), instrukcija (instruction), interese (interest), kafeja (cafey), klavieres (piano), kapteinis (captain), konfiscierēt (to confiscate), kristāls (crystal), mašīna (machine), metāls (metal), mode (fashion), muzikants (musician), pols (pole), procents (percentage), revīzers (fan), sekunde (second), šoseja (highway), uniforma (uniform). Thanks to Krišjānis Barons, the modern Latvian vocabulary also uses such scientific terms as – mathematics, geography, physics, biology and others.</p>
                    <div>
                      <div style="display:inline-block;width:50%; vertical-align:top;" class="p-10">
                        <img src="../assets/bildes/56.jpg" alt>
                      </div>
                      <div style="display:inline-block;width:50%;vertical-align:top" class="p-10">
                        <img src="../assets/bildes/57.jpg" alt>
                        <p
                          class="annotation"
                        >Title-page and excerpt from Krišjānis Barons’s first geography textbook Description Our Fatherland (Mūsu tēvzemes aprakstīšana), issued in 1859 in Jelgava. LNB</p>
                      </div>
                    </div>
                    <div class="bottom-arrow" style="margin-top: 20px !important">
                      <img src="../assets/zimes/bottom.png" class="m-auto">
                    </div>
                  </a>
                  <a>
                    <div class="top-arrow">
                      <img src="../assets/zimes/top.png" class="m-auto">
                    </div>
                    <p class="citats">
                      <span style="text-align:center;display:block">Vidzeme</span>
                      <br>Borders. North Estonian land; in the East the Great Lake Peipus and Pleskava province; south Vitebskas province and Kurzeme province, and in the West the sea.
                      <br>Vidzeme, with its islands (of which Sami Island is the largest with 47 miles) and with its large lakes, it is 880 miles large, with nearly 880 thousand inhabitants, of which:
                      <br>
                      <br>
                      <span style="line-height:1.8">
                        365 thousand are Latvian,
                        <br>410 thousand are Estonians,
                        <br>65 thousand are Germans,
                        <br>20 thousand Russians are in Riga alone,
                        <br>450 Swedes on Ruhnu Island,
                        <br>5 thousand Polish,
                        <br>Rare 1000 Finns and Jews in Riga and Sloka.
                        <br>Strange peoples - strange faiths. Lutherans are 710 thousand. (Here's counted in also the Unity of the Brethren (Herrnhuter) and their apprentices).
                        <br>Russian faiths more than 148 thousand. (Russians, Estonians and Latvians);
                        <br>Catholics are about 4300;
                        <br>Not a lot from the Continental Reformed church;
                        <br>The Jews have one synagogue in Riga.
                        <br>
                      </span>
                    </p>
                    <div class="bottom-arrow" style="margin-top:-3px !important;"></div>
                  </a>
                </slick173>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Jaunlatvieši krievijā -->
    <div class="slide bg-1" v-if="this.current == 8  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>THE ROAD OF THE AWAKENING
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1862.png" class="h-100" style="float:right;" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            YOUNG LATVIANS IN ST. PETERSBURG AND MOSCOW
            <hr style="width:45.5%">
          </h1>
          <div class="col-3">
            <div class="col-outer">
              <h2>
                St. Petersburg – the idealistic centre of the Young Latvians
                <br>in the second half of the 19th century
              </h2>
              <div class="col-bg h-100">
                <div class="slide">
                  <p
                    class="text f18 justify"
                  >In the second half of the 19th century, the idea of the Latvian National Awakening can be more freely expressed outside the sphere of Baltic German influence – in Russia. There are more opportunities for intelligent Latvians to find jobs that match their education. In St. Petersburg work Krišjānis Valdemārs, Krišjānis Barons, Fricis Brīvzemnieks, Miķelis Krogzemis (poet Auseklis), Andrejs Spāģis and other Latvians who are forced to leave their homeland because of their nationalistic ideas. Many Latvian young people are also studying there, the Newspapers of St. Petersburg (Pēterburgas Avīzes) (1862—1865) is being published, the collection Latvian Folk Songs (Latvju Dainas) by Krišjānis Barons is printed and other Latvian publications. The history of the Latvian State anthem God Bless Latvia! (Dievs, svētī Latviju!) is also associated with St. Petersburg, which is written by the Professor of the Smolney Institute of St. Petersburg, Karlis Baumanis for the first General Song Celebration.</p>
                  <div>
                    <div style="display:inline-block;width:55%" class="p-10">
                      <img src="../assets/bildes/58.jpg" alt>
                    </div>
                    <div style="display:inline-block;width:40%; vertical-align:bottom" class="p-10">
                      <p class="annotation tal">
                        St. Petersburg in the 19th century.
                        <br>A view of the sculpture Copper Rider, a replica of Wassili Surikow painting
                      </p>
                    </div>
                  </div>
                  <div>
                    <div style="display:inline-block;width:40%" class="p-10">
                      <p
                        class="annotation tal"
                      >St. Petersburg, Wassili Island, 4 Line 4, House No 5, in which the apartment of Krišjānis Barons was located, and until 1875 the editorial office of Newspapers of St. Petersburg (Pēterburgas Avīzes)</p>
                    </div>
                    <div style="display:inline-block;width:55%" class="p-10">
                      <img src="../assets/bildes/59.jpg" alt>
                    </div>
                  </div>

                  <div class="bottom-arrow" style="margin-top:-5px !important"></div>
                </div>
              </div>
            </div>
            <div class="col-outer">
              <h2>
                Newspapers of St. Petersburg –
                <br>the paper of the Young Latvians
              </h2>
              <div class="col-bg">
                <slick182 :options="slickOptions1">
                  <a>
                    <div class="slide">
                      <img class="m-auto" src="../assets/bildes/112.png" alt>
                      <p
                        class="annotation p-10"
                      >Title-page drawing (1862) by Augusts Daugulis (1830-1899)</p>
                      <p
                        class="text justify f18"
                      >Newspapers of St. Petersburg (Pēterburgas Avīzes) is a press release by Young Latvians, which is issued in St. Petersburg from 1862 to 1865 with the support of Juris Alunāns, Krišjānis Barons and Krišjānis Valdemārs. The newspaper's publications reflect the ideas of the European national movement.</p>
                      <p
                        class="text justify f16"
                      >Several press releases come out in Latvian in the mid-19th century, but they do not satisfy the growing demands of Latvian intelligence. The most active Young Latvians decide to set up a new newspaper on the initiative of Krišjānis Valdemārs. St. Petersburg is chosen as the location of its editorial, because there is greater independence from the censorship of Baltic German nobility. The Newspapers of St. Petersburg comes out only four years (1862-1865), but in this time it is possible to formulate the ideas of The Latvian National Awakening and to promote their introduction The authors of the articles call on farmers to raise their self-awareness and to recognise the importance of their importance. The Newspapers of St. Petersburg also write a lot about the Latvian national issue and independence. In one of the educational articles of Krišjānis Valdemārs the word Latvia was mentioned for the first time in history: “Latvia is between the great Russia, and ,in the light of the number of people, the great Germany…” Such Young Latvian articles, according to Krišjānis Barons were a stab in the “cluster of German wasps”. They also failed to satisfy the Russian authorities, so on June 17, 1865, the newspaper was closed</p>
                      <div class="bottom-arrow" style="margin-top:30px !important">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div class="slide">
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <img class="m-auto" style="width:65%" src="../assets/bildes/114.png" alt>
                      <p
                        class="annotation p-10"
                      >Title-page of Zobugals (1852), annex of the Newspapers of St. Petersburg, drawing by Augusts Daugulis</p>
                      <p
                        class="text f18"
                      >About taverns. An excerpt from The Newspapers of St. Petersburg:</p>
                      <p class="citats justify f16">
                        Sādžas mācītājs un skolmeisteris neliedzas ar daļu ņemt pie alus un vīna glāzes. Ja gaiss
                        lietains jeb auksts, tad iet visi gastuzī iekšā. Un tā tur visi cits caur citu biedrojas, pār
                        visiem valda viens gars. Zināms, nevajaga domāt, ka tur mācītājs un skolmeisters klāt ir, ka tur
                        jau tūlīt ar visiem priekiem pagalam, ka tur tūlīt sāk no Dieva vārdiem runāt. Mācītājs tur ar
                        visiem apietas kā viens cilvēks ar otru, viena pati mīlestības saite sien visus par vienas
                        biedrības locekļiem, kuŗā katrs tīrus, skaidrus cilvēcības priekus bauda.
                        <br>
                        <br>Tā tad, pirmā kārtā redzējām, ka krogi jeb gastūži (tas vienalga) īsti no dabas nevis vien nakts
                        mājas un apmešanās, bet it īpaši biedrošanās vietas ir; un otrā kārtā, ka no krogu un gastūžu
                        būšanas uz visa tā apriņķa miesīgu un garīgu būšanu spriest var. Krogs ir visa pagasta ģīmis. Kas
                        ar šām lietām labi iepazinies, var droši un riktīgi no krogā būšanas uz pagasta mājas būšanu
                        spriest bez kā tam misētos. Bet, saprotams, ka tas jāzina, kā vaļā kroga ieriktēšana stāv, cik
                        brīvības ļaudīm dotas uz viņa pārgrozīšanu uzspiesties…
                      </p>
                      <div class="bottom-arrow">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div class="top-arrow">
                      <img src="../assets/zimes/top.png" class="m-auto">
                    </div>

                    <p class="citats justify f16 p-10">
                      Lai tikai apskatāmies mūsu mazā zemītē. Kur atrod vairāk nešķīstību, dzeršanu un visvisādu negausību?
                      Arvien tur, kur vislielākā nabadzība, kur saimnieks un saimniece ar bēdām apgulstas un uzceļas, kur
                      sāpes, iekšķīgas un ārīgas tā prātu un sirdi sagrauž, ka viņš kā apdullis vairs nesajūt, ka cilvēks
                      esot, tur, kur nekādi prieki, nekādas lustes tam prātu necilā, kur nopūtas un bēdas uz katra soļa
                      gala, kā smags svaru akmins sirdi spiež. Ticīgā prātā gan viņš sauc uz Dievu; gan viņš zina, ka aiz
                      kapa visām bēdām gals būs, bet viņš ar sajūt, ka viņam še virs zemes vajadzētu labi klāties. Tāpēc
                      tas nāk, ka pamācīšanas tikai gluži, gluži reti vien un daudzreiz it neko nepalīdz. Laimība cilvēkam
                      šai pasaulē ir vajadzīga kā ēšana un dzeršana. Tā kā pret ēšanu un dzeršanu nekāds sprediķis
                      nepalīdz, tāpat ar pret laimību. Un ja cilvēks to nevar uz pienākamu vīzi iedabūties, tad viņš to sev
                      ņemas uz nepienākamu vīzi.
                      <br>
                      <br>Ticu, ka šo lasot nevienam prātā nenāks, ka es dzērājus aizbildināt gribējis. Dieva pēc nē! Tikai uz
                      to cītos, lasītājiem dzeršanas sakni rādīt, lai tie uz aplamiem ceļiem nenopūlētos, viņu gribēdami
                      izravēt. Vēl vienreiz jāsaka: darāt cilvēku īsti par cilvēku, tad viņš par lopu nepaliks. Ļaužu
                      vadītāji, dodat saviem audzēkņiem, bez ko tie nevar iztikt, tad tie pie tā neķersies, kas tiem
                      skādīgs. Dodat viņiem citus augstākus priekus, tad viņi paši no sevis, bez visas uzspiešanas šos
                      skādīgos atstās. Darāt viņus par cilvēku biedrības dzīviem locekļiem, tā kā viena asiņu straume caur
                      visām dzīslām iet tā kā tas viena cīnīšanās, viens gala mērķis, viena dzīšanās savieno, - tad vien
                      var ir šie cilvēku biedrības vāji locekļi atkal par veseliem locekļiem un visa miesa vesela palikt.
                    </p>
                    <div class="bottom-arrow" style="margin-top:52px !important">
                      <img src="../assets/zimes/bottom.png" class="m-auto">
                    </div>
                  </a>
                  <a>
                    <div class="top-arrow">
                      <img src="../assets/zimes/top.png" class="m-auto">
                    </div>
                    <div style="width:70%" class="m-auto">
                      <img class="m-auto" src="../assets/bildes/60.jpg" alt>
                      <p
                        class="annotation p-10"
                      >The cover of the 1875 publication of St. Petersburg Latvians The New Horseflies (Jauni dunduri), formed by Augusts Daugulis wood-carving</p>
                    </div>
                    <div class="bottom-arrow" style="margin-top:81px !important"></div>
                  </a>
                </slick182>
              </div>
            </div>
            <div class="col-outer">
              <h2>
                The activities of the Latvian intelligence in Moscow
                <br>in the second half of the 19th century
              </h2>
              <div class="col-bg">
                <slick183 :options="slickOptions1">
                  <a>
                    <div class="slide">
                      <p
                        class="text justify f18"
                      >From the 1870 also in Moscow start to form small societies of Latvian intelligence and students living there. The beginning of the Moscow society is closely linked to the names of the young ideologues Krišjānis Valdemārs and Krišjānis Barons. In 1867, looking for work they arrive in Moscow, bringing Latvian intelligence around themselves. There are meetings and chorus rehearsals in the apartment of Krišjānis Barons. Popular are the so-called Moscow Latvian reading evenings, which take the form of meetings and discussions on Latvian language, literature, history and other issues. Moscow Latvians maintain links with the new Latvians of Tartu, Jelgava and Riga Young Latvians, especially the Riga Latvian Society. In 1878 Krišjānis Valdemārs starts fundraising in the Moscow Latvian Society for the publication of Latvian Folk songs with a 60-ruble donation. To gather, organize and store the folklore material Krišjānis Barons orders a special cabinet with 70 drawers. Each contains 20 compartments designed to accommodate folk songs written on small leaflets. The closet was made in 1880 in Moscow.</p>
                      <div style="width:90%" class="m-auto">
                        <img class="m-auto" src="../assets/bildes/113.png" alt>
                        <p
                          class="annotation p-10"
                        >Moscow in the 19th century. A view of the Stone Bridge and the Kremlin. Reproduction of the painting by Fyodor Alekseyev</p>
                      </div>
                      <div class="bottom-arrow" style="margin-top:5px !important;">
                        <img src="../assets/zimes/bottom.png" class="m-auto">
                      </div>
                    </div>
                  </a>
                  <a>
                    <div class="slide">
                      <div class="top-arrow">
                        <img src="../assets/zimes/top.png" class="m-auto">
                      </div>
                      <img
                        class="m-auto"
                        style="width:70%; height:auto"
                        src="../assets/bildes/61.jpg"
                        alt
                      >
                      <p class="annotation p-10">Krišjānis Barons in Moscow. 1852. RMM</p>
                      <div class="bottom-arrow" style="margin-top:73px !important"></div>
                    </div>
                  </a>
                </slick183>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Jaunlatvieši un atmoda-->
    <div class="slide bg-3" v-if="this.current == 9  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:320px;right:70px;"
        >
        <br>THE ROAD OF THE AWAKENING
      </div>
      <div class="layout-1">
        <div class="side">
          <img src="../assets/zimes/skala-1855.png" class="h-100" style="float:right;" alt>
        </div>
        <div class="content">
          <h1 class="slide-heading">
            Young Latvians and The Awakening
            <hr style="width:35.5%">
          </h1>
          <slick19 :options="slickOptions2">
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-white" style=" width:320px; top:3px;  left:194px;">
                  <img src="../assets/bildes/62.png" alt>
                  <p
                    class="annotation"
                  >Juris Alunāns (1832-1864), one of the Young Latvians, poet, publicist and linguist. In the illustration, between the members of the student corporation of Tartu Fraternitas Academica Dorpatensis (second row, second from right)</p>
                </div>
                <div class="pos-a slide-white" style=" width:362px;top:394px;  left:381px;">
                  <p
                    class="text justify f18 p-10"
                  >Juris Alunāns knows Russian, German, Greek, Latin, French, Hebrew and Lithuanian. He translates into Latvian classical poetry and the poetry of the European National Awakening Movement's workers, as well as is the creator of many new Latvian words. His latvianized poem Not by Being Lazy or Rotting Away (Nevis slinkojot un pūstot) by the Czech poet František Čelakovsk (F. L. Čelakovský, 1799-1852). The poem becomes one of the symbols of the ideas of Latvian spiritual awakening. It was first published in Tartu in 1860 in the journal Homestead, Nature, World (Sēta, Daba, Pasaule) compiled by the Juris Alunāns. Originally, the poem has 3 verses, later a fourth verse is added by Juris Alunāns.</p>

                  <div style="width:80%;border-top:3px solid #000;float:right">
                    <p class="annotation tar">
                      Pāvela Štolls.
                      <br>"No rozes simtlapainās",
                      <br>(Latvijas Vēstnesis,
                      <br>05.05.2005., Nr. 70)
                    </p>
                  </div>
                </div>
                <div class="pos-a slide-white" style=" width:320px; top:160px;  left:770px;">
                  <img src="../assets/bildes/63.jpg" alt>

                  <p
                    class="annotation p-10"
                  >Manuscript of Juris Alunāns poem Midsummer Eve (Jāņu vakars)</p>
                </div>
                <div class="pos-a slide-white" style=" width:580px; top:47px;  left:1116px;">
                  <div>
                    <div style="width:90%; display:inline-block">
                      <img
                        src="../assets/bildes/64.jpg"
                        class="m-auto"
                        style="width:560px; height:auto"
                        alt
                      >

                      <p class="annotation p-10">
                        Alegoric illustration for the poem Not by Being Lazy or Rotting Away
                        <br>(H. Šics, Jelgava, 1873).
                      </p>
                    </div>
                    <div
                      style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:50px !important"
                    >
                      <div class="hor-next">
                        <img src="../assets/zimes/right.png" alt>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-white p-20" style=" width:812px; top:0px;  left:0px;">
                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:135px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>
                  <div style="width:45%; display:inline-block;" class="p-20">
                    <img src="../assets/bildes/65.jpg" alt>
                    <p
                      class="annotation"
                    >The poem Not by Being Lazy or Rotting Away (Nevis slinkojot un pūstot) in original language in the collected works of František Čelakovsk Růže stolistá (Rose of the hundred petals) (Publishing house: Bohumil Haas synové Praha, 1840)</p>
                  </div>
                  <div style="width:45%; display:inline-block;" class="p-20">
                    <p class="citats">
                      Nevis slinkojot un pūstot
                      <br>Tautu labā godā ceļ,
                      <br>Bet pie prāta gaismas kļūstot
                      <br>Tauta zied un tauta zeļ.
                      <br>
                      <br>Ja ikviens tik zemē sētu,
                      <br>Vienu graudu veselu.
                      <br>Kas gan izskaitīt tad spētu
                      <br>Zelta kviešu krājumu?
                      <br>
                      <br>Bet kas lielīdamies pārdod,
                      <br>Ved uz tirgu pelavas,
                      <br>Tas kā pelus vējam ārdot
                      <br>Zūd no ļaužu piemiņas.
                      <br>
                      <br>Augsim lieli, augsim stipri,
                      <br>Būsim sveiki, veseli,
                      <br>Uzdziedāsim, uzdziedāsim
                      <br>Augstu laimi Latvijai!
                      <br>
                    </p>
                    <p
                      class="annotation"
                    >Poem "Nevis slinkojot un pūstot". Translation from Checz to Latvian language by Juris Alunāns</p>
                  </div>
                </div>
                <div class="pos-a slide-white" style=" width:850px;top:133px;  left:830px;">
                  <div style="width:50%; display:inline-block; vertical-align:top" class="p-10">
                    <img src="../assets/bildes/66.jpg" alt>
                    <p
                      class="annotation p-10"
                    >Text of the Heinrich Heine poem Lorelei translated by Juris Alunāns</p>
                    <p
                      class="text f20 justify"
                    >On Juris Alunāns rendering Mācītājs Braše said ironically, that Loreleja would be like the new Latvia on the cliff. This introduces the concept of “Young Latvians”.</p>
                  </div>
                  <div style="width:40%; display:inline-block;" class="p-10">
                    <p class="citats">
                      Es nezinu tiešām kā labad
                      <br>Tik skumīgs esmu tāds!
                      <br>Sev pasaku vecu glabāt,
                      <br>Uz to vien nesas man prāts.
                      <br>Vēss vakars krēslībā sedzies,
                      <br>Un klus` tek Daugava;
                      <br>Tas kalna gals liesmās dedzies,
                      <br>Mirdz saules spožumā.
                      <br>
                      <br>Tur jaunava jo skaista
                      <br>Sēd augšā brīnišķi:
                      <br>Tur zibošā zeltā saista
                      <br>Sev matus zeltainus šī,
                      <br>Tos sukā ar zeltainu ķemmi,
                      <br>Un uzdzied dziesmiņu,
                      <br>Kas brīnišķi skan uz zemi
                      <br>Ar varenu melodiju.
                      <br>
                      <br>Tas laiviniekam laivā iekšā
                      <br>Ar žēlabām sirdi spiež;
                      <br>Viņš neredz, kur klintis priekšā,
                      <br>Viņš acis uz augšu vien griež.
                      <br>Man šķiet, ka tur laiviņā, lejā
                      <br>Nu laivinieks postā vēl ies,
                      <br>Un dziedot Loreleja
                      <br>To darījusi paties`.
                      <br>
                    </p>
                  </div>
                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:50px !important"
                  >
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-white" style=" width:380px; top:0px;  left:0px;">
                  <div>
                    <div
                      style="width:20%; display:inline-block; height:350px; vertical-align:top;margin-top:160px !important"
                    >
                      <div class="hor-prev">
                        <img src="../assets/zimes/left.png" alt>
                      </div>
                    </div>

                    <div style="width:80%;display:inline-block">
                      <img src="../assets/bildes/67.png" style="width:80%" class="m-auto" alt>
                      <p
                        class="annotation p-10"
                      >Krišjānis Valdemārs (1825-1891), one of the initiators of the Young Latvian movement, the publicist, founder of the first Latvian library and the sailing school and has financed the punishing of the Newspapers of St. Petersburg (Pēterburgas Avīzes).</p>
                      <img src="../assets/bildes/68.jpg" style="width:80%" class="m-auto" alt>
                      <p
                        class="annotation p-10"
                      >Krišjānis Barons (1835-1923) at The Cabinet of Folksongs or Dainu skapis, one of the initiators of the Young Latvian movement, literate and librarian. RMM</p>
                    </div>
                  </div>
                </div>
                <div class="pos-a slide-white p-20" style=" width:470px; top:70px;  left:400px;">
                  <img src="../assets/bildes/69.jpg" class="m-auto" alt>
                  <p
                    class="annotation p-10"
                  >Compilers and publishers of the collection of Latvian folk songs known as Latvju Dainas. From the left: Henrijs Visendorfs, Krišjānis Barons and Fricis Brīvzemnieks. 1901. LNB</p>
                  <p class="text f18 justify">
                    The Latvian oral folklore heritage is collected, accumulated and published under the influence of the ideas of the time of the National awakening. In the late 19th century thanks to the Young Latvian gathering work of Krišjānis Valdemārs, Fričis Brīvzemnieks, Ārons Matīssand Krišjānis Barons 1707 Latvian proverbs, 1682 puzzles and around 700 spells are published as well as the 1888 collected works The Songs of our People (Mūsu tautas dziesmas).
                    <br>
                    <br>Krišjānis Barons stores and systemises the original folk song texts from all municipalities in a special cabinet Dainu skapis, which in 1893 stores around 150 000 manuscripts. With the financial support of Latvian trader Henry Visendorf, from 1894 to 1898, the first books of Latvian Folk Songs (Latvju Dainas) are published in Jelgava at Jēkabs Darvnieks’s publishing house. Other poems meant for publishing come out with the support of the Russian Academy of Sciences and are printed in St. Petersburg between 1903 and 1915.
                  </p>
                </div>
                <div class="pos-a slide-white p-20" style=" width:280px; top:167px;  left:888px;">
                  <img src="../assets/bildes/70.png" style="width:100%" class="m-auto" alt>
                  <p
                    class="annotation p-20"
                  >Atis Kronvalds (1837-1875), one of the Young Latvians, educator, linguist, novelist and distinguished orator, who with his speeches inspires listeners at Vidzeme teacher seminars and the first general Latvian Song Celebration</p>
                </div>
                <div class="pos-a slide-white p-10" style=" width:350px; top:253px;  left:1252px;">
                  <div>
                    <img src="../assets/bildes/71.jpg" style="width:95%" class="m-auto" alt>
                    <p
                      class="annotation p-20"
                    >Bookplate dedicated to Atis Kronvalds. Author Zigurds Zuze. RMM</p>
                  </div>
                </div>
                <div
                  style="position:absolute;width:10px;height:350px; vertical-align:top;top:165px; left:1650px"
                >
                  <div class="hor-prev">
                    <img src="../assets/zimes/left.png" alt>
                  </div>
                </div>
              </div>
            </a>
          </slick19>
        </div>
      </div>
    </div>

    <!--Symbols slides -->
    <!-- Dziesmu svētki -->
    <div class="slide bg-4" v-if="this.current == 10  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:415px;right:106px;"
        >
        <br>SYMBOLS OF THE NATIONAL AWAKENING
      </div>
      <div class="layout-2">
        <div class="content">
          <h1 class="slide-heading">
            Song celebration
            <hr style="width:18.5%">
          </h1>
          <slick22 :options="slickOptions2">
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-green" style="top:37px;left:0px;width:389px">
                  <img src="../assets/bildes/85.jpg" alt>
                  <p
                    class="annotation p-10"
                  >XXV General Latvian Song and XV Dance Celebrations in 2013 at the Mežaparks open-air stage in Riga</p>
                  <p
                    class="text f18 p-20 justify"
                  >The Song Celebration tradition in Latvia, created during the first National Awakening, has lasted for nearly 150 years, still confirming the peoples creative strength, identity and the originality of the cultural. XXV General Latvian Song and XV Dance Celebrations in 2013 at the Mežaparks open-air stage in Riga with nearly 40 000 participants, representing more than 1500 different collectives. In 2018, approximately 43 000 participants from 118 Latvian municipalities, as well as from foreign states, participate in the XXVI Song Celebration. For the nine days from 30 June to 8 July, more than 65 events are taking place: concert programmes of choirs, dances, brass orchestras, Latvian national harps (kokle), folk music, vocal ensembles, folklore groups and concerts by other groups. Around 500,000 viewers attend the festival.</p>
                </div>
                <div class="slide-outer pos-a" style="top:64px;left:432px;width:781px">
                  <h2>Background</h2>
                  <div class="slide-green">
                    <div style="display:inline-block;width:60%">
                      <p
                        class="text justify f18"
                      >A characteristic feature of the nationally patriotic movement of 19th century Europe is choir-singing societies, whose events often conclude with a festival of collective singing. These are efforts to use the song's inspiring power to unite the nation into a united country. One of the oldest choir-song festivals is held in 1838 in Germany in Frankfurt (Alt-Frankfurt) near Maina, where the choruses of men from different regions of Germany are present The songs are also accompanied by political demands for national unity, citizens' rights and freedom. The first general German singing festival of 1845 in Vircburg (Würzburg) brings together 1,626 choir singers.</p>
                      <img src="../assets/bildes/86.jpg" style="width:80%" class="m-auto" alt>
                      <p
                        class="annotation p-10"
                      >Postcard - The arrival of singers to the first German song festival in Frankfurt on 28 July 1838</p>
                      <p
                        class="text justify f18"
                      >The singing festival in Germany inspires the German community living in the Baltic, and in 1857 the first song festival Erste Sängerfest in Reval, 1857 takes place in Tallinn (then: Reveal). They include German choirs from all over the Baltic. The next Baltic German Song Celebration (Das Baltische Sängerfest in Riga) takes place in 1861 in Riga and there are also some Latvian groups. The largest participants' activity is in the fourth Baltic Song Celebration in 1880 in Riga, where 34 men's choir associations of more than a thousand singers gather</p>
                    </div>
                    <div style="display:inline-block;width:40%; vertical-align:top">
                      <img src="../assets/bildes/87.jpg" class="m-auto" style="width:80%" alt>
                      <p
                        class="annotation p-10"
                      >Flag of the first general German singing festival. Vircburg (Würzburg). 1845</p>

                      <img src="../assets/bildes/88.jpg" style="width:90%" class="m-auto" alt>
                      <p
                        class="annotation p-10"
                      >The first Baltic Song Celebration: the singers' journey along the Piritas River in Revel, 1857 (Das erste baltische Liederfest zu Reval). Woodcarving.</p>
                    </div>
                  </div>
                </div>

                <div class="pos-a slide-green" style="top:191px;left:1227px;width:477px">
                  <div style="display:inline-block;width:80%">
                    <img src="../assets/bildes/89.jpg" class="m-auto" alt>
                    <p
                      class="annotation p-10"
                    >The first Estonian Song Celebration in 1869 in Tartu. The Song Celebration is dedicated to the remembrance of the abolition of serfdom 50 years ago</p>

                    <p
                      class="text justify p-10"
                    >The Song Celebration, which originated in the German-speaking countries of Western Europe, did not receive such a response as in Latvia, Lithuania and Estonia, where they have remained until now. The Song Celebration of the local population in the Baltic takes place in 1869 in the modern Estonian city of Tartu.</p>
                  </div>
                  <div
                    style="width:15%; display:inline-block; height:350px; vertical-align:top; margin-left:10px !important;margin-top:50px !important"
                  >
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <br>
                <br>
                <h2>
                  The First General Latvian
                  <br>Singing (Song) Celebration
                </h2>
                <div class="pos-a slide-green" style="top:195px;left:17px;width:479px">
                  <div
                    style="width:12%; display:inline-block; height:350px; margin-right:10px !important;vertical-align:top;margin-top:40px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>
                  <div style="display:inline-block;width:85%">
                    <img src="../assets/bildes/90.jpg" class="m-auto" alt>
                    <p
                      class="annotation p-10"
                    >Riga, Palace Square in the mid-19th century. The watercolour of Johan Ludwig von Radecke. LNVM</p>

                    <p
                      class="text justify p-10"
                    >The first general Latvian singing festival took place in Riga in June 1873. Here, on June 26, 27 choirs from Vidzeme, 12 choirs from Kurzeme and Zemgale, as well as 5 Riga choirs arrive In total, 1003 singers arrive in both horse-drawn carts and decorated boats along Aivieksti and Daugava.</p>
                  </div>
                </div>
                <div class="pos-a slide-green" style="top:96px;left:510px;width:560px">
                  <p class="citats justify">
                    On that 26 June the sun jumped as bright, and the sky was clear, so one could hope for a nice time. At 8 a.m., the festive committee gathered at the Society House for reception of guests. The Latvian high school apprentices from the universities of Tartu, St. Petersburg, Moscow and Berlin who had promised their support to the committee for the festival, including the overseers of order appointed by the Committee for the Celebration, all gathered in the building as early as the members of the association. These connected overseers of order were getting red-and-white bands around their shoulder, a sign of their work on holiday days.
                    <br>
                    <br>The first job of the order overseers was to receive the singers from the railway station and to accompany them to the Society House, and then to take them out to their housing. P Watch was not yet 9, when, on all sides, the singers went to the Society House where they put their flags; according to the festival programme and with a sign from the singers they were escorted to the housing.
                  </p>
                  <p
                    class="annotation tar"
                  >Excerpt from the recollections of Song Celebration Action Committee Chief Rihards Tomsons</p>
                </div>
                <div class="slide-outer pos-a" style="top:40px;left:1103px;width:602px">
                  <h2>
                    Opening of the first General Latvian
                    <br>Singing Celebration
                  </h2>
                  <div class="slide-green">
                    <div style="display:inline-block;width:88%">
                      <p class="citats justify">
                        <u>Thursday 26 June 1873</u>
                        <br>The first General Latvian Singing Celebration was revealed on June 26 at the Riga Latvian Society House. The speeches were made by Rihards Tomsons, head of the Action Committee, and architect Jānis Baumanis. Baltic teachers' seminar choir sounded out the Karlis Bauman song God Bless Latvia! for the first time. Rihards Tomsons festival report describes the carrying in of the specially sewn Līgo flag: “First came six young men, honour guards, adorned with red-and-white breast ribbons Then came the nine maids. Then the new festive flag that the chief of the Latvian Society and the two men of the speech carried. Three designated flag carriers came from behind the flag, encircled by white silk breast sashes with golden tassels at the end. From behind them came the flag-handlers nine ladies and finally six guards of honour again”
                      </p>
                      <div style="display:inline-block;width:50%;vertical-align:top;">
                        <img src="../assets/bildes/91_.png" style="width:80%" class="m-auto" alt>
                        <p
                          class="annotation m-auto"
                          style="width:90%"
                        >Entrepreneur, journalist, one of the founders of the Riga Latvian Society Rihards Tomsons (1834-1893)</p>
                      </div>
                      <div style="display:inline-block;width:50%;vertical-align:top;">
                        <img src="../assets/bildes/92_.png" style="width:80%" class="m-auto" alt>
                        <p
                          class="annotation m-auto"
                          style="width:90%"
                        >Architect, one of the founders and leaders of the Riga Latvian Society, Jānis Frīdrihs Baumanis (1834-1891). Reproduction of the portrait painted by Jānis Roze. RVKM</p>
                      </div>
                    </div>

                    <div
                      style="width:12%; display:inline-block; height:350px; vertical-align:top;margin-top:188px !important"
                    >
                      <div class="hor-next" style="margin-left:10px !important;">
                        <img src="../assets/zimes/right.png" alt>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <div class="slide-outer pos-a" style="top:40px;left:17px;width:1062px">
                  <h2>
                    Procession of choirs and concert of
                    <br>the first General Latvian Singing Celebration
                  </h2>

                  <div class="slide-green">
                    <div
                      style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:203px !important"
                    >
                      <div class="hor-prev" style="margin-right:10px !important;">
                        <img src="../assets/zimes/left.png" alt>
                      </div>
                    </div>

                    <div style="display:inline-block;width:90%">
                      <div style="display:inline-block; width:60%">
                        <p class="text justify f20 p-10">
                          <u>Friday, 27 June 1873</u>
                          <br>Choir procession from the Riga Latvian Society house to the venue of the Song Celebration in Ķeizardārzs (now: Viesturdārzs park) as described by the Song Celebration Action Committee Chief Rihards Tomsons:
                        </p>
                        <p
                          class="citats p-10 justify"
                        >The leader and the flag-bearer stood at the front of each chorus, behind them the singers four in a row. Gendarmes rode at the very front; then a war musician passed, then carried the flag of the Latvian Society, which were followed by the chief of the society speaking men and honorary guests. Then came six men and they were carrying a festive flag. Now came the festival committee, then the two festival conductors (Bētiņš un Zīle) and the whole of the singers, with the chorus of Skujene singers at the front. At the very last end, the police men went again. In the middle of this series was a second war musician. – When the festive flags were taken out of the society house, the musician began to play and all other flags were waving. Thousands of people stood on both sides of the street. There were thousands of singers waiting in front of the Ķeizardārzs park The singers, arriving in the park, went to the podium and placed their flags on each side. After a little break-in time, the concert began, as the program had laid out, at 7 p.m.</p>
                        <p
                          class="text justify f20 p-10"
                        >The concert featured songs by Jānis Cimze, Kārlis Baumanis, Jānis Bētiņš and other composers. With a special delight, during the 1873 solstice were received the Songs of Midsumer (Jāņu dziesmas) with the sonorously sung līgo. The concert continued until darkness, when the garden was beautifully illuminated with lanterns and lamps.</p>
                      </div>
                      <div style="display:inline-block; width:40%; vertical-align:bottom">
                        <img src="../assets/bildes/93.jpg" alt>
                        <p
                          class="annotation"
                        >The procession of choirs from the Riga Latvian Society to the venue of the Song Celebration in Ķeizardārzs (now: Viesturdārzs park).</p>

                        <img src="../assets/bildes/94.jpg" style="width:57%" class="m-auto" alt>
                        <p
                          class="annotation"
                        >First publication of the General Latvian Singing Celebration, Riga, 1873</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pos-a slide-outer" style="top:182px;left:1103px;width:612px">
                  <h2>
                    The Choir Wars of the first General
                    <br>Latvian Singing Celebration
                  </h2>
                  <div class="slide-green">
                    <div style="display:inline-block; width:66%">
                      <p class="citats justify p-20">
                        <u>Saturday, 28 June 1873</u>
                        <br>The third day of the Song Celebration was dedicated to the wars of the choirs, with 5 mixed and 10 man choirs participating. The Evaluation Committee consisted of Kārlis Baumanis from the Action Committee, from Kurzeme choirs the conductors Jānis Bētiņš and Teodors Veidemanis, from Vidzeme choirs – Jānis Cimze and Indriķis Zīle. Each chorus had to sing two songs. Around 11 in the evening, the winners were announced at the Riga Latvian Society House during a farewell dinner:
                        <br>
                        <br>“One larger flagpole top (silver lyre) was obtained by Mazsalaca men's choir.
                        One smaller flagpole top (silver lyre) was obtained by Cēsis mixed choir.
                        A silver goblet, given to the festival committee from a Latvian group in Riga, was obtained by a choir of Trikata men's choir.
                        Silk ribbon with a silver buckle was obtained by Straupe men's choir.
                        The silver flag token was obtained by Koknese mixed choir and Silk ribbon with a silver buckle was obtained by Beverina mixed choir”.
                      </p>
                    </div>

                    <div style="display:inline-block; width:22%; vertical-align:top">
                      <img src="../assets/bildes/95_.png" alt>
                      <p
                        class="annotation"
                      >The assessment of the Latvian 1 General Singing Celebration Committee and one of the awards – silver lyre</p>
                    </div>
                    <div
                      style="width:12%; display:inline-block; height:350px; vertical-align:top;margin-top:45px !important"
                    >
                      <div class="hor-next" style="margin-left:10px !important;">
                        <img src="../assets/zimes/right.png" alt>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <br>
                <br>
                <h2>Chief conductors</h2>
                <div class="pos-a slide-green" style="top:287px;left:17px;width:468px">
                  <div
                    style="width:15%; display:inline-block; height:300px; vertical-align:top;margin-top:0px !important"
                  >
                    <div class="hor-prev" style="height:300px; margin-right:10px !important">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>

                  <div style="display:inline-block;width:85%">
                    <img src="../assets/bildes/96.jpg" alt>
                    <p
                      class="annotation"
                    >The first General Latvian Singing Celebration in Ķeizardārzs (now: Viesturdārzs park)</p>
                    <p
                      class="text justify f18"
                    >The first General Latvian Singing Celebration's secular music concerts and song wars take place in a specially designed open-air stage. The General coir is made up of 1003 singers and dominated by the men's voices. Chief conductors are Jānis Bētiņš of Kurzeme and Indriķis Zīle of Vidzeme</p>
                  </div>
                </div>
                <div class="pos-a slide-green" style="top:15px;left:507px;width:588px">
                  <div class style="display:inline-block; width:45%">
                    <img src="../assets/bildes/97_png.png" style="width:80%" class="m-auto" alt>
                    <p
                      class="annotation"
                    >Jānis Bētiņš (1830-1912), teacher, conductor, organist, organ constructor and organizer of Kurzeme Latvian music in the second half of the 19th century. His contribution to the development of Kurzeme music is valued in the same way as the activities of Jānis Cimze during the Latvian First Awakening in Vidzeme</p>
                    <img src="../assets/bildes/98_.png" style="width:65%" class="m-auto" alt>
                    <p
                      class="annotation"
                    >Next to the graves is Ērģelnieki, the last home of Jānis Bētiņš (now Gaismas) and his last place of work Sātu church. In 1978, a memorial stone was revealed at the former teachers' seminar building and on 8 June 1986, a monument formed by the sculptor Olita Nigule and architect Teodors Nigulis.</p>
                  </div>
                  <div class="p-10" style="display:inline-block; width:55%; vertical-align:top">
                    <p
                      class="text justify f18"
                    >Jānis Bētiņš has studied music at the Irlavas Teacher Seminar, where his educator is the seminar’s director and the organist Kārlis Sadovskis, as well as the violin instructor V. Denkevics. In 1848,Jānis Bētiņš leaves the Irlavas Teacher Seminar and goes to add to his musical knowledge in Jelgavu to Rūdolfs Postelis at the time, a famous organist and music theorist. But in 1849 he returns to the seminar as a music teacher and works in Irlavā until 1883. During that time, he sets up and runs a mixed chorus, in 1870 attending the first Kurzeme Song Celebration which he himself organised in Dobele. Irlavas choir under the leadership of conductor Jānis Bētiņš also participates in the first General Latvian Song Celebration in Riga in 1873, where with 101 singers they were one of the largest collectives. Jānis Bētiņš had also been the organist of Irlava parish Sāta congregation (1860-1905), as well as participated in organ building near Tukums.</p>
                    <br>
                    <br>
                    <img src="../assets/bildes/99.jpg" style="width:70%" class="m-auto" alt>
                    <p
                      class="annotation"
                    >Church and organ of the Sāti, on which for nearly fifty years played the founder of the by Kurzeme Latvian music tradition Jānis Bētiņš</p>
                  </div>
                </div>
                <div class="pos-a slide-green" style="top:15px;left:1116px;width:588px">
                  <div style="display:inline-block;width:80%">
                    <div style="display:inline-block;width:50%; vertical-align:top">
                      <img src="../assets/bildes/100_.png" style="width:90%" class="m-auto" alt>
                      <p
                        class="annotation"
                      >Indriķis Zīle (1841-1919), teacher, conductor, organist, composer, student of Jānis Cimze and the continuator of his work. He is one of the initiators of the tradition of the Latvian Song Celebration, the chief conductor of the first three Latvian General Song Celebration</p>
                    </div>
                    <div style="display:inline-block;width:50%">
                      <img
                        src="../assets/bildes/101_.png"
                        class="m-auto"
                        style="width:100%;padding-top:250px;"
                        alt
                      >
                      <p
                        class="annotation"
                      >A relief dedicated to the chief conductor of the first General Latvian Song Celebration Indriķis Zīle, located in the musician's homeland at the Aloja museum. Sculptor Kārlis Baumanis</p>
                    </div>
                    <img src="../assets/bildes/102_.png" style="width:90%" class="m-auto" alt>
                    <p
                      class="annotation"
                    >The chief conductor’s wand of the first General Latvian Song Celebration, gifted to Indriķis Zīle</p>
                  </div>
                  <div
                    style="width:15%; display:inline-block; height:350px; vertical-align:top;margin-top:259px !important"
                  >
                    <div class="hor-next" style="margin-left:10px !important">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <br>
                <br>
                <h2>Members</h2>
                <div class="pos-a slide-green" style="top:287px;left:17px;width:409px">
                  <div
                    style="width:20%; display:inline-block; height:350px; vertical-align:top;margin-top:0px !important"
                  >
                    <div class="hor-prev" style="height:343px">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>

                  <div style="display:inline-block;width:80%">
                    <hr>
                    <hr>
                    <p class="text f18 p-10 justify">
                      To the first General Latvian Song Celebration choirs arrive from Vidzeme, Kurzeme and Riga
                      <br>
                      <br>At the first General Latvian Song Celebration, the first original Latvian choir songs and the arrangements of folk tunes came out. In the inaugural act, Baumaņu Kārlis song God Bless Latvia! was sung for the first time at the Latvian Society House, which became the national anthem of Latvia in 1920.
                    </p>
                  </div>
                </div>
                <div class="pos-a slide-green" style="top:0px;left:443px;width:1262px">
                  <div style="display:inline-block;width:90%">
                    <img src="../assets/bildes/karte.png" style="width:100%" class="m-auto" alt>
                  </div>

                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:300px !important"
                  >
                    <div class="hor-next" style="margin-left:10px !important">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-green" style="top:51px;left:17px;width:532px">
                  <div
                    style="width:15%; display:inline-block; height:350px; vertical-align:top;margin-top:241px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>

                  <div style="display:inline-block;width:80%">
                    <img src="../assets/bildes/110.jpg" style="width:70%" class="m-auto" alt>
                    <p class="annotation">Unesco logo</p>
                    <p
                      class="text justify f18 p-20"
                    >The first General Latvian Song Celebration in 1873 is the climax of the Latvian national awakening. Preparations for Song Celebration encourage the musically educated Latvians to compose folk song arrangements and original songs. In all the municipalities of Vidzeme and Kurzeme the choirs become more active for learning festival repertoire. Song Celebration becomes a celebration of the whole nation, creates a huge emotional and spiritual elevation among Latvians and shows other nations the beauty and strength of the folk songs. They establish the Latvian Song Celebration tradition with an unchanged procedure, the main ingredients of which are the song procession, the concert of the general choir and the Choir Wars. Song Celebration, widespread throughout Europe in the 19th century today remains only in Latvia, Estonia and Lithuania, where it has become a rally of the people. In Latvia, the Song Celebration takes place regularly every five years. Valuing the resilience of this tradition, in 2003 the Song Celebration is included in the UNESCO Lists of Intangible Cultural Heritage as a Masterpiece of the Oral and Intangible Heritage of Humanity.</p>
                  </div>
                  <div
                    style="width:5%; display:inline-block; height:350px; vertical-align:top;margin-top:241px !important"
                  >
                    <div class="hor-next"></div>
                  </div>
                </div>
              </div>
            </a>
          </slick22>
        </div>
      </div>
    </div>

    <!-- Himmna -->
    <div class="slide bg-4" v-if="this.current == 11  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:415px;right:106px;"
        >
        <br>SYMBOLS OF THE NATIONAL AWAKENING
      </div>
      <div class="layout-2">
        <div class="content">
          <h1 class="slide-heading">
            HYMN
            <hr style="width:8.5%">
          </h1>
          <div class="col-3 h-100">
            <div class="col-outer">
              <h2>History</h2>
              <div class="slide-green h-100 p-20">
                <p
                  class="text f18 justify p-20"
                >The emergence of the modern is linked to the traditions of choir singing of the first National Awakening in the mid-19th century. It was originally written as a chorus for men. At the time, a country or administrative territory such as Latvia does not yet exist, so the original text of the song, which began with the words God Bless Latvia! is prohibited by censorship. Instead, the verses God Bless the Baltic! are used. At first the lyrics and notes are printed in two editions in 1874 in St. Petersburg. The first is the songbook Līgo, which is confiscated by the Baltic Province government and ordered to be publicly burned in Riga by the River Daugava. Only three songbook have preserved, which are now a bibliographic rarity. The second songbook is Austra. Despite the ban of the censorship, the song God Bless Latvia! delights Latvians and is sung in all the municipalities. It is called a prayer of the Latvian people, but the playwright and director Ādolfs Alunāns is the first to call it the Latvian national anthem.</p>
                <div style="text-align:center">
                  <img style="width:90%" class="m-auto" src="../assets/bildes/82.jpg" alt>
                  <p
                    class="annotation p-20"
                  >An insight into the songbook Līgo issued in St. Petersburg in 1874, in which the song God Bless the Baltics (Dievs, svētī Baltiju!) is printed among others by Baumaņu Kārlis</p>
                </div>
                <div class="bottom-arrow" style="margin-top:-10px !important"></div>
              </div>
            </div>
            <div class="col-outer">
              <h2>Author</h2>
              <div class="slide-green h-100 p-20">
                <div style="text-align:center">
                  <img style="width:70%" class="m-auto" src="../assets/bildes/83.jpg" alt>
                  <p
                    class="annotation p-10"
                  >Postage stamp dedicated to the Latvian anthem author Kārlis Baumanis (1835-1905) issued on 21 May 2005</p>
                  <p
                    class="text f18 p-20 justify"
                  >The author of the words and text of the Latvian people's prayer Dievs, svētī Latviju! is the teacher, poet and composer Kārlis Baumanis (1835-1905). While staying in St. Petersburg Kārlis Baumanis joins the Latvian Reading Society in 1862 and works in the editorial of The Newspapers of St. Petersburg. Having improved his composition and his piano skills in the late 1860s he writes 36 Latvian folk-songs and choir songs, including God bless Latvia! Later, in 1874, they were published in the songbook Austra and Līgo.</p>
                </div>
                <div class="bottom-arrow" style="margin-top:53px !important"></div>
              </div>
            </div>
            <div class="col-outer">
              <h2>Hymn and the Song Celebration</h2>
              <div class="slide-green h-100 p-20">
                <div style="text-align:center">
                  <img class="m-auto" src="../assets/bildes/84.jpg" alt>
                  <p
                    class="annotation p-20"
                  >Text and notes of the Latvian anthem on the memorial of Kārlis Baumanis in Riga, Viesturdārzās park where the first General Latvian Song Celebration took place Author of the memorial is sculptor Bruno Strautiņš</p>
                  <p
                    class="text f18 p-20 justify"
                  >Three of the chorus songs composed in St. Petersburg, Karlis Bauman sends to the first General Latvian Song Celebration organisation committee. The song of Fatherland and the Daugava fishermen song is included in the repertoire of the general choir, but the song God, Bless Latvia! is banned by censorship. However, it is sung out in the opening event of the Song Celebration at the Riga Latvian Society House Hall on 23 June 1873. The song is performed by a chorus of men from the Baltic teachers' seminar under the leadership of conductor Jānis Dreiberģis. At the third Song Celebration in 1888, it is played by a symphony orchestra, and in 1895 the song already gains the status of an unofficial Latvian national anthem. By the decree of the Latvian Constitution of 4 June 1920, Karlis Bauman's song God bless Latvia! (Dievs, svētī Latviju!) becomes the national anthem of Latvia.</p>
                </div>
                <div class="bottom-arrow" style="margin-top:24px !important"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tautas dziemas -->
    <div class="slide bg-4" v-if="this.current == 12  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:415px;right:106px;"
        >
        <br>SYMBOLS OF THE NATIONAL AWAKENING
      </div>
      <div class="layout-2">
        <div class="content">
          <h1 class="slide-heading">
            Latvian folk songs and The Cabinet of Folksongs (Dainu skapis)
            <hr style="width:40.5%">
          </h1>
          <slick23 :options="slickOptions2">
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-green" style=" width:846px; top:0px; left:0px;">
                  <div>
                    <div
                      style="display:inline-block;  width:55%; vertical-align:bottom"
                      class="p-10"
                    >
                      <img src="../assets/bildes/105.jpg" alt>
                    </div>
                    <div
                      style="display:inline-block;  width:35%; vertical-align:baseline; border-left:5px solid #333"
                      class="p-10 dzejolis"
                    >
                      Divi vien, divi vien,
                      <br>Kas miedziņa negulēja:
                      <br>Ūdens miega negulēja,
                      <br>Saule gaisu tecēdama.
                      <br>
                    </div>
                  </div>
                  <div>
                    <div style="display:inline-block; width:10%"></div>
                    <div
                      style="display:inline-block;  width:55%; vertical-align:bottom"
                      class="p-10"
                    >
                      <img src="../assets/bildes/106.jpg" alt>
                    </div>
                    <div
                      style="display:inline-block;  width:35%; vertical-align:baseline; border-left:5px solid #333"
                      class="p-10 dzejolis"
                    >
                      Sudradots gailis dzied
                      <br>Zeltupītes maliņā,
                      <br>Lai cēlās tās meitiņas,
                      <br>Sudraba vērpējiņas
                      <br>
                    </div>
                  </div>
                  <p
                    class="annotation"
                  >The lyrics of the folk songs in handwriting and their transcription. Recorded in the Kalsnava parish of Cēsis district (sent in by K. Mieriņš) and in Dūre in Vārmes parish (sent in by F. Simanovičs). Handwriting is stored in the cabinet of folk songs at the National Library of Latvia</p>
                </div>

                <div class="pos-a slide-green p-20" style="width:340px; left:264px; top:384px;">
                  <p
                    class="text justify f20"
                  >Latvian folk songs – archaic oral poetry reflecting the character of the nation, traditions, rituals, habits, history events. Their content, their form, and the means of expression show the age of the texts. There are also Latvian folk songs made based on European lyrics or liro-epic ballads, but the most ancient ones are considered to be the story-less four verse poems.</p>
                </div>
                <div class="pos-a slide-green p-20" style="width:484px; left:624px; top:415px;">
                  <img src="../assets/bildes/107.jpg" style="width:90%" class="m-auto" alt>
                  <p
                    class="annotation"
                  >Painting Dievs, Laima, Māra by Jēkabs Bīns (1931), symbolically depicting the deities mentioned in Latvian folk songs. Latvian folk songs reflecting the creation of the world</p>
                </div>
                <div class="pos-a slide-green p-20" style="width:297px; left:1127px; top:707px;">
                  <p class="dzejolis" style="text-align:left;">
                    Dieviņš kannu sadauzīja
                    <br>Pa vienam gabalam,
                    <br>Mīļā Māra sastīpoja
                    <br>Ar sudraba stīpiņām.
                    <br>
                  </p>
                </div>
                <div class="pos-a slide-green p-20" style="width:500px; left:1127px; top:150px;">
                  <div style="display:inline-block;width:87%">
                    <p class="dzejolis m-auto" style="padding:20px;text-align:center">
                      Kas varēja to darīt
                      <br>Vidū jūras kaudzi mest?
                      <br>To darīja Dieva dēls,
                      <br>Saules meitu precēdams
                      <br>
                    </p>
                    <div
                      style="border-bottom:4px solid #333; width:30%;margin-bottom:5px"
                      class="m-auto"
                    ></div>
                    <br>
                    <p
                      class="text justify f20"
                    >The most ancient Latvian folk songs reveal the understanding of ancestors about the creation of the world, the structure of the universe and the glow of the sky. In the world, they are used as a major source of research for the archaic mythical and cosmogonic notions of indo Europeans. The universe in Latvian view is a golden pot – a container or a room. The fragments or sequins of the dish is intended as the starry sky. On the other hand, the creation of the world, like the myths of many other nations, involves water, the sea, or the primordial ocean, in the middle of which is located land (a pile in the middle of the sea).</p>
                  </div>
                  <div
                    style="width:13%; display:inline-block; height:350px; vertical-align:top;margin-top:50px !important"
                  >
                    <div class="hor-next" style="margin-left:5px !important">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <div class="pos-a slide-green p-20" style="width:615px; left:0px; top:166px;">
                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:50px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>

                  <div style="display:inline-block;width:90%">
                    <img src="../assets/bildes/108.jpg" style="width:90%" class="m-auto p-10" alt>
                    <img src="../assets/bildes/109.jpg" style="width:90%" class="m-auto p-10" alt>
                    <p class="annotation">The Cabinet of Folksongs (Dainu skapis)</p>
                  </div>
                </div>
                <div class="pos-a slide-green p-20" style="width:449px; left:626px; top:97px;">
                  <p
                    class="text justify f18"
                  >The Cabinet of Folksongs (Dainu skapis) created after the concept of Krišjānis Barons (1835-1923) compiler and editor of Latvian Folk Songs (Latvju Dainas) in Moscow in 1880. It contains 70 drawers with 20 sections in which Krišjānis Barons systemised and inserted folk song manuscripts from all the territory of Latvia. The drawers are marked with the Latvian Folk Songs (Latvju Dainas) type and edition volume numbers. In addition, there are three larger drawers containing other valuable and important documents – the letters written to K. Barons, the beginning of his folk song word index lyrics and a few small objects.</p>
                </div>
                <div class="pos-a slide-green p-20" style="width:449px; left:626px; top:450px;">
                  <img src="../assets/bildes/110.jpg" style="width:70%" class="m-auto" alt>
                  <p class="annotation">Unesco logo</p>
                  <p
                    class="text justify f18"
                  >Valueing the uniqueness of these folklore texts and the link with the still living Latvian intangible cultural traditions today, in 2001 The Cabinet of Folksongs (Dainu skapis) was included in the UNESCO international register Memory of the World. To make its content available to the public around the world, a virtual version, of The Cabinet of Folksongs (Dainu skapis) was created in 2006: www.dainuskapis.lv</p>
                </div>
                <div
                  class="pos-a slide-green"
                  style="padding:40px !important;width:579px; left:1128px; top:208px;"
                >
                  <div style="display:inline-block;width:90%">
                    <img src="../assets/bildes/111.jpg" style="width:100%" class="m-auto" alt>
                    <p class="dzejolis p-20" style="text-align:center;">
                      Sukā, māte, man galviņu,
                      <br>Pin līdzenus man matiņus,
                      <br>Lai mūžiņš līdzināts
                      <br>Pie tautieša tēva dēla.
                      <br>
                    </p>
                    <div
                      style="border-bottom:4px solid #333; width:30%; margin-bottom:5px"
                      class="m-auto"
                    ></div>
                    <br>
                    <p
                      class="annotation"
                    >One of the fifteen folk songs written down in Turaida, stored in The Cabinet of Folksongs (Dainu skapis). Manuscript and its transcription. Written down and sent in by Alaunu Reinis</p>
                  </div>
                  <div style="width:10%; display:inline-block; height:350px; vertical-align:top;">
                    <div class="hor-prev" style="height:100%"></div>
                  </div>
                </div>
              </div>
            </a>
          </slick23>
        </div>
      </div>
    </div>

    <!-- Karogs -->
    <div class="slide bg-4" v-if="this.current == 13  && this.language == 2">
      <div
        class="virs"
        style="color:#333;font-weight:bold;position:absolute;bottom:25px; font-size:25px;text-transform:uppercase; right:40px;"
      >
        <hr
          style="height:6px; background-color:#333; position:absolute;bottom:30px;width:415px;right:106px;"
        >
        <br>SYMBOLS OF THE NATIONAL AWAKENING
      </div>
      <div class="layout-2">
        <div class="content">
          <h1 class="slide-heading">
            THE FLAG
            <hr style="width:14.5%">
          </h1>
          <slick21 :options="slickOptions2">
            <a>
              <div class="absolute-hor-slide">
                <h2>History</h2>
                <div class="pos-a slide-green p-20" style=" width:542px; top:60px; left:0px;">
                  <p
                    class="text f18 justify"
                  >The first information on the origin of today's Latvian flag is written in the Livonian Rhymed Chronicle at the end of the 13th century. In its fragment, the mentioned member of the Order is the Land Marshal of Livonian Order Gerhard from Kacenelnbogene, who led the combined troops of the Crusaders and the Autīne Letts (Latgalians) against the Semigallians in 1279. The Latgalian warriors carried a red-and-white flag as a sign of identification.</p>
                  <br>
                  <div>
                    <div style="display:inline-block; width:40%; vertical-align:top" class="p-10">
                      <img src="../assets/bildes/72.jpg" alt>
                    </div>
                    <div style="display:inline-block; width:60%; vertical-align:top" class="p-10">
                      <p class="citats">
                        No Cēsīm Rīgā atnācis
                        <br>bij brālis kāds un atvedis
                        <br>simts zemessargu sevim līdz,
                        <br>lai zemgaļus tie sakaut līdz.
                        <br>To dzirdējuši nāca nu
                        <br>
                        <span class="red">
                          ar karogu tie sarkanu,
                          <br>kam vidū balta josla bija.
                        </span>
                        <br>To pirmo reizi ieraudzīja
                        <br>pie Cēsīm, tur tas zināms nācis
                        <br>un letu zemē plīvot sācis...
                        <br>
                      </p>
                    </div>
                    <p
                      class="annotation"
                    >A handwritten excerpt of Livonian Rhymed Chronicle with a message about the red-and-white flag. 1290–1296</p>
                  </div>
                </div>
                <div class="pos-a slide-green" style=" width:542px; top:633px; left:0px;">
                  <p
                    class="text justify f18 p-10"
                  >Jēkabs Lautenbahs-Jūsmiņš Tartu University lecturer in the mid-19th century 1 draws students' attention to the flag of the Letts (Latgallians) described in the Livonian Rhymed Chronicle. The University of Tartu student corporation Lettonia uses its red-and-white colours for the first time as symbolism for Latvians. A little later, the poet Auseklis in his 1879 poem Palace of Light (Gaismas pils) acknowledges in writing the legendary Latgalian Flag as the symbol of the Latvian First Awakening.</p>
                </div>
                <div class="pos-a slide-green" style=" width:235px; top:0px; left:570px;">
                  <img src="../assets/bildes/73_.png" class="m-auto" style="width:90%" alt>
                  <p class="annotation p-10">
                    Auseklis (Miķelis Krogzemis)
                    <br>(1850–1879)
                  </p>
                </div>
                <div class="pos-a slide-green" style=" width:235px; top:400px; left:570px;">
                  <img src="../assets/bildes/74_png.png" class="m-auto" style="width:90%" alt>
                  <p
                    class="annotation p-10"
                  >Jēkabs Lautenbahs-Jūsmiņš (1847-1928), theology faculty student at the University of Tartu (1875-1878), later a – lecturer in Latvian language at the University of Tartu Faculty of History and philosophy. 1890. RMM</p>
                </div>
                <div class="pos-a slide-green" style=" width:312px; top:0px; left:830px;">
                  <p class="dzejolis p-20 f14" style="line-height:1.2">
                    <span style="font-weight:bold">GAISMAS PILS</span>
                    <br>
                    <br>Kurzemīte, Dievzemīte,
                    <br>Brīvas tautas auklētāj.
                    <br>Kur palika sirmie dievi?
                    <br>Brīvie tautas dēliņi?
                    <br>
                    <br>Tie līgoja vecos laikos
                    <br>Gaismas kalna galotnē.
                    <br>Visapkārt egļu meži,
                    <br>Vidū gaiša tautas pils.
                    <br>
                    <br>Zelta stabiem, zītar - jumtu,
                    <br>Sidrabotiem pamatiem.
                    <br>To negāza gaisa vētras,
                    <br>Kara viļņu bangojums.
                    <br>
                    <br>Asiņainas dienas ausa
                    <br>Tēvu zemes ielejā;
                    <br>Vergu valgā tauta nāca,
                    <br>Nāvē krita varoņi.
                    <br>
                    <br>Ātri grima, ātri zuda
                    <br>Gaismas kalna staltā pils.
                    <br>Tur guļ mūsu tēvu dievi!
                    <br>Tautas gara greznumi.
                    <br>
                    <br>Sirmajami ozolami
                    <br>Pēdīgajo ziedu dod:
                    <br>Tas slēpj svētu piles vārdu
                    <br>Dziļās siržu rētiņās.
                    <br>
                    <br>Ja kas vārdu uzminētu,
                    <br>Augšām celtos vecā pils!
                    <br>Tālu laistu tautas slavu,
                    <br>Gaismas starus margodam.
                    <br>
                    <br>

                    <span class="red">
                      Zilā gaisā plivinātos
                      <br>Sarkanbalti karogi,
                    </span>
                    <br>Dobji, dobji atskanētu
                    <br>Sirmo garu daiņojums.
                    <br>
                    <br>Tautas dēli uzminēja
                    <br>Sen aizmirstu svētumu:
                    <br>Gaismu sauca, gaisma ausa,
                    <br>Augšām cēlās Gaismas pils!
                    <br>
                    <br>
                  </p>
                </div>
                <div class="pos-a slide-green" style=" width:538px; top:0px; left:1160px;">
                  <div style="display:inline-block;width:85%">
                    <img src="../assets/bildes/75.jpg" alt>
                    <p
                      class="annotation p-20"
                    >The allegoric painting Battle of Saule by Voldemārs Vimba. 1930. The Battle of Saule in1936 depicts warriors with the red-and-white flag mentioned in the legend and the Livonian Rhymed Chronicle</p>
                    <p
                      class="text justify f18 p-10"
                    >Several legends have been written about the history of Latvia's red-and-white flag. One of them tells: “In ancient times Latvians fought with the invaders – the Knights for their freedom. In one battle the Latvians won the enemy's white flag, but in the same battle the Latvian chief was also wounded. The Latvian had placed the white flag on the ground and placed the injured leader on it. He called all the warriors around him and asked that the warriors promise to fight until the enemy has been expelled and the land is free. Everyone had promised so. K When the chief had died, his comrades had lifted him from a flag that had been quite red from blood, the only white place remaining was where the body of the wounded had been For the leader's death, the sad and angry Latvians have attached the blood-stained flag to a spear, fought and driven off the enemy. This had been the Latvian flag”.</p>
                  </div>
                  <div
                    style="width:15%; display:inline-block; height:350px; vertical-align:top;margin-top:225px !important"
                  >
                    <div class="hor-next" style="margin-left:10px !important">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <h2>
                  Red-and-white flag
                  <br>and the Song Celebration
                </h2>
                <div class="pos-a slide-green p-20" style=" width:561px; top:60px; left:0px;">
                  <div
                    style="width:15%; display:inline-block; height:350px; vertical-align:top;margin-top:114px !important; margin-right:15px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>
                  <div style="display:inline-block;width:80%">
                    <div>
                      <img src="../assets/bildes/76.jpg" alt>

                      <p
                        class="annotation p-20"
                      >Flag of the First General Latvian Song Celebration at XXV Latvian Song Celebration procession in Riga on 7 July 2013</p>
                    </div>
                    <p
                      class="text f18 justify"
                    >The First General Latvian Song Celebration Symbol – Flag – is also presented in shades of red and white. In turn, students from Tartu University, who perform the duties of policemen, as an identification wear red-and-white bands traditional for their corporation. More broadly, though, the red-and-white flag isn't yet in use.</p>
                  </div>
                </div>
                <div class="pos-a slide-green p-20" style=" width:355px; top:0px; left:673px;">
                  <img src="../assets/bildes/77_.png" alt>
                  <p
                    class="annotation p-20"
                  >The flag of the first General Latvian Song Celebration Līgo was sewn in a workshop of royal court flags in Leipzig. RVKM</p>
                </div>
                <div class="pos-a slide-green p-20" style=" width:680px; top:222px; left:1065px;">
                  <div style="width:80%; display:inline-block;">
                    <p
                      class="citats p-10"
                    >The flag is on the front of a white silk, encased with a wide read silk velvet. There are gold ornaments on the velvet, and gold bouquets at the bottom tassels. There is a picture embroidered in silk threads in the middle of the flag, showing a sacred grove and a mossy altar decorated with a full leaf wreath under a large and old oak. On the altar a sacrificial flame and smoke waves upward. There is an old priest leaning on the left hand against the altar holding a thick branch of oak in his raised right hand. Above the flag Līgo is sewn in golden letters on red velvet: June 26, 1873. The other side of the flag is red silk</p>
                    <div style="float:right;width:50%; border-top:3px solid #000">
                      <p
                        class="annotation p-10 tar"
                      >From the descriptions of Action Committee chief of the Latvian Song Calibration Rihard Tomson</p>
                    </div>
                  </div>
                  <div
                    style="width:10%; display:inline-block; height:150px; vertical-align:top;margin-top:0px !important; margin-left:10px !important"
                  >
                    <div class="hor-next">
                      <img src="../assets/zimes/right.png" alt>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a>
              <div class="absolute-hor-slide">
                <h2>
                  Red-and-white flag –
                  <br>symbol of the Latvian State
                </h2>
                <div class="pos-a slide-green p-20" style=" width:565px; top:70px; left:0px;">
                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:133px !important"
                  >
                    <div class="hor-prev">
                      <img src="../assets/zimes/left.png" alt>
                    </div>
                  </div>
                  <div style="display:inline-block; width:90%">
                    <img src="../assets/bildes/78_.png" style="width:90%" class="m-auto" alt>
                    <p
                      class="annotation p-10 pt0"
                    >The first preserved red-and-white flag, made in the second half of 1916 after the sketch of a teacher and Jānis Lapiņš by his student the teacher of the Valmiera refugee shelter Marianna Straumane</p>
                    <p
                      class="text f18 justify p-10"
                    >The red-and-white colour symbolism used during the first Latvia National Awakening of is widely used later in 1917 for the flags of Latvian rifleman battalions. The first known red-and-white flag, sewn in 1916, is currently stored in the Cēsis Museum of History and the Arts. The corner is decorated by a sun which is the bases for the Latvian rifleman badge, hence, it is also embroidered on the flag.</p>

                    <img style="width:70%;" class="m-auto" src="../assets/bildes/79.jpg" alt>

                    <p
                      class="annotation pt0"
                    >Latvian rifleman red-and-white flag with colour ratio 2:1:2 and patriotic inscription: We go to avenge the moans of the ancestors and conclude the unfinished battles! Reserve soldiers of Latvian rifleman regiment in Strenči on 1 May 1917. LKM</p>
                  </div>
                </div>

                <div class="pos-a slide-green p-20" style=" width:382px; top:80px; left:680px;">
                  <p
                    class="text f20 justify"
                  >With the establishment of a state, Latvia's political activities are linked to red-and-white colouring as national symbolism. t is used in 1917 when drawing up flag-standard proposals. Of the two flags sent in, the offer of the artist Ansis Cīrlis and Voldemārs Tone is selected which includes the proportion of red-and-white colour corresponding to the modern flag (2:1:2), but the carmine-red tone has not yet been determined. The current National Theatre Hall is decorated with such a flag at the Latvian State Proclamation event on 18 November 1918 in Riga. Law at the Constitutional Meeting of 15 June 1921 officially recognises the flag of the Republic of Latvia.</p>
                </div>
                <div class="pos-a slide-green p-20" style=" width:465px; top:540px; left:587px;">
                  <img src="../assets/bildes/80.jpg" style="width:95%" class="m-auto" alt>
                  <p
                    class="annotation p-18"
                  >Hall decorated with red-and-white flags during the Proclamation Act of the Republic of Latvia on 18 November 1918. Vilis Rīdzenieks photo, LNVM</p>
                </div>
                <div class="pos-a slide-green p-20" style=" width:572px; top:0px; left:1123px;">
                  <div style="display:inline-block; width:90%">
                    <div>
                      <div style="display:inline-block;width:40%">
                        <img src="../assets/bildes/81.jpg" class="m-auto" alt>
                      </div>
                      <div style="display:inline-block;width:60%">
                        <p
                          class="annotation p-10 tal"
                        >Marģers Skujenieks Chairman of the Constitutional Committee (1886–1941)</p>
                      </div>
                    </div>
                    <p
                      class="text f20 justify"
                    >Marģera Skujenieka speech excerpt from the verbatim of the Latvian Constitution meeting of 15 June 1921:</p>
                    <p
                      class="citats justify"
                    >The national flag is set to be red with a white stripe, to the extent that each red stripe is twice the average white stripe. This flag has already been established for us, it is in use, and in such a way this law on the flag only lays down what has already been really introduced. This flag has been introduced quite happily, because it already had historic authority, because some chronicle writer has retold the case from the 13th century, where the Latvian military regiments had travelled towards Riga and carried a flag, that has been red with a white streak, and the writer told that indeed I can claim that the flag is the flag of Latvians. As for the flag, we have a certain classic witness; it determines what our flag should be. In addition, the freedom fights and wars were fought under this red-white red flag and for that reason I considered it was the most acceptable thing to keep the flag already in place.</p>
                  </div>
                  <div
                    style="width:10%; display:inline-block; height:350px; vertical-align:top;margin-top:239px !important"
                  >
                    <div class="hor-prev"></div>
                  </div>
                </div>
              </div>
            </a>
          </slick21>
        </div>
      </div>
    </div>

    <Menu/>

    <div style="display:none">
      <img src="../assets/zimes/josla-lv.png">
      <img src="../assets/zimes/josla-en.png">
      <img src="../assets/bildes/fons/1bilde_uzlabots.jpg">
      <img src="../assets/bildes/fons/main-menu-back.jpg">
      <img src="../assets/bildes/fons/fons2.jpg">
      <img src="../assets/bildes/fons/2attels_uzlabots.jpg">
      <img src="../assets/bildes/fons/fons4.jpg">
      <img src="../assets/bildes/fons/dzimtas.jpg">
      <img src="../assets/bildes/fons/4__attels_uzlabota.jpg">
      <img src="../assets/bildes/1.png">
      <img src="../assets/bildes/10.png">
      <img src="../assets/bildes/100_.png">
      <img src="../assets/bildes/101_.png">
      <img src="../assets/bildes/102_.png">
      <img src="../assets/bildes/103.jpg">
      <img src="../assets/bildes/104.jpg">
      <img src="../assets/bildes/105.jpg">
      <img src="../assets/bildes/106.jpg">
      <img src="../assets/bildes/107.jpg">
      <img src="../assets/bildes/108.jpg">
      <img src="../assets/bildes/109.jpg">
      <img src="../assets/bildes/11.png">
      <img src="../assets/bildes/110.jpg">
      <img src="../assets/bildes/111.jpg">
      <img src="../assets/bildes/112.png">
      <img src="../assets/bildes/113.png">
      <img src="../assets/bildes/114.png">
      <img src="../assets/bildes/12.jpg">
      <img src="../assets/bildes/BILDE3.jpg">
      <img src="../assets/bildes/13.png">
      <img src="../assets/bildes/14.png">
      <img src="../assets/bildes/15.jpg">
      <img src="../assets/bildes/16L.jpg">
      <img src="../assets/bildes/17.jpg">
      <img src="../assets/bildes/18L.jpg">
      <img src="../assets/bildes/19.jpg">
      <img src="../assets/bildes/2.png">
      <img src="../assets/bildes/20.jpg">
      <img src="../assets/bildes/21.jpg">
      <img src="../assets/bildes/22.jpg">
      <img src="../assets/bildes/23.jpg">
      <img src="../assets/bildes/24.jpg">
      <img src="../assets/bildes/25.jpg">
      <img src="../assets/bildes/26.jpg">
      <img src="../assets/bildes/27.jpg">
      <img src="../assets/bildes/28.png">
      <img src="../assets/bildes/29.jpg">
      <img src="../assets/bildes/3.png">
      <img src="../assets/bildes/30.jpg">
      <img src="../assets/bildes/33.jpg">
      <img src="../assets/bildes/34.jpg">
      <img src="../assets/bildes/35.jpg">
      <img src="../assets/bildes/36.jpg">
      <img src="../assets/bildes/37.jpg">
      <img src="../assets/bildes/38-39.png">
      <img src="../assets/bildes/38.jpg">
      <img src="../assets/bildes/39.jpg">
      <img src="../assets/bildes/4.png">
      <img src="../assets/bildes/40.jpg">
      <img src="../assets/bildes/41.jpg">
      <img src="../assets/bildes/42_.png">
      <img src="../assets/bildes/43.jpg">
      <img src="../assets/bildes/44.jpg">
      <img src="../assets/bildes/45.jpg">
      <img src="../assets/bildes/46.jpg">
      <img src="../assets/bildes/47-48-49.png">
      <img src="../assets/bildes/47.jpg">
      <img src="../assets/bildes/48.jpg">
      <img src="../assets/bildes/49.jpg">
      <img src="../assets/bildes/5.png">
      <img src="../assets/bildes/50.jpg">
      <img src="../assets/bildes/51.jpg">
      <img src="../assets/bildes/52.jpg">
      <img src="../assets/bildes/53.jpg">
      <img src="../assets/bildes/54.jpg">
      <img src="../assets/bildes/55.jpg">
      <img src="../assets/bildes/56.jpg">
      <img src="../assets/bildes/57.jpg">
      <img src="../assets/bildes/58.jpg">
      <img src="../assets/bildes/59.jpg">
      <img src="../assets/bildes/6.png">
      <img src="../assets/bildes/60.jpg">
      <img src="../assets/bildes/61.jpg">
      <img src="../assets/bildes/62.jpg">
      <img src="../assets/bildes/62.png">
      <img src="../assets/bildes/63.jpg">
      <img src="../assets/bildes/64.jpg">
      <img src="../assets/bildes/65.jpg">
      <img src="../assets/bildes/66.jpg">
      <img src="../assets/bildes/67.png">
      <img src="../assets/bildes/68.jpg">
      <img src="../assets/bildes/69.jpg">
      <img src="../assets/bildes/7.png">
      <img src="../assets/bildes/70.png">
      <img src="../assets/bildes/71.jpg">
      <img src="../assets/bildes/72.jpg">
      <img src="../assets/bildes/73_.png">
      <img src="../assets/bildes/74_png.png">
      <img src="../assets/bildes/75.jpg">
      <img src="../assets/bildes/76.jpg">
      <img src="../assets/bildes/77_.png">
      <img src="../assets/bildes/78_.png">
      <img src="../assets/bildes/79.jpg">
      <img src="../assets/bildes/8.png">
      <img src="../assets/bildes/80.jpg">
      <img src="../assets/bildes/81.jpg">
      <img src="../assets/bildes/82.jpg">
      <img src="../assets/bildes/83.jpg">
      <img src="../assets/bildes/84.jpg">
      <img src="../assets/bildes/85.jpg">
      <img src="../assets/bildes/86.jpg">
      <img src="../assets/bildes/87.jpg">
      <img src="../assets/bildes/88.jpg">
      <img src="../assets/bildes/89.jpg">
      <img src="../assets/bildes/9.png">
      <img src="../assets/bildes/90.jpg">
      <img src="../assets/bildes/91_.png">
      <img src="../assets/bildes/92_.png">
      <img src="../assets/bildes/93.jpg">
      <img src="../assets/bildes/94.jpg">
      <img src="../assets/bildes/95_.png">
      <img src="../assets/bildes/96.jpg">
      <img src="../assets/bildes/97_png.png">
      <img src="../assets/bildes/98_.png">
      <img src="../assets/bildes/99.jpg">
      <img src="../assets/bildes/karte.png">
    </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Slick from "./Slick.vue";
import Slick2 from "./Slick.vue";

import Slick181 from "./Slick.vue";
import Slick182 from "./Slick.vue";
import Slick183 from "./Slick.vue";

import Slick151 from "./Slick.vue";
import Slick152 from "./Slick.vue";
import Slick153 from "./Slick.vue";
import Slick154 from "./Slick.vue";

import Slick171 from "./Slick.vue";
import Slick172 from "./Slick.vue";
import Slick173 from "./Slick.vue";

import Slick19 from "./Slick.vue";

import Slick21 from "./Slick.vue";
import Slick22 from "./Slick.vue";
import Slick23 from "./Slick.vue";
import carousel from "vue-owl-carousel";

export default {
  name: "home",
  components: {
    Menu,
    carousel,
    Slick,
    Slick2,
    Slick151,
    Slick152,
    Slick153,
    Slick154,
    Slick171,
    Slick172,
    Slick173,
    Slick181,
    Slick182,
    Slick183,
    Slick19,
    Slick21,
    Slick22,
    Slick23
  },
  data: function() {
    return {
      language: 1,
      current: 0,
      max: 15,
      slickOptions1: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        touchThreshold: 50,
        infinite: false,
        arrows: false

        // Any other options that can be got from plugin documentation
      },
      slickOptions2: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        verticalSwiping: false,
        touchThreshold: 50,
        infinite: false,
        arrows: false

        // Any other options that can be got from plugin documentation
      },
      slickOptions3: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        verticalSwiping: false,
        touchThreshold: 50,
        infinite: false,
        arrows: false
        // Any other options that can be got from plugin documentation
      }
    };
  },

  methods: {
    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.Slick.reSlick();
    },
    slide(n) {
      this.current = n;
      this.count();
    },
    count() {
      this.$eventHub.$emit("slide-changed", this.current);
    }
  },

  created() {
    this.$eventHub.$on("next-slide", slide => {
      if (this.current !== this.max - 1) {
        this.current++;
        this.count();
      }
      if (this.current == this.max - 1 || this.current == 10) {
        this.slide(1);
      }
    });
    this.$eventHub.$on("home-slide", slide => {
      this.current = 0;
    });
    this.$eventHub.$on("prev-slide", slide => {
      if (this.current !== 0) {
        this.current--;
        this.count();
      }
      if (this.current == 9) {
        this.slide(1);
      }
    });
    this.$eventHub.$on("slide", slide => {
      this.current = slide;
      this.count();
    });
    this.$eventHub.$on("language", language => {
      this.language = language;
    });
  }
};
</script>


<style lang="scss">
.bottom-arrow {
  border-top: 5px solid #5e5e5e !important;
  width: 70%;

  text-align: center;
  margin: auto !important;
}
.top-arrow {
  border-bottom: 5px solid #5e5e5e;
  width: 70%;
  text-align: center;
  margin: auto !important;
  margin-bottom: 5px !important;
}

.red {
  color: #981e32;
  font-weight: bold;
}
.dzejolis {
  h1 {
    text-transform: uppercase;
    text-decoration: none;
    font-size: 20px;
  }
  font-family: "Century Schoolbook";
  color: #333;
  font-weight: 100;
  line-height: 1.5;
  font-size: 18px;
  div {
    font-weight: 100;
  }
}
.virs {
  font-weight: bold;
}
.m-auto {
  margin: auto !important;
}
.tar {
  text-align: right !important;
}
.tal {
  text-align: left !important;
}
.pb0 {
  padding-bottom: 0 !important;
}
.pt0 {
  padding-top: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}
.mt0 {
  margin-top: 0 !important;
}

.float-right {
  float: right;
}
.b-10 {
  border: 10px solid rgba(254, 254, 254, 0.8);
}
.absolute-hor-slide {
  position: relative;
  width: 100%;
  height: 864px;
}
.slide-green {
  background-color: rgba(197, 218, 179, 0.65);
  padding: 10px;
  p.citats {
    color: #111;
  }
}
.slide-white {
  background-color: rgba(254, 254, 254, 0.6);
  padding: 10px;
}
.h-100 {
  height: 100%;
}
.w-100 {
  width: 100%;
}
.pos-a {
  position: absolute;
}
.pos-r {
  position: relative;
}

.slide {
  height: 100%;
}
//Background image set
.bg-home {
  background: linear-gradient(
      rgba(254, 252, 234, 0.4),
      rgba(254, 252, 234, 0.4)
    ),
    url("../assets/bildes/fons/1bilde_uzlabots.jpg");
  background-size: cover;
}
.bg-menu {
  background: url("../assets/bildes/fons/main-menu-back.jpg");
  background-size: cover;
}

.bg-1 {
  background: url("../assets/bildes/fons/fons2.jpg");
  background-size: cover;
}
.bg-2 {
  background: url("../assets/bildes/fons/2attels_uzlabots.jpg");
  background-size: cover;
}
.bg-3 {
  background: url("../assets/bildes/fons/fons4.jpg");
  background-size: cover;
}
.bg-dzimtas {
  background: url("../assets/bildes/fons/dzimtas.jpg");
  background-size: cover;
}
.bg-4 {
  background: linear-gradient(
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0.1)
    ),
    url("../assets/bildes/fons/4__attels_uzlabota.jpg");
  background-size: cover;
}
//layout
.layout-1 {
  position: relative;
  display: flex;
  height: 100%;
  .side {
    width: 5%;
  }
  .content {
    width: 95%;
    height: 90%;
    padding: 50px;
  }
}
.layout-2 {
  position: relative;
  display: flex;
  height: 100%;
  .content {
    width: 97%;
    margin-left: 3% !important;
    height: 90%;
    padding: 50px;
  }
}

//Text
h1.slide-heading {
  font-family: "Century Schoolbook Bold";

  text-transform: uppercase;
  padding-bottom: 10px;
  color: #444;
  font-size: 28px;
  position: relative;
  hr {
    margin-top: -3px !important;
    height: 5px;
    background: #555;
    border: none;
  }
}
hr {
  border: none;
}

h1 {
  text-transform: uppercase;

  padding-bottom: 10px;
  color: #111;
}
h2 {
  text-transform: uppercase;
  color: #111;
}
p {
  color: #2b2a29;
  backface-visibility: hidden;
  transform: perspective(1px) translateZ(0);
}

.p-10 {
  padding: 10px;
}
.p-15 {
  padding: 15px;
}
.p-20 {
  padding: 20px;
}

.f14 {
  font-size: 14px !important;
}
.f16 {
  font-size: 16px !important;
}

.f18 {
  font-size: 18px;
}

.f19 {
  font-size: 19px !important;
}
.f20 {
  font-size: 20px;
}

.f24 {
  font-size: 24px;
}

.justify {
  text-align: justify;
}

p.text {
  font-weight: normal;
  color: #111;
  font-family: "Almira";
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
p.annotation {
  font-family: "Almira";
  text-align: center;
  margin-bottom: 10px !important;
  font-weight: bold;
}

p.citats {
  font-family: "Century Schoolbook";
  font-size: 17px;
  color: #222;
  font-weight: 200;
  position: relative;

  padding-top: 15px;
  padding-bottom: 15px;
  margin-top: 20px !important;
  margin-bottom: 15px !important;
  &::before {
    content: "";
    position: absolute;
    top: -5px;

    width: 25px;
    height: 20px;
    background: url("../assets/zimes/citats-before.png");
    background-repeat: no-repeat;
  }
  &::after {
    content: "";
    position: absolute;
    width: 25px;
    height: 20px;
    background: url("../assets/zimes/citats-after.png");
    background-repeat: no-repeat;
    bottom: -7px;
    right: 0px;
  }
}

.slick-vertical > .slick-list {
  height: 100% !important;
  .slick-slide {
    height: 900px !important;
  }
}

img {
  max-width: 100%;
  height: auto;
}

.bg {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  margin-top: 20px !important;
}
.col-3 {
  display: inline-bloxk;
  justify-content: space-between;
  height: 100%;
  display: flex;

  .col-outer {
    width: 32%;

    height: 100%;
    overflow: hidden;

    .col-bg {
      background-color: rgba(255, 255, 255, 0.9);
      padding: 20px;
      text-align: justify;
    }
  }
}

.col-4 {
  display: inline-bloxk;
  justify-content: space-between;
  height: 100%;
  display: flex;

  .col-outer {
    width: 24.5%;

    height: 100%;
    overflow: hidden;

    .col-bg {
      background-color: rgba(255, 255, 255, 0.9);
      padding: 20px;
      text-align: justify;
    }
  }
}

.hor-next {
  border-left: 5px solid #5e5e5e;
  position: relative;
  height: 375px;
  img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
.hor-prev {
  border-right: 5px solid #5e5e5e;
  position: relative;
  height: 375px;
  img {
    right: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}

.columns-3 {
  padding-top: 10% !important;
  padding-bottom: 10% !important;
  display: flex;
  height: 100%;
  margin-left: 15% !important;
  margin-right: 5% !important;
  justify-content: space-around;
}
.columns-3 > div {
  width: 30%;
  height: 100%;
  overflow-y: scroll;
  background: rgba(203, 195, 187, 0.8);
}
.rows-2 > div > div {
  height: 100%;
}

.rows-2 {
  padding-top: 10% !important;
  padding-bottom: 10% !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-left: 15% !important;
  margin-right: 5% !important;
  justify-content: space-around;
}

.n-1 {
  background: linear-gradient(
      rgba(254, 252, 234, 0.4),
      rgba(254, 252, 234, 0.4)
    ),
    url("../assets/bildes/fons/fons3.jpg");
  background-size: cover;
}
.home-arrow {
  position: absolute;
  left: 1586.597px;
  top: 418px;
  z-index: 2;
}
.box {
  display: inline-block;
  padding: 45px;
  padding-top: 70px;
  background-color: rgba(203, 195, 187, 0.9);
  position: absolute;
  left: 907.284px;
  top: 560.946px;
  width: 733.215px;
  height: 308.947px;

  h1 {
    font-size: 24px;
    text-transform: uppercase;

    text-align: center;
  }
  p {
    font-size: 24px;
    padding: 20px;
    padding-top: 10px;
    text-align: justify;
  }
}

#nav {
  position: absolute;
  bottom: 20px;
  right: 50%;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
